//#region \0rolldown/runtime.js
var __commonJSMin = (cb, mod) => () => (mod || (cb((mod = { exports: {} }).exports, mod), cb = null), mod.exports);
//#endregion
//#region Library/Library.ts
/**
* @public 
*/
var DelayAsync = async (duration) => {
	await new Promise((resolve) => setTimeout(resolve, duration));
};
var siGridsReadyResolve;
window.siGridsReady = new Promise((resolve) => {
	siGridsReadyResolve = resolve;
});
window.siSignalGridsReady = siGridsReadyResolve;
/**
* @public 
*/
var Hide = (el, id, query, duration = 200) => {
	if (!el && id) el = document.getElementById(id) ?? void 0;
	if (el) {
		DoHide(el, duration);
		return;
	}
	if (query) document.querySelectorAll(query).forEach((ee) => DoHide(ee, duration));
};
var DoHide = (el, duration = 200) => {
	if (!el.classList.contains("si-hidden")) {
		el.classList.add("si-hideable");
		el.style.setProperty("--si-height", el.scrollHeight + "px");
		el.style.setProperty("--si-width", el.scrollWidth + "px");
		el.style.setProperty("--si-duration", duration + "ms");
		const onEnd = (e) => {
			if (e.target !== el) return;
			el.style.display = "none";
			el.removeEventListener("transitionend", onEnd);
		};
		el.addEventListener("transitionend", onEnd);
		requestAnimationFrame(() => {
			el.classList.add("si-hidden");
		});
	}
};
/**
* @public 
*/
var Show = (el, id, query, duration = 200) => {
	if (!el && id) el = document.getElementById(id) ?? void 0;
	if (el) {
		DoShow(el, duration);
		return;
	}
	if (query) document.querySelectorAll(query).forEach((ee) => DoShow(ee, duration));
};
var DoShow = (el, duration = 200) => {
	el.classList.add("si-hideable");
	el.style.display = "";
	el.offsetHeight;
	el.style.removeProperty("--si-height");
	el.style.removeProperty("--si-width");
	el.style.removeProperty("--si-duration");
	requestAnimationFrame(() => {
		el.classList.remove("si-hidden");
	});
};
/**
* @public 
*/
var Toggle = (el, id, query, duration = 200) => {
	if (!el && id) el = document.getElementById(id) ?? void 0;
	if (el) {
		if (IsHidden(el)) DoShow(el, duration);
		else DoHide(el, duration);
		return;
	}
	if (query) document.querySelectorAll(query).forEach((ee) => {
		if (IsHidden(ee)) DoShow(ee, duration);
		else DoHide(ee, duration);
	});
};
/**
* @public 
*/
var IsHidden = (el) => {
	if (el) {
		if (el.classList.contains("si-hidden")) return true;
	}
	return false;
};
/**
* @public 
*/
var ValId = (id) => {
	return document.getElementById(id)?.value;
};
/**
* @public 
*/
var Val = (selector) => {
	return document.querySelector(selector)?.value;
};
//#endregion
//#region Ajax/Ajax.ts
var Qs = (selector) => {
	return document.querySelector(selector);
};
var QsVal = (selector) => {
	return Qs(selector)?.value ?? "";
};
var Headers = () => {
	return {
		"RequestVerificationToken": Qs("input[name=\"__RequestVerificationToken\"]")?.value ?? "",
		"Content-Type": "application/x-www-form-urlencoded"
	};
};
var HeadersJson = () => {
	return {
		"RequestVerificationToken": Qs("input[name=\"__RequestVerificationToken\"]")?.value ?? "",
		"Content-Type": "application/json",
		"Accept": "application/json"
	};
};
var HeadersXhr = () => {
	return { "RequestVerificationToken": Qs("input[name=\"__RequestVerificationToken\"]")?.value ?? "" };
};
var HeadersAppend = (headers, key, value) => {
	headers[key] = value;
	return headers;
};
/**
* @public 
*/
var Ajax = {
	Qs,
	QsVal,
	Headers,
	HeadersJson,
	HeadersXhr,
	HeadersAppend
};
//#endregion
//#region Alert/Alert.ts
/**
* @public 
*/
var Alert = (() => {
	const Show = (title, body) => {
		var alert = document.querySelector("#SI_Alert");
		if (alert) {
			if (title !== null) alert.querySelector(".modal-title").innerHTML = title;
			alert.querySelector(".modal-body").innerHTML = body;
			new bootstrap.Modal(alert).show();
		}
	};
	return { Show };
})();
//#endregion
//#region Attachments/Attachment.ts
/**
* @public 
*/
var Attachment = (() => {
	const _counter = [];
	const _data = {};
	const _groupFiles = [];
	const Init = (id) => {
		if (id === void 0) id = "FileUploadBox";
		Hover(id);
	};
	const AddFormData = (key, value, id) => {
		if (id === void 0) id = "FileUploadBox";
		var extra = document.getElementById(id + "_extra");
		if (extra) {
			var s = String(extra.value ?? "");
			if (s.length > 0) s += ";";
			s += key + "|" + value;
			extra.value = s;
		}
	};
	const InitFileUpload = (uploadUrl, renderFunction, id, customRender = false, dropFn) => {
		if (id === void 0) id = "FileUploadBox";
		if (_counter.find((e) => e.id === id) === void 0) _counter.push({
			id,
			counter: 0
		});
		var counter = _counter.find((e) => e.id === id)?.counter ?? 0;
		var url = uploadUrl ?? _data[id].uploadUrl ?? "";
		var waiting = document.getElementById(id + "_Waiting");
		if (waiting) waiting.classList.add("d-none");
		var box = document.getElementById(id);
		if (box) {
			if (window.File !== void 0 && window.FileReader && window.FileList && window.Blob) {
				box.addEventListener("dragenter", (e) => {
					counter++;
					e.stopPropagation();
					e.preventDefault();
					if (counter === 1) box.classList.add("FileHover");
				});
				box.addEventListener("dragleave", (e) => {
					const related = e.relatedTarget;
					if (related && box.contains(related)) return;
					if (counter > 0) counter--;
					e.stopPropagation();
					e.preventDefault();
					if (counter === 0) box.classList.remove("FileHover");
				});
				box.addEventListener("dragover", (e) => {
					e.stopPropagation();
					e.preventDefault();
					if (!box.classList.contains("FileHover")) {
						counter++;
						if (counter === 1) box.classList.add("FileHover");
					}
				});
				box.addEventListener("drop", async (e) => {
					e.stopPropagation();
					e.preventDefault();
					counter = 0;
					const selectedFiles = e.dataTransfer?.files ?? e.target?.files;
					if (!selectedFiles || selectedFiles.length === 0) return;
					var filenames = "";
					for (var i = 0; i < selectedFiles.length; i++) {
						if (filenames !== "") filenames += "<br />";
						filenames += selectedFiles[i].name;
					}
					const fileText = box.querySelector(".file-text");
					if (fileText) {
						fileText.innerHTML = filenames;
						fileText.classList.add("text-white");
					}
					if (typeof dropFn === "function") dropFn();
					await UploadFileAsync(url, renderFunction, id, selectedFiles, customRender);
				});
				box.addEventListener("dragend", (e) => {
					if (counter > 0) counter--;
					e.stopPropagation();
					e.preventDefault();
					if (counter === 0) box.classList.remove("FileHover");
				});
			} else box.classList.add("d-none");
			var dai = box.closest("[data-attachment-id]");
			dai.querySelector("[data-drop-click]")?.addEventListener("click", () => {
				document.querySelector(".sil_upload_file[data-id=\"" + id + "\"]")?.classList.add("d-none");
				const el = document.querySelector("[data-upload-id=\"" + id + "\"]");
				if (el) new bootstrap.Modal(el).show();
			});
			dai.querySelector("input[type=\"file\"]")?.addEventListener("change", () => {
				document.querySelector(".sil_upload_file[data-id=\"" + id + "\"]")?.classList.remove("d-none");
				if (document.getElementById(id + "_sil").value === "") document.querySelector(".sil_upload_file[data-id=\"" + id + "\"]")?.classList.add("d-none");
			});
			dai.querySelector(".sil_upload_file_cancel")?.addEventListener("click", () => {
				document.getElementById(id + "_sil").value = "";
				const el = document.querySelector("[data-upload-id=\"" + id + "\"]");
				if (el) {
					const modal = bootstrap.Modal.getInstance(el);
					if (modal) modal.hide();
				}
			});
			dai.querySelector(".sil_upload_file")?.addEventListener("click", async (e) => {
				e.stopPropagation();
				const el = document.querySelector("[data-upload-id=\"" + id + "\"]");
				if (el) {
					const modal = bootstrap.Modal.getInstance(el);
					if (modal) modal.hide();
				}
				await UploadFileInputAsync(url, renderFunction, id);
			});
		}
	};
	const UploadFileAsync = async (uploadUrl, renderFunction, id, selectedFiles, customRender) => {
		if (id === void 0) id = "FileUploadBox";
		var newForm = new FormData();
		var extras = String(document.getElementById(id + "_extra").value ?? "")?.split(";");
		for (var i = 0; i < extras.length; i++) {
			var extra = extras[i].split("|");
			newForm.append(extra[0], extra[1]);
		}
		for (var i = 0; i < (selectedFiles?.length ?? 0); i++) newForm.append(selectedFiles[i].name, selectedFiles[i]);
		var data;
		var headers = {
			...Ajax.HeadersXhr(),
			"SilPartial": "1"
		};
		const xhr = new XMLHttpRequest();
		xhr.open("POST", uploadUrl, true);
		xhr.responseType = "json";
		Object.entries(headers).forEach(([key, value]) => {
			xhr.setRequestHeader(key, String(value));
		});
		xhr.upload.addEventListener("progress", (e) => {
			if (e.lengthComputable) {
				const percent = Math.round(e.loaded / e.total * 100);
				const bar = document.querySelector("[data-file-progress=\"" + id + "\"] .progress-bar");
				if (bar) {
					bar.style.width = percent + "%";
					bar.setAttribute("aria-valuenow", percent.toString());
				}
			}
		});
		xhr.onload = async () => {
			if (xhr.status >= 200 && xhr.status < 300) {
				var d = xhr.response;
				if (typeof d === "string" && d !== "") alert(d);
				else if (d.value !== void 0) alert(d.value);
				else data = d;
				if (_data[id] === void 0) _data[id] = { id };
				await RenderSubAsync(_data[id], data);
				if (!customRender) ResetUpload(id);
			} else {
				alert("There was an error uploading files.");
				ResetUpload(id);
				return false;
			}
		};
		xhr.onerror = () => {
			alert("There was an error uploading files.");
			ResetUpload(id);
		};
		xhr.send(newForm);
	};
	const ResetUpload = (id) => {
		document.getElementById(id + "_Waiting")?.classList.add("d-none");
		var o = document.querySelector("[data-file-progress=\"" + id + "\"] .progress-bar");
		if (o) {
			o.style.width = "0%";
			o.setAttribute("aria-valuenow", "0");
		}
		window.setTimeout(() => {
			const fileText = document.querySelector("#" + id + " .file-text");
			fileText.innerHTML = "Drop files here or click to upload.";
			fileText.classList.remove("text-white");
			document.getElementById(id)?.classList.remove("FileHover");
			_counter.find((e) => e.id === id)?.counter;
		}, 400);
	};
	const UploadFileInputAsync = async (uploadUrl, renderFunction, id, customRender = false) => {
		if (id === void 0) id = "FileUploadBox";
		var newForm = new FormData();
		var extras = String(document.getElementById(id + "_extra").value ?? "").split(";");
		for (var i = 0; i < extras.length; i++) {
			var extra = extras[i].split("|");
			newForm.append(extra[0], extra[1]);
		}
		var files = document.getElementById(id + "_sil").files;
		if (!files) return;
		for (var i = 0; i < files.length; i++) newForm.append(files[i].name, files[i]);
		var data;
		var headers = {
			...Ajax.HeadersXhr(),
			"SilPartial": "1"
		};
		const xhr = new XMLHttpRequest();
		xhr.open("POST", uploadUrl, true);
		xhr.responseType = "json";
		Object.entries(headers).forEach(([key, value]) => {
			xhr.setRequestHeader(key, String(value));
		});
		xhr.upload.addEventListener("progress", (e) => {
			if (e.lengthComputable) {
				const percent = Math.round(e.loaded / e.total * 100);
				const bar = document.querySelector("[data-file-progress=\"" + id + "\"] .progress-bar");
				if (bar) {
					bar.style.width = percent + "%";
					bar.setAttribute("aria-valuenow", percent.toString());
				}
			}
		});
		xhr.onload = async () => {
			if (xhr.status >= 200 && xhr.status < 300) {
				var d = xhr.response;
				if (typeof d === "string" && d !== "") alert(d);
				else if (d.value !== void 0) alert(d.value);
				else data = d;
				const sil = document.getElementById(id + "_sil");
				if (sil) sil.value = "";
				if (_data[id] === void 0) _data[id] = { id };
				await RenderSubAsync(_data[id], data);
				if (!customRender) ResetUpload(id);
			} else {
				alert("There was an error uploading files.");
				ResetUpload(id);
				return false;
			}
		};
		xhr.onerror = () => {
			alert("There was an error uploading files.");
			ResetUpload(id);
		};
		xhr.send(newForm);
	};
	const RenderAttachments = (attachments, imagePage, downloadFunction, deleteFunction, id) => {
		if (id === void 0) id = "FileUploadBox";
		var attachmentField = document.getElementById(id);
		var attachmentFieldAttachments = document.getElementById(id + "_Attachments");
		attachmentFieldAttachments.innerHTML = "";
		delete attachmentField.dataset.loaded;
		var readOnly = attachmentFieldAttachments.dataset.readOnly !== void 0;
		var showTime = attachmentFieldAttachments.dataset.showUploadTime !== void 0;
		for (var i = 0; i < attachments.length; i++) {
			var filename = attachments[i].filename;
			var attachmentId = attachments[i].attachmentId;
			if (attachmentId === void 0) attachmentId = encodeURIComponent(filename);
			var attachment = document.createElement("div");
			attachment.dataset.aid = attachmentId;
			attachment.classList.add("Attachment");
			var showPreview = false;
			var preview = document.createElement("div");
			if (attachmentFieldAttachments.dataset.showPreview === "True") {
				var previewButton = document.createElement("a");
				previewButton.classList.add("PreviewImage");
				if (document.querySelector(".Attachments").dataset.hover === void 0) previewButton.classList.add("NoHover");
				var previewImage = document.createElement("img");
				switch (filename.substring(filename.lastIndexOf(".") + 1).toLowerCase()) {
					case "jpg":
					case "jpeg":
					case "bmp":
					case "png":
					case "gif":
						previewImage.src = imagePage + "?aid=" + attachmentId + "&d=" + (/* @__PURE__ */ new Date()).getTime();
						previewButton.addEventListener("click", () => {
							downloadFunction(attachmentId, null);
						});
						showPreview = true;
						previewButton.appendChild(previewImage);
				}
				if (showPreview) {
					preview.classList.add("PreviewImageItem");
					preview.appendChild(previewButton);
					preview.appendChild(document.createElement("br"));
				}
			}
			const downloadLink = document.createElement("a");
			downloadLink.role = "button";
			downloadLink.dataset.download = "";
			downloadLink.dataset.attachmentId = attachmentId.replace("'", "\\'");
			downloadLink.textContent = filename;
			if (showPreview) {
				preview.appendChild(downloadLink);
				attachment.appendChild(preview);
			} else attachment.appendChild(downloadLink);
			if (!readOnly) {
				const deleteButton = document.createElement("a");
				deleteButton.role = "button";
				deleteButton.dataset.delete = "";
				deleteButton.classList.add("DeleteAttachment");
				deleteButton.addEventListener("click", () => {
					return confirm("Do you really wish to delete this attachment?");
				});
				deleteButton.dataset.attachmentId = attachmentId.replace("'", "\\'");
				const deleteIcon = document.createElement("i");
				deleteIcon.classList.add("far", "fa-trash-alt", "fa-lg");
				deleteButton.appendChild(deleteIcon);
				attachment.appendChild(deleteButton);
			}
			if (showTime) {
				var uploadTime = attachments[i].uploadTime;
				if (uploadTime !== void 0) {
					if (uploadTime !== null) {
						const timeOuter = document.createElement("div");
						const small = document.createElement("small");
						small.innerText = uploadTime;
						timeOuter.appendChild(small);
						attachment.appendChild(timeOuter);
					}
				}
			}
			attachmentFieldAttachments.appendChild(attachment);
		}
		document.querySelectorAll("#" + CSS.escape(id) + "_Attachments [data-download]").forEach((el) => {
			el.addEventListener("click", (e) => {
				var attachmentId = e.currentTarget.dataset.attachmentId;
				downloadFunction(attachmentId ?? "", id);
			});
		});
		document.querySelectorAll("#" + CSS.escape(id) + "_Attachments [data-delete]").forEach((el) => {
			el.addEventListener("click", (e) => {
				var attachmentId = e.currentTarget.dataset.attachmentId;
				deleteFunction(attachmentId, id);
			});
		});
		Hover(id);
		attachmentField.dataset.loaded = "";
		attachmentField.dispatchEvent(new Event("loaded"));
	};
	const Hover = (id) => {
		document.querySelectorAll("#" + CSS.escape(id) + "_Attachments[data-hover] a.PreviewImage").forEach((el) => {
			el.addEventListener("mouseenter", (e) => {
				var that = e.currentTarget;
				if (!that.querySelector("span")) {
					var imgHtml = that.innerHTML;
					var img = that.querySelector("img");
					if (img) img.style.opacity = "0.2";
					var span = document.createElement("span");
					span.classList.add("imghover", "si-hideable");
					span.innerHTML = imgHtml;
					var img2 = span.querySelector("img");
					img2.style.opacity = "0";
					that.appendChild(span);
					img2.animate([{ opacity: 0 }, { opacity: 1 }], {
						duration: 200,
						fill: "forwards"
					});
				}
			});
			el.addEventListener("mouseleave", (e) => {
				var that = e.currentTarget;
				var span = that.querySelector("span");
				span.classList.add("si-hidden");
				span.addEventListener("transitionend", () => {
					span.remove();
				}, { once: true });
				that.querySelector("img").style.opacity = "unset";
			});
		});
	};
	const RenderAsync = async (data) => {
		if (data.headers === void 0) data.headers = {
			...Ajax.Headers(),
			"SilPartial": "1"
		};
		if (data.id == void 0) data.id = "FileUploadBox";
		var category = document.getElementById(data.id + "_Attachments")?.dataset.category;
		if (category) data.data.type = category;
		var group = document.getElementById(data.id + "_Attachments")?.dataset.group;
		if (group) data.data.group = group;
		if (data.imagePage === void 0) data.imagePage = "Download";
		_data[data.id] = data;
		if (data.data === void 0) data.data = {};
		else for (var o in data.data) if (data.data[o]) AddFormData(o, data.data[o], data.id);
		InitFileUpload(null, data.renderFunction, data.id, void 0, data.dropFunction);
		if (data.data.group === void 0) {
			if (data.renderUrl !== void 0) await RenderSubAsync(data);
		} else {
			if (!_groupFiles.length || _groupFiles.find((e) => e.group === data.data.group) === void 0) _groupFiles.push({
				group: data.data.group,
				loading: false,
				loaded: false,
				data: {}
			});
			var g = _groupFiles.find((e) => e.group === data.data.group);
			if (g.loaded) RenderSubGroup(data, g);
			else if (!g.loading) {
				g.loading = true;
				await RenderSubAsync(data, null, true);
			}
		}
	};
	const RenderSubGroup = (data, g) => {
		if (g.data.filter !== void 0) {
			var d = g.data.filter((e) => e.type === data.data.type);
			RenderSubRender(data, d);
		} else {
			document.getElementById(data.id + "_Waiting")?.classList.add("d-none");
			var attachmentField = document.getElementById(data.id);
			if (attachmentField) {
				attachmentField.dataset.loaded = "";
				attachmentField.dispatchEvent(new Event("loaded"));
			}
		}
	};
	const RenderSubRender = (data, d) => {
		var attachmentField = document.getElementById(data.id);
		if (attachmentField) {
			delete attachmentField.dataset.loaded;
			if (!data.renderFunction) {
				RenderAttachments(d, data.imagePage, Download, DeleteAsync, data.id);
				document.getElementById(data.id + "_Waiting")?.classList.add("d-none");
				if (data.callBack !== void 0) data.callBack(data);
			} else {
				var attachmentFieldSub = document.getElementById(data.id);
				if (attachmentFieldSub) {
					delete attachmentFieldSub.dataset.loaded;
					data.renderFunction(data.id, data, d, Download, DeleteAsync);
					attachmentFieldSub.dataset.loaded = "";
				}
			}
			attachmentField.dataset.loaded = "";
			attachmentField.dispatchEvent(new Event("loaded"));
		}
	};
	const RenderSubAsync = async (data, renderData, isGroupLoad = false) => {
		document.getElementById(data.id + "_Waiting")?.classList.remove("d-none");
		var savedType;
		if (isGroupLoad) {
			savedType = data.data.type;
			data.data.type = null;
		}
		if (data.renderUrl !== void 0) {
			const dataForm = new URLSearchParams(data.data).toString();
			const response = await fetch(data.renderUrl, {
				method: "POST",
				headers: data.headers,
				body: dataForm
			});
			if (!response.ok) return;
			var d = await response.json();
			if (isGroupLoad) {
				data.data.type = savedType;
				var g = _groupFiles.find((e) => e.group === data.data.group);
				if (g !== void 0 && !g.loaded) {
					g.loading = false;
					g.loaded = true;
					g.data = d;
					Object.keys(_data).forEach((item) => {
						var t = _data[item];
						if (t.data.group == g.group) RenderSubGroup(t, g);
					});
				} else RenderSubRender(data, d);
			} else RenderSubRender(data, d);
		} else RenderSubRender(data, renderData);
	};
	const Download = (fileId, id) => {
		if (id !== null) {
			var data = _data[id];
			var url = data.downloadUrl + "?";
			var parms = "aid=" + fileId;
			for (var m in data.data) parms += "&" + m + "=" + data.data[m];
			window.open(url + parms);
		}
	};
	const DeleteAsync = async (fileId, id, renderFunction) => {
		document.getElementById(id + "_Waiting")?.classList.remove("d-none");
		var data = _data[id];
		data.data.aid = fileId;
		if (!data.deleteUrl) {
			alert("Missing a delete URL");
			return;
		}
		const dataForm = new URLSearchParams(data.data).toString();
		const response = await fetch(data.deleteUrl, {
			method: "POST",
			headers: data.headers,
			body: dataForm
		});
		if (!response.ok) {
			alert(await response.text());
			return;
		}
		await RenderSubAsync(_data[id]);
	};
	return {
		Init,
		RenderAsync
	};
})();
document.addEventListener("DOMContentLoaded", () => {
	Attachment.Init();
});
//#endregion
//#region node_modules/idb/build/index.js
var instanceOfAny = (object, constructors) => constructors.some((c) => object instanceof c);
var idbProxyableTypes;
var cursorAdvanceMethods;
function getIdbProxyableTypes() {
	return idbProxyableTypes || (idbProxyableTypes = [
		IDBIndex,
		IDBObjectStore,
		IDBCursor,
		IDBDatabase,
		IDBTransaction
	]);
}
function getCursorAdvanceMethods() {
	return cursorAdvanceMethods || (cursorAdvanceMethods = [
		"advance",
		"continue",
		"continuePrimaryKey"
	].map((method) => IDBCursor.prototype[method]));
}
var transactionDoneMap = /* @__PURE__ */ new WeakMap();
var transformCache = /* @__PURE__ */ new WeakMap();
var reverseTransformCache = /* @__PURE__ */ new WeakMap();
function promisifyRequest(request) {
	const promise = new Promise((resolve, reject) => {
		const unlisten = () => {
			request.removeEventListener("success", success);
			request.removeEventListener("error", error);
		};
		const success = () => {
			resolve(wrap(request.result));
			unlisten();
		};
		const error = () => {
			reject(request.error);
			unlisten();
		};
		request.addEventListener("success", success);
		request.addEventListener("error", error);
	});
	reverseTransformCache.set(promise, request);
	return promise;
}
function cacheDonePromiseForTransaction(tx) {
	if (transactionDoneMap.has(tx)) return;
	const done = new Promise((resolve, reject) => {
		const unlisten = () => {
			tx.removeEventListener("complete", complete);
			tx.removeEventListener("error", error);
			tx.removeEventListener("abort", error);
		};
		const complete = () => {
			resolve();
			unlisten();
		};
		const error = () => {
			reject(tx.error || new DOMException("AbortError", "AbortError"));
			unlisten();
		};
		tx.addEventListener("complete", complete);
		tx.addEventListener("error", error);
		tx.addEventListener("abort", error);
	});
	transactionDoneMap.set(tx, done);
}
var idbProxyTraps = {
	get(target, prop, receiver) {
		if (target instanceof IDBTransaction) {
			if (prop === "done") return transactionDoneMap.get(target);
			if (prop === "store") return receiver.objectStoreNames[1] ? void 0 : receiver.objectStore(receiver.objectStoreNames[0]);
		}
		return wrap(target[prop]);
	},
	set(target, prop, value) {
		target[prop] = value;
		return true;
	},
	has(target, prop) {
		if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
		return prop in target;
	}
};
function replaceTraps(callback) {
	idbProxyTraps = callback(idbProxyTraps);
}
function wrapFunction(func) {
	if (getCursorAdvanceMethods().includes(func)) return function(...args) {
		func.apply(unwrap(this), args);
		return wrap(this.request);
	};
	return function(...args) {
		return wrap(func.apply(unwrap(this), args));
	};
}
function transformCachableValue(value) {
	if (typeof value === "function") return wrapFunction(value);
	if (value instanceof IDBTransaction) cacheDonePromiseForTransaction(value);
	if (instanceOfAny(value, getIdbProxyableTypes())) return new Proxy(value, idbProxyTraps);
	return value;
}
function wrap(value) {
	if (value instanceof IDBRequest) return promisifyRequest(value);
	if (transformCache.has(value)) return transformCache.get(value);
	const newValue = transformCachableValue(value);
	if (!Object.is(newValue, value)) {
		transformCache.set(value, newValue);
		reverseTransformCache.set(newValue, value);
	}
	return newValue;
}
var unwrap = (value) => reverseTransformCache.get(value);
/**
* Open a database.
*
* @param name Name of the database.
* @param version Schema version.
* @param callbacks Additional callbacks.
*/
function openDB(name, version, { blocked, upgrade, blocking, terminated } = {}) {
	const request = indexedDB.open(name, version);
	const openPromise = wrap(request);
	if (upgrade) request.addEventListener("upgradeneeded", (event) => {
		upgrade(wrap(request.result), event.oldVersion, event.newVersion, wrap(request.transaction), event);
	});
	if (blocked) request.addEventListener("blocked", (event) => blocked(event.oldVersion, event.newVersion, event));
	openPromise.then((db) => {
		if (terminated) db.addEventListener("close", () => terminated());
		if (blocking) db.addEventListener("versionchange", (event) => blocking(event.oldVersion, event.newVersion, event));
	}).catch(() => {});
	return openPromise;
}
var readMethods = [
	"get",
	"getKey",
	"getAll",
	"getAllKeys",
	"count"
];
var writeMethods = [
	"put",
	"add",
	"delete",
	"clear"
];
var cachedMethods = {};
function getMethod(target, prop) {
	if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
	if (cachedMethods[prop]) return cachedMethods[prop];
	const targetFuncName = prop.replace(/FromIndex$/, "");
	const useIndex = prop !== targetFuncName;
	const isWrite = writeMethods.includes(targetFuncName);
	if (!(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || readMethods.includes(targetFuncName))) return;
	const method = async function(storeName, ...args) {
		const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
		let target = tx.store;
		if (useIndex) target = target.index(args.shift());
		return (await Promise.all([target[targetFuncName](...args), isWrite && tx.done]))[0];
	};
	return cachedMethods[prop] = method;
}
replaceTraps((oldTraps) => ({
	...oldTraps,
	get: (target, prop, receiver) => getMethod(target, prop) || oldTraps.get(target, prop, receiver),
	has: (target, prop) => !!getMethod(target, prop) || oldTraps.has(target, prop)
}));
var advanceMethodProps = [
	"advance",
	"continue",
	"continuePrimaryKey"
];
var methodMap = {};
var advanceResults = /* @__PURE__ */ new WeakMap();
var ittrProxiedCursorToOriginalProxy = /* @__PURE__ */ new WeakMap();
var cursorIteratorTraps = { get(target, prop) {
	if (!advanceMethodProps.includes(prop)) return target[prop];
	let cachedFunc = methodMap[prop];
	if (!cachedFunc) cachedFunc = methodMap[prop] = function(...args) {
		advanceResults.set(this, ittrProxiedCursorToOriginalProxy.get(this)[prop](...args));
	};
	return cachedFunc;
} };
async function* iterate(...args) {
	let cursor = this;
	if (!(cursor instanceof IDBCursor)) cursor = await cursor.openCursor(...args);
	if (!cursor) return;
	cursor = cursor;
	const proxiedCursor = new Proxy(cursor, cursorIteratorTraps);
	ittrProxiedCursorToOriginalProxy.set(proxiedCursor, cursor);
	reverseTransformCache.set(proxiedCursor, unwrap(cursor));
	while (cursor) {
		yield proxiedCursor;
		cursor = await (advanceResults.get(proxiedCursor) || cursor.continue());
		advanceResults.delete(proxiedCursor);
	}
}
function isIteratorProp(target, prop) {
	return prop === Symbol.asyncIterator && instanceOfAny(target, [
		IDBIndex,
		IDBObjectStore,
		IDBCursor
	]) || prop === "iterate" && instanceOfAny(target, [IDBIndex, IDBObjectStore]);
}
replaceTraps((oldTraps) => ({
	...oldTraps,
	get(target, prop, receiver) {
		if (isIteratorProp(target, prop)) return iterate;
		return oldTraps.get(target, prop, receiver);
	},
	has(target, prop) {
		return isIteratorProp(target, prop) || oldTraps.has(target, prop);
	}
}));
//#endregion
//#region IndexedDb/IndexedDb.ts
/**
* @public 
*/
var SiIndexedDb = class {
	_currentRequests;
	_runningRequests;
	_maxConcurrentRequests;
	constructor() {
		this._currentRequests = [];
		this._runningRequests = 0;
		this._maxConcurrentRequests = 1;
	}
	Open() {
		return new Promise((resolve, reject) => {
			this._currentRequests.push({
				resolve,
				reject
			});
			this.TryNext();
		});
	}
	TryNext() {
		if (!this._currentRequests.length) return;
		else if (this._runningRequests < this._maxConcurrentRequests) {
			let { resolve, reject } = this._currentRequests.shift();
			this._runningRequests++;
			siIndexedDb.OpenDb().then((res) => resolve(res)).catch((err) => reject(err)).finally(() => {
				this._runningRequests--;
				this.TryNext();
			});
		}
	}
};
/**
* @public 
*/
var SiIndexedDbMain = class SiIndexedDbMain {
	static _dbName = "ShareItLibrary";
	static _filterOs = "filter";
	static _gridOs = "grid";
	static _gridCachedFieldOs = "gridCachedField";
	static _pageReturnOs = "pageReturn";
	_db = null;
	_open = null;
	_dbOpen = false;
	OpenDb = async () => {
		if (!this._dbOpen) {
			const db = await openDB(SiIndexedDbMain._dbName, 5, { upgrade(db, oldVersion, newVersion, transaction, event) {
				switch (oldVersion) {
					case 0:
						const filterStore = db.createObjectStore(SiIndexedDbMain._filterOs, { keyPath: ["filterId", "field"] });
						filterStore.createIndex("filterId", "filterId", { unique: false });
						filterStore.createIndex("date", "date", { unique: false });
						db.createObjectStore(SiIndexedDbMain._gridOs, { keyPath: "gridId" }).createIndex("date", "date", { unique: false });
						const gridCachedFieldStore = db.createObjectStore(SiIndexedDbMain._gridCachedFieldOs, { keyPath: "key" });
						gridCachedFieldStore.createIndex("gridId_fieldId_rowId_parentId", [
							"gridId",
							"fieldId",
							"rowId",
							"parentId"
						], { unique: false });
						gridCachedFieldStore.createIndex("gridId_fieldId_parentId", [
							"gridId",
							"fieldId",
							"parentId"
						], { unique: false });
						gridCachedFieldStore.createIndex("date", "date", { unique: false });
						db.createObjectStore(SiIndexedDbMain._pageReturnOs, { keyPath: "key" });
					case 1:
						try {
							db.deleteObjectStore(SiIndexedDbMain._gridCachedFieldOs);
							db.deleteObjectStore(SiIndexedDbMain._pageReturnOs);
						} catch {}
						const gridCachedFieldStore1 = db.createObjectStore(SiIndexedDbMain._gridCachedFieldOs, { keyPath: "key" });
						gridCachedFieldStore1.createIndex("gridId_fieldId_rowId_parentId", [
							"gridId",
							"fieldId",
							"rowId",
							"parentId"
						], { unique: false });
						gridCachedFieldStore1.createIndex("gridId_fieldId_parentId", [
							"gridId",
							"fieldId",
							"parentId"
						], { unique: false });
						gridCachedFieldStore1.createIndex("date", "date", { unique: false });
						db.createObjectStore(SiIndexedDbMain._pageReturnOs, { keyPath: "key" });
						break;
					case 2:
						try {
							db.deleteObjectStore(SiIndexedDbMain._gridCachedFieldOs);
							db.deleteObjectStore(SiIndexedDbMain._pageReturnOs);
						} catch {}
						const gridCachedFieldStore2 = db.createObjectStore(SiIndexedDbMain._gridCachedFieldOs, { keyPath: "key" });
						gridCachedFieldStore2.createIndex("gridId_fieldId_rowId_parentId", [
							"gridId",
							"fieldId",
							"rowId",
							"parentId"
						], { unique: false });
						gridCachedFieldStore2.createIndex("gridId_fieldId_parentId", [
							"gridId",
							"fieldId",
							"parentId"
						], { unique: false });
						gridCachedFieldStore2.createIndex("date", "date", { unique: false });
						db.createObjectStore(SiIndexedDbMain._pageReturnOs, { keyPath: "key" });
						break;
					case 3:
						try {
							db.deleteObjectStore(SiIndexedDbMain._gridCachedFieldOs);
							db.deleteObjectStore(SiIndexedDbMain._pageReturnOs);
						} catch {}
						db.deleteObjectStore(SiIndexedDbMain._gridCachedFieldOs);
						const gridCachedFieldStore3 = db.createObjectStore(SiIndexedDbMain._gridCachedFieldOs, { keyPath: "key" });
						gridCachedFieldStore3.createIndex("gridId_fieldId_rowId_parentId", [
							"gridId",
							"fieldId",
							"rowId",
							"parentId"
						], { unique: false });
						gridCachedFieldStore3.createIndex("gridId_fieldId_parentId", [
							"gridId",
							"fieldId",
							"parentId"
						], { unique: false });
						gridCachedFieldStore3.createIndex("date", "date", { unique: false });
						db.createObjectStore(SiIndexedDbMain._pageReturnOs, { keyPath: "key" });
						break;
					case 4: db.createObjectStore(SiIndexedDbMain._pageReturnOs, { keyPath: "key" });
				}
			} });
			this._db = db;
			this._dbOpen = true;
		}
	};
	DeleteExpired = async (os, isGridValues) => {
		var expiredDate = /* @__PURE__ */ new Date();
		if (isGridValues) expiredDate.setMinutes(expiredDate.getMinutes() - 10);
		else expiredDate.setHours(expiredDate.getHours() - 12);
		let dataR = await this._db.transaction(os, "readonly").objectStore(os).index("date").getAll(IDBKeyRange.upperBound(expiredDate));
		if (dataR.length) {
			let rows = this._db.transaction(os, "readwrite").objectStore(os);
			for (const e of dataR) if (e.gridId !== void 0) await rows.delete(e.gridId);
			else if (e.filterId !== void 0) await rows.delete([e.filterId, e.field]);
		}
	};
	InitAsync = async () => {
		this._open = new SiIndexedDb();
		await this._open.Open();
	};
	FilterSetAsync = async (filterId, field, value, text) => {
		await this._open.Open();
		let trans = this._db.transaction(SiIndexedDbMain._filterOs, "readwrite");
		let rows = trans.objectStore(SiIndexedDbMain._filterOs);
		let row = {
			key: Math.random(),
			filterId,
			field,
			value,
			text,
			date: /* @__PURE__ */ new Date()
		};
		try {
			await rows.put(row);
			await trans.done;
		} catch (err) {
			alert("Something went wrong!");
		}
	};
	FilterGetAsync = async (filterId, field) => {
		await this._open.Open();
		await this.DeleteExpired(SiIndexedDbMain._filterOs, false);
		return await this._db.transaction(SiIndexedDbMain._filterOs, "readonly").objectStore(SiIndexedDbMain._filterOs).get([filterId, field]);
	};
	FilterClearAsync = async (filterId) => {
		await this._open.Open();
		let rows = this._db.transaction(SiIndexedDbMain._filterOs, "readwrite").objectStore(SiIndexedDbMain._filterOs);
		let request = await rows.index("filterId").getAllKeys(IDBKeyRange.only(filterId));
		for (const e of request) await rows.delete(e);
	};
	GridSetAsync = async (gridId, sortField, direction, page) => {
		await this._open.Open();
		let trans = this._db.transaction(SiIndexedDbMain._gridOs, "readwrite");
		let rows = trans.objectStore(SiIndexedDbMain._gridOs);
		var existing = await rows.get(gridId);
		if (existing !== void 0) {
			sortField = sortField == void 0 || sortField == null ? existing.sortField : sortField;
			direction = direction == null ? existing.direction : direction;
			page = page == void 0 || page == null ? existing.page : page;
		}
		let row = {
			gridId,
			sortField,
			direction,
			page,
			date: /* @__PURE__ */ new Date()
		};
		try {
			await rows.put(row);
			await trans.done;
		} catch (err) {
			alert("Something went wrong!");
		}
	};
	GridGetAsync = async (gridId) => {
		await this._open.Open();
		await this.DeleteExpired(SiIndexedDbMain._gridOs, false);
		return await this._db.transaction(SiIndexedDbMain._gridOs, "readonly").objectStore(SiIndexedDbMain._gridOs).get(gridId);
	};
	GridClearAsync = async (gridId) => {
		await this._open.Open();
		await this._db.transaction(SiIndexedDbMain._gridOs, "readwrite").objectStore(SiIndexedDbMain._gridOs).delete(gridId);
	};
	GridFieldSetAsync = async (gridId, fieldId, rowId, value, parentId) => {
		await this._open.Open();
		let trans = this._db.transaction(SiIndexedDbMain._gridCachedFieldOs, "readwrite");
		let rows = trans.objectStore(SiIndexedDbMain._gridCachedFieldOs);
		let row = {
			key: Math.random(),
			gridId,
			fieldId,
			rowId,
			value,
			parentId,
			date: /* @__PURE__ */ new Date()
		};
		try {
			await rows.put(row);
			await trans.done;
		} catch (err) {
			alert("Something went wrong!");
		}
	};
	GridFieldValuesGetAsync = async (gridId, fieldId, rowIds, parentId) => {
		await this._open.Open();
		await this.DeleteExpired(SiIndexedDbMain._gridCachedFieldOs, true);
		let trans = this._db.transaction(SiIndexedDbMain._gridCachedFieldOs, "readonly");
		var result = [];
		if (rowIds !== void 0) {
			let rows = trans.objectStore(SiIndexedDbMain._gridCachedFieldOs).index("gridId_fieldId_rowId_parentId");
			for (var i = 0; i < rowIds.length; i++) {
				let found = await rows.get([
					gridId,
					fieldId,
					rowIds[i],
					parentId
				]);
				if (found !== void 0) result.push(found);
			}
		} else result = await trans.objectStore(SiIndexedDbMain._gridCachedFieldOs).index("gridId_fieldId_parentId").getAll([
			gridId,
			fieldId,
			parentId
		]);
		return result;
	};
	GridFieldRemoveAsync = async (gridId, fieldId, rowId, parentId) => {
		if (!rowId) return;
		await this._open.Open();
		let rows = this._db.transaction(SiIndexedDbMain._gridCachedFieldOs, "readwrite").objectStore(SiIndexedDbMain._gridCachedFieldOs);
		let request = await rows.index("gridId_fieldId_rowId_parentId").getAllKeys(IDBKeyRange.only([
			gridId,
			fieldId,
			rowId,
			parentId
		]));
		for (const e of request) await rows.delete(e);
	};
	GridFieldClearAsync = async (gridId, fieldId, parentId) => {
		await this._open.Open();
		let rows = this._db.transaction(SiIndexedDbMain._gridCachedFieldOs, "readwrite").objectStore(SiIndexedDbMain._gridCachedFieldOs);
		let request = await rows.index("gridId_fieldId_parentId").getAllKeys(IDBKeyRange.only([
			gridId,
			fieldId,
			parentId
		]));
		for (const e of request) await rows.delete(e);
	};
	PageReturnSetAsync = async (trail) => {
		await this._open.Open();
		let trans = this._db.transaction(SiIndexedDbMain._pageReturnOs, "readwrite");
		let rows = trans.objectStore(SiIndexedDbMain._pageReturnOs);
		await this.PageReturnClearAsync(rows);
		let row = {
			key: Math.random(),
			trail
		};
		try {
			await rows.put(row);
			await trans.done;
		} catch (err) {
			alert("Something went wrong!");
		}
	};
	PageReturnClearAsync = async (rows) => {
		if (rows == void 0) {
			await this._open.Open();
			rows = this._db.transaction(SiIndexedDbMain._pageReturnOs, "readwrite").objectStore(SiIndexedDbMain._pageReturnOs);
		}
		if (rows !== void 0) rows.clear();
	};
	PageReturnGetAsync = async () => {
		await this._open.Open();
		var allRows = await this._db.transaction(SiIndexedDbMain._pageReturnOs, "readonly").objectStore(SiIndexedDbMain._pageReturnOs).getAll();
		return allRows.length > 0 ? allRows[0].trail : null;
	};
};
/**
* @public 
*/
var siIndexedDb = new SiIndexedDbMain();
/**
* @public 
*/
var IndexedDb = {
	async InitAsync() {
		await siIndexedDb.InitAsync();
	},
	async FilterSetAsync(filterId, field, value, text) {
		await siIndexedDb.FilterSetAsync(filterId, field, value, text);
	},
	async FilterGetAsync(filterId, field) {
		return await siIndexedDb.FilterGetAsync(filterId, field);
	},
	async FilterClearAsync(filterId) {
		await siIndexedDb.FilterClearAsync(filterId);
	},
	async GridSetAsync(gridId, sortField, direction, page) {
		await siIndexedDb.GridSetAsync(gridId, sortField, direction, page);
	},
	async GridGetAsync(gridId) {
		return await siIndexedDb.GridGetAsync(gridId);
	},
	async GridClearAsync(gridId) {
		await siIndexedDb.GridClearAsync(gridId);
	},
	async GridFieldSetAsync(gridId, fieldId, rowId, value, parentId) {
		await siIndexedDb.GridFieldSetAsync(gridId, fieldId, rowId, value, parentId);
	},
	async GridFieldValuesGetAsync(gridId, fieldId, rowIds, parentId) {
		return await siIndexedDb.GridFieldValuesGetAsync(gridId, fieldId, rowIds, parentId);
	},
	async GridFieldRemoveAsync(gridId, fieldId, rowId, parentId) {
		await siIndexedDb.GridFieldRemoveAsync(gridId, fieldId, rowId, parentId);
	},
	async GridFieldClearAsync(gridId, fieldId, parentId) {
		await siIndexedDb.GridFieldClearAsync(gridId, fieldId, parentId);
	},
	async PageReturnSetAsync(trail) {
		await siIndexedDb.PageReturnSetAsync(trail);
	},
	async PageReturnClearAsync(rows) {
		await siIndexedDb.PageReturnClearAsync(rows);
	},
	async PageReturnGetAsync() {
		return await siIndexedDb.PageReturnGetAsync();
	}
};
document.addEventListener("DOMContentLoaded", async () => {
	await IndexedDb.InitAsync();
});
//#endregion
//#region AutoCompleter/AutoCompleter.ts
/**
* @public 
*/
var AutoCompleter = (() => {
	const Init = () => {
		document.querySelectorAll(".AutoCompleteEntry").forEach((el) => {
			el.removeEventListener("keydown", AutoCompleteEnter);
			el.removeEventListener("keyup", AutoCompleteAsync);
			el.addEventListener("keydown", AutoCompleteEnter);
			el.addEventListener("keyup", AutoCompleteAsync);
		});
		document.querySelectorAll(".AutoCompleterContainer").forEach((el) => {
			el.removeEventListener("focusout", AutoCompleteBlur);
			el.removeEventListener("focusin", AutoCompleteUnBlur);
			el.addEventListener("focusout", AutoCompleteBlur);
			el.addEventListener("focusin", AutoCompleteUnBlur);
		});
		document.querySelectorAll(".AutoCompleterResults").forEach((el) => {
			el.removeEventListener("focusout", AutoCompleteBlur);
			el.removeEventListener("focusin", AutoCompleteUnBlur);
			el.addEventListener("focusout", AutoCompleteBlur);
			el.addEventListener("focusin", AutoCompleteUnBlur);
		});
		document.querySelectorAll(".AutoCompleteEntry").forEach((el) => {
			const form = el.closest("form");
			if (form) form.dataset.autocomplete = "off";
		});
		document.querySelectorAll(".AutoCompleterContainer [data-init-validate]").forEach((el) => {
			var valueId = el.dataset.valueid;
			(async () => {
				await AutoCompleteValueTextAsync(valueId ?? "");
			})();
		});
		document.querySelectorAll(".AutoCompleterContainer [data-show-list]").forEach((el) => {
			el.addEventListener("click", async (e) => {
				var id = e.currentTarget.dataset.showList;
				await ShowListAsync(id);
			});
		});
		document.querySelectorAll(".AutoCompleterContainer [data-autocompleter-edit]").forEach((el) => {
			el.addEventListener("click", async (e) => {
				var id = e.currentTarget.dataset.autocompleterEdit;
				await EditAsync(id);
			});
		});
		document.querySelectorAll("[data-focus]").forEach((el) => {
			el.dispatchEvent(new Event("focus"));
		});
	};
	const AutoCompleteAsync = async (e, tb) => {
		var textBox = e ? e.currentTarget : tb;
		var isPage = textBox.dataset.isPaging === "1";
		if (e) {
			if (e.key !== "ArrowUp" && e.key !== "ArrowDown") await ShowListAsync(textBox.dataset.valueid ?? "", false, true, isPage);
		}
		textBox.dataset.validating = "1";
		var valueBox = document.getElementById(CSS.escape(textBox.dataset.valueid ?? ""));
		var resultContainer = document.getElementById(CSS.escape(textBox.dataset.resultsid ?? ""));
		var editButton = document.getElementById(CSS.escape(textBox.dataset.editbutton ?? ""));
		var newButton = document.getElementById(CSS.escape(textBox.dataset.newbutton ?? ""));
		var handled = false;
		var item;
		if (e) switch (e.key) {
			case "Enter":
			case "NumpadEnter":
			case "Tab":
			case "Escape":
				handled = true;
				break;
			case "ArrowDown":
				item = resultContainer.querySelector(".AutoCompleterResultHover");
				if (item) {
					const parent = item.parentElement;
					if (parent && item !== parent.lastElementChild) {
						item.classList.remove("AutoCompleterResultHover");
						var next = item.nextElementSibling;
						if (next) next.classList.add("AutoCompleterResultHover");
					}
				}
				handled = true;
				break;
			case "ArrowUp":
				item = resultContainer.querySelector(".AutoCompleterResultHover");
				if (item) {
					const parent = item.parentElement;
					if (parent && item !== parent.firstElementChild) {
						item.classList.remove("AutoCompleterResultHover");
						var prev = item.previousElementSibling;
						if (prev) prev.classList.add("AutoCompleterResultHover");
					}
				}
				handled = true;
		}
		if (!handled) {
			var oldValue = valueBox ? valueBox.value : "";
			if (textBox.dataset.load === "1") textBox.dataset.load = "";
			else {
				textBox.classList.remove("AutoCompleteValid");
				valueBox.dataset.validity = "";
				if (editButton) editButton.classList.add("AutoCompleterHidden");
				if (newButton) newButton.classList.remove("AutoCompleterHidden");
				valueBox.value = "";
			}
			if (textBox.value === "") {
				if (!resultContainer.classList.contains("AutoCompleterHidden")) resultContainer.classList.add("AutoCompleterHidden");
				textBox.dataset.validating = "0";
				valueBox.dataset.validity = "true";
				valueBox.dispatchEvent(new CustomEvent("valid", { detail: {
					value: valueBox.value,
					oldValue
				} }));
			} else {
				var data = {};
				data = ExtraParameters(textBox, data);
				data = FilterControls(textBox, data);
				var doSearch = true;
				if (textBox.dataset.postinvalidvalue === "1") valueBox.value = textBox.value;
				if (doSearch) {
					var timerId = setTimeout(() => {
						ShowWaiting(resultContainer);
					}, 400);
					if (textBox.dataset.textOnly !== void 0) valueBox.value = textBox.value;
					var headers = Ajax.Headers();
					data.resultType = textBox.dataset.resulttype;
					data.search = encodeURIComponent(textBox.value);
					data.user = textBox.dataset.user;
					var rawPage = textBox.dataset.page;
					data.page = typeof rawPage === "number" ? rawPage : Number.isFinite(Number(rawPage)) ? Number(rawPage) : 0;
					const dataForm = new URLSearchParams(data).toString();
					const response = await fetch(textBox.dataset.ajax, {
						method: "POST",
						headers,
						body: dataForm
					});
					if (timerId !== void 0) clearTimeout(timerId);
					if (!response.ok) {
						textBox.dataset.validating = "0";
						return;
					}
					var d = await response.json();
					resultContainer.innerHTML = "";
					if (!d.results || d.results.length === 0 || valueBox.dataset.clear === "1") {
						resultContainer.classList.add("AutoCompleterHidden");
						valueBox.dispatchEvent(new CustomEvent("invalid", { detail: { value: valueBox.value } }));
						delete valueBox.dataset.clear;
					} else {
						resultContainer.classList.remove("AutoCompleterHidden");
						d.results.forEach((result) => {
							var html = document.createElement("div");
							if (result.bad || d.includeInfo) {
								if (result.bad) html.classList.add("bg-danger", "text-white");
								if (d.includeInfo && result.info !== "") html.classList.add("IncludeInfo");
							}
							html.dataset.result = "result";
							html.dataset.value = result.value;
							const text = document.createElement("div");
							text.dataset.text = "text";
							if (result.bad) text.classList.add("bg-danger");
							text.textContent = result.text ?? "";
							html.appendChild(text);
							if (d.includeInfo && result.info !== "") {
								const info = document.createElement("div");
								info.classList.add("Info");
								if (result.bad) info.classList.add("bg-danger", "text-white");
								info.textContent = result.info ?? "";
								html.appendChild(info);
							}
							resultContainer.appendChild(html);
							if (textBox.value.toLowerCase() === (result.text ?? "").toLowerCase()) {
								textBox.value = result.text ?? "";
								if (textBox.dataset.textOnly !== void 0) valueBox.value = textBox.value;
								else valueBox.value = result.value ?? "";
								textBox.classList.remove("AutoCompleteInValid");
								valueBox.dataset.validity = "";
								if (textBox.dataset.textOnly === void 0) {
									textBox.classList.add("AutoCompleteValid");
									valueBox.dataset.validity = "valid";
								}
								resultContainer.classList.add("AutoCompleterHidden");
								textBox.dispatchEvent(new CustomEvent("valid", { detail: { value: valueBox.value } }));
								valueBox.dispatchEvent(new CustomEvent("valid", { detail: {
									value: valueBox.value,
									oldValue
								} }));
							}
						});
						if (d.canPage || data.page !== 0) {
							const foot = document.createElement("div");
							foot.classList.add("bg-secondary", "text-center");
							foot.dataset.paging = "";
							if (data.page !== 0) {
								const aLeft = document.createElement("a");
								aLeft.role = "button";
								aLeft.classList.add("me-3", "btn", "btn-secondary", "pt-0", "pb-0", "ps-1", "pe-1", "border", "border-light", "rounded-4");
								aLeft.dataset.siAcPageLeft = "";
								const iLeft = document.createElement("i");
								iLeft.classList.add("fa", "fa-arrow-left");
								aLeft.appendChild(iLeft);
								foot.append(aLeft);
							}
							if (d.canPage) {
								const aRight = document.createElement("a");
								aRight.role = "button";
								aRight.classList.add("me-3", "btn", "btn-secondary", "pt-0", "pb-0", "ps-1", "pe-1", "border", "border-light", "rounded-4");
								aRight.dataset.siAcPageRight = "";
								const iRight = document.createElement("i");
								iRight.classList.add("fa", "fa-arrow-right");
								aRight.appendChild(iRight);
								foot.append(aRight);
							}
							resultContainer.appendChild(foot);
							if (!isPage) textBox.dispatchEvent(new Event("focus"));
							var pageLeft = foot.querySelector("[data-si-ac-page-left]");
							if (pageLeft) pageLeft.addEventListener("click", async (ee) => {
								var page = Number(textBox.dataset.page) - 1;
								textBox.dataset.page = String(page);
								textBox.dataset.isPaging = "1";
								window.clearTimeout(textBox.timeoutHandle);
								textBox.timeoutHandle = void 0;
								await RefreshResultsAsync(textBox, true);
								textBox.dataset.isPaging = "";
								textBox.focus();
							});
							var pageRight = foot.querySelector("[data-si-ac-page-right]");
							if (pageRight) pageRight.addEventListener("click", async (ee) => {
								var page = Number(textBox.dataset.page) + 1;
								textBox.dataset.page = String(page);
								textBox.dataset.isPaging = "1";
								window.clearTimeout(textBox.timeoutHandle);
								textBox.timeoutHandle = void 0;
								await RefreshResultsAsync(textBox, true);
								textBox.dataset.isPaging = "";
								textBox.focus();
							});
						}
						if (valueBox.dataset.validity !== "valid") valueBox.dispatchEvent(new CustomEvent("invalid", { detail: { value: valueBox.value } }));
						var firstChild = resultContainer.firstElementChild;
						if (firstChild) firstChild.classList.add("AutoCompleterResultHover");
						resultContainer.querySelectorAll("[data-result]").forEach((el) => {
							el.addEventListener("mouseenter", (ee) => {
								var thatEe = ee.target;
								resultContainer.querySelectorAll(".AutoCompleterResultHover").forEach((el2) => el2.classList.remove("AutoCompleterResultHover"));
								if (!thatEe.dataset.result) thatEe = thatEe.parentElement;
								thatEe.classList.add("AutoCompleterResultHover");
								resultContainer.dataset.mouseInside = String(true);
							});
						});
						resultContainer.querySelectorAll("[data-result]").forEach((el) => {
							el.addEventListener("mouseleave", () => {
								delete resultContainer.dataset.mouseInside;
							});
						});
						resultContainer.querySelectorAll("[data-result=\"result\"]").forEach((el) => {
							el.addEventListener("click", (ee) => {
								if (ee.target != null) {
									var thatEe = ee.target.closest("[data-result=\"result\"]");
									if (thatEe && thatEe.dataset.result === void 0) thatEe = thatEe.parentElement;
									if (thatEe) {
										const element = thatEe.querySelector("[data-text=\"text\"]");
										if (element) {
											textBox.value = HtmlDecode(element.innerHTML) ?? "";
											if (textBox.dataset.textOnly !== void 0) valueBox.value = textBox.value;
											else valueBox.value = thatEe.dataset.value ?? "";
											if (textBox.dataset.textOnly === void 0) {
												textBox.classList.add("AutoCompleteValid");
												valueBox.dataset.validity = "valid";
											}
											if (editButton) editButton.classList.remove("AutoCompleterHidden");
											if (newButton) newButton.classList.add("AutoCompleterHidden");
											resultContainer.classList.add("AutoCompleterHidden");
											textBox.dispatchEvent(new CustomEvent("valid", { detail: { value: valueBox.value } }));
											valueBox.dispatchEvent(new CustomEvent("valid", { detail: {
												value: valueBox.value,
												oldValue
											} }));
											delete resultContainer.dataset.mouseInside;
										}
									}
								}
							});
						});
					}
					textBox.dataset.validating = "0";
				}
			}
		} else textBox.dataset.validating = "0";
	};
	const ShowWaiting = (resultContainer) => {
		resultContainer.innerHTML = "";
		var html = document.createElement("div");
		html.classList.add("WaitingOuterChild");
		html.style.position = "relative";
		html.style.paddingTop = "1.5rem";
		var child = document.createElement("div");
		child.classList.add("WaitingChild");
		var centre = document.createElement("div");
		centre.classList.add("text-center");
		var spinner = document.createElement("div");
		spinner.classList.add("spinner-border", "text-primary");
		spinner.role = "status";
		var text = document.createElement("p");
		text.textContent = "Loading Data...";
		centre.appendChild(spinner);
		centre.appendChild(text);
		child.appendChild(centre);
		html.appendChild(child);
		resultContainer.appendChild(html);
	};
	const RefreshResultsAsync = async (textBox, page) => {
		window.clearTimeout(textBox.dataset.timeoutHandle);
		delete textBox.dataset.timeoutHandle;
		if (!page) textBox.dataset.page = "0";
		await AutoCompleteAsync(null, textBox);
	};
	const AutoCompleteEnter = (e) => {
		var that = e.currentTarget;
		var textBox;
		switch (e.key) {
			case "Enter":
			case "Tab":
				if (e.key == "Enter") e.preventDefault();
				textBox = that;
				var valueBox = document.getElementById(CSS.escape(textBox.dataset.valueid ?? ""));
				var resultContainer = document.getElementById(CSS.escape(textBox.dataset.resultsid ?? ""));
				var editButton = document.getElementById(CSS.escape(textBox.dataset.editbutton ?? ""));
				var newButton = document.getElementById(CSS.escape(textBox.dataset.newbutton ?? ""));
				var item = resultContainer.querySelector(".AutoCompleterResultHover");
				if (item !== void 0) {
					const itemText = item.querySelector("[data-text=\"text\"]");
					textBox.value = HtmlDecode(itemText.innerHTML) ?? "";
					if (textBox.dataset.textOnly !== void 0) valueBox.value = textBox.value;
					else valueBox.value = item.dataset.value ?? "";
					if (textBox.dataset.textOnly === void 0) {
						textBox.classList.add("AutoCompleteValid");
						valueBox.dataset.validity = "valid";
					}
					if (editButton) editButton.classList.remove("AutoCompleterHidden");
					if (newButton) newButton.classList.remove("AutoCompleterHidden");
					textBox.dispatchEvent(new CustomEvent("valid", { detail: { value: valueBox.value } }));
					valueBox.dispatchEvent(new CustomEvent("valid", { detail: {
						value: valueBox.value,
						oldValue: valueBox.value
					} }));
				}
				resultContainer.classList.add("AutoCompleterHidden");
				break;
			case "Escape":
				e.preventDefault();
				textBox = that;
				window.setTimeout("ShareItLibrary.AutoCompleter.HideResultContainer('" + textBox.dataset.resultsid + "')", 200);
				return;
		}
	};
	const AutoCompleteBlur = (e) => {
		var node = e.currentTarget;
		while (!node.classList.contains("AutoCompleterContainer")) node = node.parentElement;
		var textBox = node.querySelector("input[data-resultsid]");
		var id = textBox.dataset.valueid;
		if (id) textBox.timeoutHandle = window.setTimeout(() => {
			HideAllResults(id);
		}, 400);
	};
	const AutoCompleteUnBlur = (e) => {
		var node = e.currentTarget;
		while (!node.classList.contains("AutoCompleterContainer")) node = node.parentElement;
		var textBox = node.querySelector("input[data-resultsid]");
		window.clearTimeout(textBox.timeoutHandle);
		textBox.timeoutHandle = void 0;
	};
	const HideAllResults = (id) => {
		var textBox = document.getElementById(id + "_text");
		window.clearTimeout(textBox.timeoutHandle);
		textBox.timeoutHandle = void 0;
		HideResultContainer(id + "_r");
		(async () => {
			await ShowListAsync(id, false, true);
		})();
	};
	const HideResultContainer = (resultsid) => {
		var resultContainer = document.getElementById(CSS.escape(resultsid));
		if (!resultContainer.classList.contains("AutoCompleterHidden")) {
			resultContainer.classList.add("AutoCompleterHidden");
			var textBox = document.querySelector("input[data-resultsid=\"" + CSS.escape(resultsid) + "\"]");
			if (textBox.dataset.isPaging !== "1") textBox.dataset.page = "0";
		}
	};
	const ExtraParameters = (textBox, data) => {
		var extraParamters = textBox.dataset.extraparameters;
		if (extraParamters !== void 0) {
			var eps = extraParamters.split("|");
			for (var i = 0; i < eps.length; i++) {
				var ep = eps[i].split("=");
				var ep1 = encodeURI(ep[1]);
				data[ep[0]] = ep1;
			}
		}
		return data;
	};
	const FilterControls = (textBox, data) => {
		var filterControls = textBox.dataset.filtercontrols;
		var fVal = "";
		if (filterControls !== void 0) {
			var filters = filterControls.split("|");
			for (var i = 0; i < filters.length; i++) {
				var filter = filters[i].split("=");
				var filter1 = CSS.escape(filter[1]);
				var fVal = "";
				if (filter[2] === "ShareIt.Library.AutoCompleter") {
					const entry = document.getElementById(filter1 + "_Entry");
					if (entry.dataset.validating === "1") window.setTimeout("ShareItLibrary.AutoCompleter.AutoCompleteValidate('" + textBox.id + "')", 100);
					else fVal = document.getElementById(encodeURI(entry.dataset.valueid ?? "")).value;
				} else switch (document.getElementById(filter1).type) {
					case "radio":
						const radio = document.querySelector("#" + filter1 + ":checked");
						fVal = radio ? radio.value : "";
						break;
					default:
						const other = document.getElementById(filter1);
						fVal = other ? other.value : "";
				}
				data[filter[0]] = fVal;
			}
		}
		return data;
	};
	const AutoCompleteValueTextAsync = async (id) => {
		var textBox = document.getElementById(CSS.escape(id) + "_text");
		var valueBox = document.getElementById(CSS.escape(textBox.dataset.valueid ?? ""));
		var headers = Ajax.Headers();
		var data = {
			ResultType: textBox.dataset.resulttype,
			TextFromValue: true,
			Value: valueBox.value
		};
		data = ExtraParameters(textBox, data);
		data = FilterControls(textBox, data);
		textBox.classList.remove("AutoCompleteValid", "AutoCompleteInValid");
		valueBox.dataset.validity = "";
		const dataForm = new URLSearchParams(data).toString();
		const response = await fetch(textBox.dataset.ajax, {
			method: "POST",
			headers,
			body: dataForm
		});
		if (!response.ok) {
			alert(await response.text());
			return;
		}
		var d = await response.json();
		textBox.value = d.text ?? "";
		if (d.text !== null && d.text !== "") {
			textBox.classList.remove("AutoCompleteInValid");
			valueBox.dataset.validity = "";
			if (textBox.dataset.textOnly === void 0) {
				textBox.classList.add("AutoCompleteValid");
				valueBox.dataset.validity = "valid";
			}
		}
	};
	const Clear = (id) => {
		var valueBox = document.getElementById(CSS.escape(id));
		var textBox = document.getElementById(CSS.escape(id) + "_text");
		var results = document.getElementById(CSS.escape(id) + "_r");
		valueBox.value = "";
		valueBox.dataset.clear = "1";
		textBox.value = "";
		results.classList.add("AutoCompleterHidden");
		textBox.classList.remove("AutoCompleteValid", "AutoCompleteInValid");
		valueBox.dataset.validity = "";
		return valueBox;
	};
	const HtmlDecode = (value) => {
		if (value !== void 0) {
			value = value.replaceAll("&amp;", "&");
			value = value.replaceAll("&lt;", "<");
			value = value.replaceAll("&gt;", ">");
		}
		return value;
	};
	const ShowListAsync = async (id, refresh = false, forceClose = false, page = false) => {
		if (id) {
			var idEsc = CSS.escape(id);
			var listParent = document.getElementById(idEsc + "_List");
			var textBox = document.getElementById(idEsc + "_text");
			if (textBox.dataset.isPaging !== "1") HideResultContainer(idEsc + "_r");
			if ((listParent.classList.contains("d-none") || refresh) && !forceClose) {
				listParent.classList.remove("d-none");
				var list = document.getElementById(idEsc + "_ListContent");
				var valueBox = document.getElementById(CSS.escape(textBox.dataset.valueid ?? ""));
				var data = {};
				data = ExtraParameters(textBox, data);
				data = FilterControls(textBox, data);
				list.innerHTML = "";
				var headers = Ajax.Headers();
				data.resultType = textBox.dataset.resulttype;
				data.function = "List";
				data.user = textBox.dataset.user;
				data.page = Number(listParent.dataset.page ?? "0");
				var timerId = setTimeout(() => {
					ShowWaiting(list);
				}, 400);
				const dataForm = new URLSearchParams(data).toString();
				const response = await fetch(textBox.dataset.ajax, {
					method: "POST",
					headers,
					body: dataForm
				});
				if (!response.ok) {
					alert(await response.text());
					return;
				}
				var d = await response.json();
				if (timerId !== void 0) clearTimeout(timerId);
				list.innerHTML = "";
				if (d.results) for (var i = 0; i < d.results.length; i++) {
					var html = document.createElement("div");
					if (d.includeInfo) html.classList.add("IncludeInfo");
					html.dataset.result = "result";
					html.dataset.value = d.results[i].value;
					var text = document.createElement("div");
					text.dataset.text = "text";
					text.textContent = d.results[i].text ?? "";
					html.appendChild(text);
					if (d.includeInfo) {
						var info = document.createElement("div");
						info.classList.add("Info");
						info.textContent = d.results[i].info ?? "";
						html.appendChild(info);
					}
					list.appendChild(html);
				}
				if (d.canPage || data.page !== 0) {
					var htmlFoot = document.createElement("div");
					htmlFoot.classList.add("bg-secondary", "text-center");
					htmlFoot.dataset.paging = "";
					if (data.page !== 0) {
						var a = document.createElement("a");
						a.role = "button";
						a.classList.add("me-3", "btn", "btn-secondary", "pt-0", "pb-0", "ps-1", "pe-1", "border", "border-light", "rounded-4");
						a.dataset.siAcPageLeft = "";
						var iFa = document.createElement("i");
						iFa.classList.add("fa", "fa-arrow-left");
						a.appendChild(iFa);
						htmlFoot.appendChild(a);
					}
					if (d.canPage) {
						var a = document.createElement("a");
						a.role = "button";
						a.classList.add("me-3", "btn", "btn-secondary", "pt-0", "pb-0", "ps-1", "pe-1", "border", "border-light", "rounded-4");
						a.dataset.siAcPageRight = "";
						var iFa = document.createElement("i");
						iFa.classList.add("fa", "fa-arrow-right");
						a.appendChild(iFa);
						htmlFoot.appendChild(a);
					}
					list.appendChild(htmlFoot);
					textBox.dispatchEvent(new Event("focus"));
					var pageLeft = list.querySelector("[data-si-ac-page-left]");
					if (pageLeft) pageLeft.addEventListener("click", async (e) => {
						var page = Number(listParent.dataset.page) - 1;
						listParent.dataset.page = String(page);
						window.clearTimeout(textBox.timeoutHandle);
						textBox.timeoutHandle = void 0;
						textBox.dataset.isPaging = "1";
						await ShowListAsync(id, true, false, true);
						textBox.dataset.isPaging = "";
					});
					var pageRight = list.querySelector("[data-si-ac-page-right]");
					if (pageRight) pageRight.addEventListener("click", async (e) => {
						var page = Number(listParent.dataset.page) + 1;
						listParent.dataset.page = String(page);
						window.clearTimeout(textBox.timeoutHandle);
						textBox.timeoutHandle = void 0;
						textBox.dataset.isPaging = "1";
						await ShowListAsync(id, true, false, true);
						textBox.dataset.isPaging = "";
					});
				}
				Array.from(list.children).forEach((el) => {
					el.addEventListener("mouseenter", (e) => {
						var that = e.currentTarget;
						Array.from(list.children).forEach((elI) => elI.classList.remove("AutoCompleterResultHover"));
						that.classList.add("AutoCompleterResultHover");
					});
				});
				list.querySelectorAll("[data-result=\"result\"]").forEach((el) => {
					el.addEventListener("click", (e) => {
						var that = e.currentTarget;
						textBox.value = HtmlDecode(that.querySelector("[data-text=\"text\"]").innerHTML) ?? "";
						var oldValue = valueBox.value;
						if (textBox.dataset.textOnly !== void 0) valueBox.value = textBox.value;
						else valueBox.value = that.dataset.value ?? "";
						if (textBox.dataset.textOnly === void 0) {
							textBox.classList.add("AutoCompleteValid");
							valueBox.dataset.validity = "valid";
						}
						if (!page) {
							textBox.dataset.page = "0";
							listParent.dataset.page = "0";
						}
						listParent.classList.add("d-none");
						textBox.dispatchEvent(new CustomEvent("valid", { detail: { value: valueBox.value } }));
						valueBox.dispatchEvent(new CustomEvent("valid", { detail: {
							value: valueBox.value,
							oldValue
						} }));
					});
				});
			} else {
				if (!page) {
					textBox.dataset.page = "0";
					listParent.dataset.page = "0";
				}
				listParent.classList.add("d-none");
			}
		}
	};
	const EditAsync = async (id) => {
		if (id) {
			var idEsc = CSS.escape(id);
			var val = document.getElementById(idEsc);
			if (val.value === "") val.value = document.getElementById(idEsc + "_n").value;
			var ac = document.getElementById(idEsc + "_text");
			var form = ac.closest("form");
			if (ac.dataset.editaction !== void 0) form.action = ac.dataset.editaction ?? "";
			else if (ac.dataset.editSavedUrl !== void 0) {
				document.querySelectorAll("[name=\"__SiSavedUrl\"], [name=\"__SiPkf\"], [name=\"__SiPk\"]").forEach((el) => el.remove());
				const url = document.createElement("input");
				url.type = "hidden";
				url.id = "__SiSavedUrl";
				url.name = "__SiSavedUrl";
				url.value = ac.dataset.editSavedUrl;
				form.appendChild(url);
				const pkf = document.createElement("input");
				pkf.type = "hidden";
				pkf.id = "__SiPkf";
				pkf.name = "__SiPkf";
				pkf.value = idEsc;
				form.appendChild(pkf);
				const pk = document.createElement("input");
				pk.type = "hidden";
				pk.id = "__SiPk";
				pk.name = "__SiPk";
				pk.value = val.value;
				form.appendChild(pk);
				if (ac.dataset.pageReturnEditFields !== void 0) {
					var value = ac.dataset.pageReturnEditFields ?? "";
					if (value !== "") {
						var fieldsString = new DOMParser().parseFromString(value, "text/html").documentElement.textContent;
						var fields = JSON.parse(fieldsString);
						var fv = "";
						fields.forEach((e) => {
							if (e.V === "") e.V = document.getElementById(ac.dataset.pageReturnEditFields ?? "").value;
							if (fv !== "") fv += "&";
							fv += (e.F + "=" + (e.V ?? "")).replace(/"/g, "&quot;");
						});
						document.querySelectorAll("[name=\"__SiPFs\"]").forEach((el) => el.remove());
						const pfs = document.createElement("input");
						pfs.type = "hidden";
						pfs.id = "__SiPFs";
						pfs.name = "__SiPFs";
						pfs.value = fv;
						form.appendChild(pfs);
					}
				}
				if (ac.dataset.editSaveButtonName !== void 0) {
					document.querySelectorAll("[name=\"" + ac.dataset.editSaveButtonName + "\"]").forEach((el) => el.remove());
					const saveButton = document.createElement("input");
					saveButton.type = "hidden";
					saveButton.id = "__SiSaveButton";
					saveButton.name = ac.dataset.editSaveButtonName;
					saveButton.value = "1";
					form.appendChild(saveButton);
				}
			}
			var pageReturn = document.querySelector("[name=\"__SiPageReturn\"]")?.value;
			await IndexedDb.PageReturnSetAsync(String(pageReturn));
			ac.closest("form").dispatchEvent(new Event("submit"));
		}
	};
	const InitSingle = (id) => {
		document.querySelectorAll("#" + id + "_div .AutoCompleteEntry").forEach((el) => {
			el.removeEventListener("keydown", AutoCompleteEnter);
			el.removeEventListener("keyup", AutoCompleteAsync);
			el.addEventListener("keydown", AutoCompleteEnter);
			el.addEventListener("keyup", AutoCompleteAsync);
		});
		document.querySelectorAll("#" + id + "_div .AutoCompleterContainer").forEach((el) => {
			el.removeEventListener("focusout", AutoCompleteBlur);
			el.removeEventListener("focusin", AutoCompleteUnBlur);
			el.addEventListener("focusout", AutoCompleteBlur);
			el.addEventListener("focusin", AutoCompleteUnBlur);
		});
		document.querySelectorAll("#" + id + "_div .AutoCompleterResults").forEach((el) => {
			el.removeEventListener("focusout", AutoCompleteBlur);
			el.removeEventListener("focusin", AutoCompleteUnBlur);
			el.addEventListener("focusout", AutoCompleteBlur);
			el.addEventListener("focusin", AutoCompleteUnBlur);
		});
		document.querySelectorAll("#" + id + "_div .AutoCompleteEntry").forEach((el) => {
			const form = el.closest("form");
			if (form) form.dataset.autocomplete = "off";
		});
		var textBox = document.getElementById(id + "_text");
		if (textBox.dataset.initValidate === "1" || textBox.dataset.focus === "1") (async () => {
			await AutoCompleteValueTextAsync(id);
		})();
		document.querySelectorAll("#" + id + "_div [data-show-list]").forEach((el) => {
			el.addEventListener("click", async (e) => {
				var id = e.currentTarget.dataset.showList;
				await ShowListAsync(id);
			});
		});
		document.querySelectorAll("#" + id + "_div [data-autocompleter-edit]").forEach((el) => {
			el.addEventListener("click", async (e) => {
				var id = e.currentTarget.dataset.autocompleterEdit;
				await EditAsync(id);
			});
		});
	};
	return {
		AutoCompleteValueTextAsync,
		Init,
		InitSingle,
		Clear
	};
})();
document.addEventListener("DOMContentLoaded", async () => {
	await AutoCompleter.Init();
});
//#endregion
//#region Canvas/Canvas.ts
/**
* @public 
*/
var Canvas = (() => {
	const Init = () => {
		document.querySelectorAll(".CanvasBorder, [data-shareitaction=canvasClear], [data-shareitaction=canvasCancel]").forEach((el) => el.classList.add("d-none"));
		document.querySelectorAll(".ShareItCanvas").forEach((el) => {
			el.addEventListener("pointerdown", (e) => {
				if (!(e instanceof PointerEvent)) return;
				e.preventDefault();
				var canvas = e.currentTarget;
				var context = canvas.getContext("2d");
				if (!context) return;
				const ctx = context;
				var rect = canvas.getBoundingClientRect();
				var x = e.clientX - rect.left;
				var y = e.clientY - rect.top;
				context.beginPath();
				context.moveTo(x, y);
				canvas.setPointerCapture(e.pointerId);
				const paint = (ev) => {
					const px = ev.clientX - rect.left;
					const py = ev.clientY - rect.top;
					ctx.lineTo(px, py);
					ctx.stroke();
				};
				const stopPaint = () => {
					canvas.releasePointerCapture(e.pointerId);
					canvas.removeEventListener("pointermove", paint);
					canvas.removeEventListener("pointerup", stopPaint);
					canvas.removeEventListener("pointercancel", stopPaint);
				};
				canvas.addEventListener("pointermove", paint);
				canvas.addEventListener("pointerup", stopPaint);
				canvas.addEventListener("pointercancel", stopPaint);
			});
		});
		document.querySelectorAll("[data-draw]").forEach((el) => {
			el.addEventListener("click", (e) => {
				var id = e.currentTarget.dataset.draw;
				Draw(id);
			});
		});
		document.querySelectorAll("[data-clear]").forEach((el) => {
			el.addEventListener("click", (e) => {
				var id = e.currentTarget.dataset.clear;
				Clear(id);
			});
		});
		document.querySelectorAll("[data-cancel]").forEach((el) => {
			el.addEventListener("click", (e) => {
				var id = e.currentTarget.dataset.cancel;
				Cancel(id);
			});
		});
	};
	const Draw = (id) => {
		const el = document.getElementById(id + "_canvasborder");
		if (!el || el.offsetParent === null) {
			var eImg = document.getElementById(id + "_img");
			var src = eImg ? eImg.getAttribute("src") ?? "" : "";
			CanvasSetImage(id, src);
		}
		[
			id + "_canvasborder",
			id + "_clear",
			id + "_cancel"
		].forEach((e) => document.getElementById(e).classList.remove("d-none"));
		[id + "_img", id + "_draw"].forEach((e) => {
			const el = document.getElementById(e);
			if (el) el.classList.add("d-none");
		});
	};
	const CanvasSetImage = (id, url) => {
		var context = document.getElementById(id + "_canvas").getContext("2d");
		var img = new Image();
		img.onload = () => {
			context.drawImage(img, 0, 0);
		};
		img.src = url;
	};
	const Clear = (id) => {
		var canvas = document.getElementById(id + "_canvas");
		canvas.getContext("2d").clearRect(0, 0, canvas.clientWidth, canvas.clientHeight);
		var eImg = document.getElementById(id + "_img");
		const imgUrl = eImg ? eImg.dataset.defaultimageurl : "";
		if (imgUrl) CanvasSetImage(id, imgUrl);
	};
	const Cancel = (id) => {
		var canvas = document.getElementById(id + "_canvas");
		var context = canvas.getContext("2d");
		var img = new Image();
		img.onload = () => {
			context.clearRect(0, 0, canvas.clientWidth, canvas.clientHeight);
			context.drawImage(img, 0, 0);
		};
		var eImg = document.getElementById(id + "_img");
		img.src = eImg ? eImg.getAttribute("src") ?? "" : "";
		[
			id + "_canvasborder",
			id + "_clear",
			id + "_cancel"
		].forEach((e) => document.getElementById(e).classList.add("d-none"));
		[id + "_img", id + "_draw"].forEach((e) => {
			const el = document.getElementById(e);
			if (el) el.classList.remove("d-none");
		});
	};
	return { Init };
})();
document.addEventListener("DOMContentLoaded", () => {
	Canvas.Init();
});
//#endregion
//#region node_modules/flatpickr/dist/esm/types/options.js
var HOOKS = [
	"onChange",
	"onClose",
	"onDayCreate",
	"onDestroy",
	"onKeyDown",
	"onMonthChange",
	"onOpen",
	"onParseConfig",
	"onReady",
	"onValueUpdate",
	"onYearChange",
	"onPreCalendarPosition"
];
var defaults = {
	_disable: [],
	allowInput: false,
	allowInvalidPreload: false,
	altFormat: "F j, Y",
	altInput: false,
	altInputClass: "form-control input",
	animate: typeof window === "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
	ariaDateFormat: "F j, Y",
	autoFillDefaultTime: true,
	clickOpens: true,
	closeOnSelect: true,
	conjunction: ", ",
	dateFormat: "Y-m-d",
	defaultHour: 12,
	defaultMinute: 0,
	defaultSeconds: 0,
	disable: [],
	disableMobile: false,
	enableSeconds: false,
	enableTime: false,
	errorHandler: function(err) {
		return typeof console !== "undefined" && console.warn(err);
	},
	getWeek: function(givenDate) {
		var date = new Date(givenDate.getTime());
		date.setHours(0, 0, 0, 0);
		date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
		var week1 = new Date(date.getFullYear(), 0, 4);
		return 1 + Math.round(((date.getTime() - week1.getTime()) / 864e5 - 3 + (week1.getDay() + 6) % 7) / 7);
	},
	hourIncrement: 1,
	ignoredFocusElements: [],
	inline: false,
	locale: "default",
	minuteIncrement: 5,
	mode: "single",
	monthSelectorType: "dropdown",
	nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
	noCalendar: false,
	now: /* @__PURE__ */ new Date(),
	onChange: [],
	onClose: [],
	onDayCreate: [],
	onDestroy: [],
	onKeyDown: [],
	onMonthChange: [],
	onOpen: [],
	onParseConfig: [],
	onReady: [],
	onValueUpdate: [],
	onYearChange: [],
	onPreCalendarPosition: [],
	plugins: [],
	position: "auto",
	positionElement: void 0,
	prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
	shorthandCurrentMonth: false,
	showMonths: 1,
	static: false,
	time_24hr: false,
	weekNumbers: false,
	wrap: false
};
//#endregion
//#region node_modules/flatpickr/dist/esm/l10n/default.js
var english = {
	weekdays: {
		shorthand: [
			"Sun",
			"Mon",
			"Tue",
			"Wed",
			"Thu",
			"Fri",
			"Sat"
		],
		longhand: [
			"Sunday",
			"Monday",
			"Tuesday",
			"Wednesday",
			"Thursday",
			"Friday",
			"Saturday"
		]
	},
	months: {
		shorthand: [
			"Jan",
			"Feb",
			"Mar",
			"Apr",
			"May",
			"Jun",
			"Jul",
			"Aug",
			"Sep",
			"Oct",
			"Nov",
			"Dec"
		],
		longhand: [
			"January",
			"February",
			"March",
			"April",
			"May",
			"June",
			"July",
			"August",
			"September",
			"October",
			"November",
			"December"
		]
	},
	daysInMonth: [
		31,
		28,
		31,
		30,
		31,
		30,
		31,
		31,
		30,
		31,
		30,
		31
	],
	firstDayOfWeek: 0,
	ordinal: function(nth) {
		var s = nth % 100;
		if (s > 3 && s < 21) return "th";
		switch (s % 10) {
			case 1: return "st";
			case 2: return "nd";
			case 3: return "rd";
			default: return "th";
		}
	},
	rangeSeparator: " to ",
	weekAbbreviation: "Wk",
	scrollTitle: "Scroll to increment",
	toggleTitle: "Click to toggle",
	amPM: ["AM", "PM"],
	yearAriaLabel: "Year",
	monthAriaLabel: "Month",
	hourAriaLabel: "Hour",
	minuteAriaLabel: "Minute",
	time_24hr: false
};
//#endregion
//#region node_modules/flatpickr/dist/esm/utils/index.js
var pad = function(number, length) {
	if (length === void 0) length = 2;
	return ("000" + number).slice(length * -1);
};
var int = function(bool) {
	return bool === true ? 1 : 0;
};
function debounce(fn, wait) {
	var t;
	return function() {
		var _this = this;
		var args = arguments;
		clearTimeout(t);
		t = setTimeout(function() {
			return fn.apply(_this, args);
		}, wait);
	};
}
var arrayify = function(obj) {
	return obj instanceof Array ? obj : [obj];
};
//#endregion
//#region node_modules/flatpickr/dist/esm/utils/dom.js
function toggleClass(elem, className, bool) {
	if (bool === true) return elem.classList.add(className);
	elem.classList.remove(className);
}
function createElement(tag, className, content) {
	var e = window.document.createElement(tag);
	className = className || "";
	content = content || "";
	e.className = className;
	if (content !== void 0) e.textContent = content;
	return e;
}
function clearNode(node) {
	while (node.firstChild) node.removeChild(node.firstChild);
}
function findParent(node, condition) {
	if (condition(node)) return node;
	else if (node.parentNode) return findParent(node.parentNode, condition);
}
function createNumberInput(inputClassName, opts) {
	var wrapper = createElement("div", "numInputWrapper"), numInput = createElement("input", "numInput " + inputClassName), arrowUp = createElement("span", "arrowUp"), arrowDown = createElement("span", "arrowDown");
	if (navigator.userAgent.indexOf("MSIE 9.0") === -1) numInput.type = "number";
	else {
		numInput.type = "text";
		numInput.pattern = "\\d*";
	}
	if (opts !== void 0) for (var key in opts) numInput.setAttribute(key, opts[key]);
	wrapper.appendChild(numInput);
	wrapper.appendChild(arrowUp);
	wrapper.appendChild(arrowDown);
	return wrapper;
}
function getEventTarget(event) {
	try {
		if (typeof event.composedPath === "function") return event.composedPath()[0];
		return event.target;
	} catch (error) {
		return event.target;
	}
}
//#endregion
//#region node_modules/flatpickr/dist/esm/utils/formatting.js
var doNothing = function() {};
var monthToStr = function(monthNumber, shorthand, locale) {
	return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
};
var revFormat = {
	D: doNothing,
	F: function(dateObj, monthName, locale) {
		dateObj.setMonth(locale.months.longhand.indexOf(monthName));
	},
	G: function(dateObj, hour) {
		dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
	},
	H: function(dateObj, hour) {
		dateObj.setHours(parseFloat(hour));
	},
	J: function(dateObj, day) {
		dateObj.setDate(parseFloat(day));
	},
	K: function(dateObj, amPM, locale) {
		dateObj.setHours(dateObj.getHours() % 12 + 12 * int(new RegExp(locale.amPM[1], "i").test(amPM)));
	},
	M: function(dateObj, shortMonth, locale) {
		dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
	},
	S: function(dateObj, seconds) {
		dateObj.setSeconds(parseFloat(seconds));
	},
	U: function(_, unixSeconds) {
		return /* @__PURE__ */ new Date(parseFloat(unixSeconds) * 1e3);
	},
	W: function(dateObj, weekNum, locale) {
		var weekNumber = parseInt(weekNum);
		var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
		date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
		return date;
	},
	Y: function(dateObj, year) {
		dateObj.setFullYear(parseFloat(year));
	},
	Z: function(_, ISODate) {
		return new Date(ISODate);
	},
	d: function(dateObj, day) {
		dateObj.setDate(parseFloat(day));
	},
	h: function(dateObj, hour) {
		dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
	},
	i: function(dateObj, minutes) {
		dateObj.setMinutes(parseFloat(minutes));
	},
	j: function(dateObj, day) {
		dateObj.setDate(parseFloat(day));
	},
	l: doNothing,
	m: function(dateObj, month) {
		dateObj.setMonth(parseFloat(month) - 1);
	},
	n: function(dateObj, month) {
		dateObj.setMonth(parseFloat(month) - 1);
	},
	s: function(dateObj, seconds) {
		dateObj.setSeconds(parseFloat(seconds));
	},
	u: function(_, unixMillSeconds) {
		return new Date(parseFloat(unixMillSeconds));
	},
	w: doNothing,
	y: function(dateObj, year) {
		dateObj.setFullYear(2e3 + parseFloat(year));
	}
};
var tokenRegex = {
	D: "",
	F: "",
	G: "(\\d\\d|\\d)",
	H: "(\\d\\d|\\d)",
	J: "(\\d\\d|\\d)\\w+",
	K: "",
	M: "",
	S: "(\\d\\d|\\d)",
	U: "(.+)",
	W: "(\\d\\d|\\d)",
	Y: "(\\d{4})",
	Z: "(.+)",
	d: "(\\d\\d|\\d)",
	h: "(\\d\\d|\\d)",
	i: "(\\d\\d|\\d)",
	j: "(\\d\\d|\\d)",
	l: "",
	m: "(\\d\\d|\\d)",
	n: "(\\d\\d|\\d)",
	s: "(\\d\\d|\\d)",
	u: "(.+)",
	w: "(\\d\\d|\\d)",
	y: "(\\d{2})"
};
var formats = {
	Z: function(date) {
		return date.toISOString();
	},
	D: function(date, locale, options) {
		return locale.weekdays.shorthand[formats.w(date, locale, options)];
	},
	F: function(date, locale, options) {
		return monthToStr(formats.n(date, locale, options) - 1, false, locale);
	},
	G: function(date, locale, options) {
		return pad(formats.h(date, locale, options));
	},
	H: function(date) {
		return pad(date.getHours());
	},
	J: function(date, locale) {
		return locale.ordinal !== void 0 ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
	},
	K: function(date, locale) {
		return locale.amPM[int(date.getHours() > 11)];
	},
	M: function(date, locale) {
		return monthToStr(date.getMonth(), true, locale);
	},
	S: function(date) {
		return pad(date.getSeconds());
	},
	U: function(date) {
		return date.getTime() / 1e3;
	},
	W: function(date, _, options) {
		return options.getWeek(date);
	},
	Y: function(date) {
		return pad(date.getFullYear(), 4);
	},
	d: function(date) {
		return pad(date.getDate());
	},
	h: function(date) {
		return date.getHours() % 12 ? date.getHours() % 12 : 12;
	},
	i: function(date) {
		return pad(date.getMinutes());
	},
	j: function(date) {
		return date.getDate();
	},
	l: function(date, locale) {
		return locale.weekdays.longhand[date.getDay()];
	},
	m: function(date) {
		return pad(date.getMonth() + 1);
	},
	n: function(date) {
		return date.getMonth() + 1;
	},
	s: function(date) {
		return date.getSeconds();
	},
	u: function(date) {
		return date.getTime();
	},
	w: function(date) {
		return date.getDay();
	},
	y: function(date) {
		return String(date.getFullYear()).substring(2);
	}
};
//#endregion
//#region node_modules/flatpickr/dist/esm/utils/dates.js
var createDateFormatter = function(_a) {
	var _b = _a.config, config = _b === void 0 ? defaults : _b, _c = _a.l10n, l10n = _c === void 0 ? english : _c, _d = _a.isMobile, isMobile = _d === void 0 ? false : _d;
	return function(dateObj, frmt, overrideLocale) {
		var locale = overrideLocale || l10n;
		if (config.formatDate !== void 0 && !isMobile) return config.formatDate(dateObj, frmt, locale);
		return frmt.split("").map(function(c, i, arr) {
			return formats[c] && arr[i - 1] !== "\\" ? formats[c](dateObj, locale, config) : c !== "\\" ? c : "";
		}).join("");
	};
};
var createDateParser = function(_a) {
	var _b = _a.config, config = _b === void 0 ? defaults : _b, _c = _a.l10n, l10n = _c === void 0 ? english : _c;
	return function(date, givenFormat, timeless, customLocale) {
		if (date !== 0 && !date) return void 0;
		var locale = customLocale || l10n;
		var parsedDate;
		var dateOrig = date;
		if (date instanceof Date) parsedDate = new Date(date.getTime());
		else if (typeof date !== "string" && date.toFixed !== void 0) parsedDate = new Date(date);
		else if (typeof date === "string") {
			var format = givenFormat || (config || defaults).dateFormat;
			var datestr = String(date).trim();
			if (datestr === "today") {
				parsedDate = /* @__PURE__ */ new Date();
				timeless = true;
			} else if (config && config.parseDate) parsedDate = config.parseDate(date, format);
			else if (/Z$/.test(datestr) || /GMT$/.test(datestr)) parsedDate = new Date(date);
			else {
				var matched = void 0, ops = [];
				for (var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++) {
					var token = format[i];
					var isBackSlash = token === "\\";
					var escaped = format[i - 1] === "\\" || isBackSlash;
					if (tokenRegex[token] && !escaped) {
						regexStr += tokenRegex[token];
						var match = new RegExp(regexStr).exec(date);
						if (match && (matched = true)) ops[token !== "Y" ? "push" : "unshift"]({
							fn: revFormat[token],
							val: match[++matchIndex]
						});
					} else if (!isBackSlash) regexStr += ".";
				}
				parsedDate = !config || !config.noCalendar ? new Date((/* @__PURE__ */ new Date()).getFullYear(), 0, 1, 0, 0, 0, 0) : new Date((/* @__PURE__ */ new Date()).setHours(0, 0, 0, 0));
				ops.forEach(function(_a) {
					var fn = _a.fn, val = _a.val;
					return parsedDate = fn(parsedDate, val, locale) || parsedDate;
				});
				parsedDate = matched ? parsedDate : void 0;
			}
		}
		if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
			config.errorHandler(/* @__PURE__ */ new Error("Invalid date provided: " + dateOrig));
			return;
		}
		if (timeless === true) parsedDate.setHours(0, 0, 0, 0);
		return parsedDate;
	};
};
function compareDates(date1, date2, timeless) {
	if (timeless === void 0) timeless = true;
	if (timeless !== false) return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
	return date1.getTime() - date2.getTime();
}
var isBetween = function(ts, ts1, ts2) {
	return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
};
var calculateSecondsSinceMidnight = function(hours, minutes, seconds) {
	return hours * 3600 + minutes * 60 + seconds;
};
var parseSeconds = function(secondsSinceMidnight) {
	var hours = Math.floor(secondsSinceMidnight / 3600), minutes = (secondsSinceMidnight - hours * 3600) / 60;
	return [
		hours,
		minutes,
		secondsSinceMidnight - hours * 3600 - minutes * 60
	];
};
var duration = { DAY: 864e5 };
function getDefaultHours(config) {
	var hours = config.defaultHour;
	var minutes = config.defaultMinute;
	var seconds = config.defaultSeconds;
	if (config.minDate !== void 0) {
		var minHour = config.minDate.getHours();
		var minMinutes = config.minDate.getMinutes();
		var minSeconds = config.minDate.getSeconds();
		if (hours < minHour) hours = minHour;
		if (hours === minHour && minutes < minMinutes) minutes = minMinutes;
		if (hours === minHour && minutes === minMinutes && seconds < minSeconds) seconds = config.minDate.getSeconds();
	}
	if (config.maxDate !== void 0) {
		var maxHr = config.maxDate.getHours();
		var maxMinutes = config.maxDate.getMinutes();
		hours = Math.min(hours, maxHr);
		if (hours === maxHr) minutes = Math.min(maxMinutes, minutes);
		if (hours === maxHr && minutes === maxMinutes) seconds = config.maxDate.getSeconds();
	}
	return {
		hours,
		minutes,
		seconds
	};
}
//#endregion
//#region node_modules/flatpickr/dist/esm/utils/polyfills.js
if (typeof Object.assign !== "function") Object.assign = function(target) {
	var args = [];
	for (var _i = 1; _i < arguments.length; _i++) args[_i - 1] = arguments[_i];
	if (!target) throw TypeError("Cannot convert undefined or null to object");
	var _loop_1 = function(source) {
		if (source) Object.keys(source).forEach(function(key) {
			return target[key] = source[key];
		});
	};
	for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
		var source = args_1[_a];
		_loop_1(source);
	}
	return target;
};
//#endregion
//#region node_modules/flatpickr/dist/esm/index.js
var __assign = function() {
	__assign = Object.assign || function(t) {
		for (var s, i = 1, n = arguments.length; i < n; i++) {
			s = arguments[i];
			for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
		}
		return t;
	};
	return __assign.apply(this, arguments);
};
var __spreadArrays = function() {
	for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
	return r;
};
var DEBOUNCED_CHANGE_MS = 300;
function FlatpickrInstance(element, instanceConfig) {
	var self = {
		config: __assign(__assign({}, defaults), flatpickr.defaultConfig),
		l10n: english
	};
	self.parseDate = createDateParser({
		config: self.config,
		l10n: self.l10n
	});
	self._handlers = [];
	self.pluginElements = [];
	self.loadedPlugins = [];
	self._bind = bind;
	self._setHoursFromDate = setHoursFromDate;
	self._positionCalendar = positionCalendar;
	self.changeMonth = changeMonth;
	self.changeYear = changeYear;
	self.clear = clear;
	self.close = close;
	self.onMouseOver = onMouseOver;
	self._createElement = createElement;
	self.createDay = createDay;
	self.destroy = destroy;
	self.isEnabled = isEnabled;
	self.jumpToDate = jumpToDate;
	self.updateValue = updateValue;
	self.open = open;
	self.redraw = redraw;
	self.set = set;
	self.setDate = setDate;
	self.toggle = toggle;
	function setupHelperFunctions() {
		self.utils = { getDaysInMonth: function(month, yr) {
			if (month === void 0) month = self.currentMonth;
			if (yr === void 0) yr = self.currentYear;
			if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) return 29;
			return self.l10n.daysInMonth[month];
		} };
	}
	function init() {
		self.element = self.input = element;
		self.isOpen = false;
		parseConfig();
		setupLocale();
		setupInputs();
		setupDates();
		setupHelperFunctions();
		if (!self.isMobile) build();
		bindEvents();
		if (self.selectedDates.length || self.config.noCalendar) {
			if (self.config.enableTime) setHoursFromDate(self.config.noCalendar ? self.latestSelectedDateObj : void 0);
			updateValue(false);
		}
		setCalendarWidth();
		var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
		if (!self.isMobile && isSafari) positionCalendar();
		triggerEvent("onReady");
	}
	function getClosestActiveElement() {
		var _a;
		return ((_a = self.calendarContainer) === null || _a === void 0 ? void 0 : _a.getRootNode()).activeElement || document.activeElement;
	}
	function bindToInstance(fn) {
		return fn.bind(self);
	}
	function setCalendarWidth() {
		var config = self.config;
		if (config.weekNumbers === false && config.showMonths === 1) return;
		else if (config.noCalendar !== true) window.requestAnimationFrame(function() {
			if (self.calendarContainer !== void 0) {
				self.calendarContainer.style.visibility = "hidden";
				self.calendarContainer.style.display = "block";
			}
			if (self.daysContainer !== void 0) {
				var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
				self.daysContainer.style.width = daysWidth + "px";
				self.calendarContainer.style.width = daysWidth + (self.weekWrapper !== void 0 ? self.weekWrapper.offsetWidth : 0) + "px";
				self.calendarContainer.style.removeProperty("visibility");
				self.calendarContainer.style.removeProperty("display");
			}
		});
	}
	function updateTime(e) {
		if (self.selectedDates.length === 0) {
			var defaultDate = self.config.minDate === void 0 || compareDates(/* @__PURE__ */ new Date(), self.config.minDate) >= 0 ? /* @__PURE__ */ new Date() : new Date(self.config.minDate.getTime());
			var defaults = getDefaultHours(self.config);
			defaultDate.setHours(defaults.hours, defaults.minutes, defaults.seconds, defaultDate.getMilliseconds());
			self.selectedDates = [defaultDate];
			self.latestSelectedDateObj = defaultDate;
		}
		if (e !== void 0 && e.type !== "blur") timeWrapper(e);
		var prevValue = self._input.value;
		setHoursFromInputs();
		updateValue();
		if (self._input.value !== prevValue) self._debouncedChange();
	}
	function ampm2military(hour, amPM) {
		return hour % 12 + 12 * int(amPM === self.l10n.amPM[1]);
	}
	function military2ampm(hour) {
		switch (hour % 24) {
			case 0:
			case 12: return 12;
			default: return hour % 12;
		}
	}
	function setHoursFromInputs() {
		if (self.hourElement === void 0 || self.minuteElement === void 0) return;
		var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60, seconds = self.secondElement !== void 0 ? (parseInt(self.secondElement.value, 10) || 0) % 60 : 0;
		if (self.amPM !== void 0) hours = ampm2military(hours, self.amPM.textContent);
		var limitMinHours = self.config.minTime !== void 0 || self.config.minDate && self.minDateHasTime && self.latestSelectedDateObj && compareDates(self.latestSelectedDateObj, self.config.minDate, true) === 0;
		var limitMaxHours = self.config.maxTime !== void 0 || self.config.maxDate && self.maxDateHasTime && self.latestSelectedDateObj && compareDates(self.latestSelectedDateObj, self.config.maxDate, true) === 0;
		if (self.config.maxTime !== void 0 && self.config.minTime !== void 0 && self.config.minTime > self.config.maxTime) {
			var minBound = calculateSecondsSinceMidnight(self.config.minTime.getHours(), self.config.minTime.getMinutes(), self.config.minTime.getSeconds());
			var maxBound = calculateSecondsSinceMidnight(self.config.maxTime.getHours(), self.config.maxTime.getMinutes(), self.config.maxTime.getSeconds());
			var currentTime = calculateSecondsSinceMidnight(hours, minutes, seconds);
			if (currentTime > maxBound && currentTime < minBound) {
				var result = parseSeconds(minBound);
				hours = result[0];
				minutes = result[1];
				seconds = result[2];
			}
		} else {
			if (limitMaxHours) {
				var maxTime = self.config.maxTime !== void 0 ? self.config.maxTime : self.config.maxDate;
				hours = Math.min(hours, maxTime.getHours());
				if (hours === maxTime.getHours()) minutes = Math.min(minutes, maxTime.getMinutes());
				if (minutes === maxTime.getMinutes()) seconds = Math.min(seconds, maxTime.getSeconds());
			}
			if (limitMinHours) {
				var minTime = self.config.minTime !== void 0 ? self.config.minTime : self.config.minDate;
				hours = Math.max(hours, minTime.getHours());
				if (hours === minTime.getHours() && minutes < minTime.getMinutes()) minutes = minTime.getMinutes();
				if (minutes === minTime.getMinutes()) seconds = Math.max(seconds, minTime.getSeconds());
			}
		}
		setHours(hours, minutes, seconds);
	}
	function setHoursFromDate(dateObj) {
		var date = dateObj || self.latestSelectedDateObj;
		if (date && date instanceof Date) setHours(date.getHours(), date.getMinutes(), date.getSeconds());
	}
	function setHours(hours, minutes, seconds) {
		if (self.latestSelectedDateObj !== void 0) self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
		if (!self.hourElement || !self.minuteElement || self.isMobile) return;
		self.hourElement.value = pad(!self.config.time_24hr ? (12 + hours) % 12 + 12 * int(hours % 12 === 0) : hours);
		self.minuteElement.value = pad(minutes);
		if (self.amPM !== void 0) self.amPM.textContent = self.l10n.amPM[int(hours >= 12)];
		if (self.secondElement !== void 0) self.secondElement.value = pad(seconds);
	}
	function onYearInput(event) {
		var eventTarget = getEventTarget(event);
		var year = parseInt(eventTarget.value) + (event.delta || 0);
		if (year / 1e3 > 1 || event.key === "Enter" && !/[^\d]/.test(year.toString())) changeYear(year);
	}
	function bind(element, event, handler, options) {
		if (event instanceof Array) return event.forEach(function(ev) {
			return bind(element, ev, handler, options);
		});
		if (element instanceof Array) return element.forEach(function(el) {
			return bind(el, event, handler, options);
		});
		element.addEventListener(event, handler, options);
		self._handlers.push({ remove: function() {
			return element.removeEventListener(event, handler, options);
		} });
	}
	function triggerChange() {
		triggerEvent("onChange");
	}
	function bindEvents() {
		if (self.config.wrap) [
			"open",
			"close",
			"toggle",
			"clear"
		].forEach(function(evt) {
			Array.prototype.forEach.call(self.element.querySelectorAll("[data-" + evt + "]"), function(el) {
				return bind(el, "click", self[evt]);
			});
		});
		if (self.isMobile) {
			setupMobile();
			return;
		}
		var debouncedResize = debounce(onResize, 50);
		self._debouncedChange = debounce(triggerChange, DEBOUNCED_CHANGE_MS);
		if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent)) bind(self.daysContainer, "mouseover", function(e) {
			if (self.config.mode === "range") onMouseOver(getEventTarget(e));
		});
		bind(self._input, "keydown", onKeyDown);
		if (self.calendarContainer !== void 0) bind(self.calendarContainer, "keydown", onKeyDown);
		if (!self.config.inline && !self.config.static) bind(window, "resize", debouncedResize);
		if (window.ontouchstart !== void 0) bind(window.document, "touchstart", documentClick);
		else bind(window.document, "mousedown", documentClick);
		bind(window.document, "focus", documentClick, { capture: true });
		if (self.config.clickOpens === true) {
			bind(self._input, "focus", self.open);
			bind(self._input, "click", self.open);
		}
		if (self.daysContainer !== void 0) {
			bind(self.monthNav, "click", onMonthNavClick);
			bind(self.monthNav, ["keyup", "increment"], onYearInput);
			bind(self.daysContainer, "click", selectDate);
		}
		if (self.timeContainer !== void 0 && self.minuteElement !== void 0 && self.hourElement !== void 0) {
			var selText = function(e) {
				return getEventTarget(e).select();
			};
			bind(self.timeContainer, ["increment"], updateTime);
			bind(self.timeContainer, "blur", updateTime, { capture: true });
			bind(self.timeContainer, "click", timeIncrement);
			bind([self.hourElement, self.minuteElement], ["focus", "click"], selText);
			if (self.secondElement !== void 0) bind(self.secondElement, "focus", function() {
				return self.secondElement && self.secondElement.select();
			});
			if (self.amPM !== void 0) bind(self.amPM, "click", function(e) {
				updateTime(e);
			});
		}
		if (self.config.allowInput) bind(self._input, "blur", onBlur);
	}
	function jumpToDate(jumpDate, triggerChange) {
		var jumpTo = jumpDate !== void 0 ? self.parseDate(jumpDate) : self.latestSelectedDateObj || (self.config.minDate && self.config.minDate > self.now ? self.config.minDate : self.config.maxDate && self.config.maxDate < self.now ? self.config.maxDate : self.now);
		var oldYear = self.currentYear;
		var oldMonth = self.currentMonth;
		try {
			if (jumpTo !== void 0) {
				self.currentYear = jumpTo.getFullYear();
				self.currentMonth = jumpTo.getMonth();
			}
		} catch (e) {
			e.message = "Invalid date supplied: " + jumpTo;
			self.config.errorHandler(e);
		}
		if (triggerChange && self.currentYear !== oldYear) {
			triggerEvent("onYearChange");
			buildMonthSwitch();
		}
		if (triggerChange && (self.currentYear !== oldYear || self.currentMonth !== oldMonth)) triggerEvent("onMonthChange");
		self.redraw();
	}
	function timeIncrement(e) {
		var eventTarget = getEventTarget(e);
		if (~eventTarget.className.indexOf("arrow")) incrementNumInput(e, eventTarget.classList.contains("arrowUp") ? 1 : -1);
	}
	function incrementNumInput(e, delta, inputElem) {
		var target = e && getEventTarget(e);
		var input = inputElem || target && target.parentNode && target.parentNode.firstChild;
		var event = createEvent("increment");
		event.delta = delta;
		input && input.dispatchEvent(event);
	}
	function build() {
		var fragment = window.document.createDocumentFragment();
		self.calendarContainer = createElement("div", "flatpickr-calendar");
		self.calendarContainer.tabIndex = -1;
		if (!self.config.noCalendar) {
			fragment.appendChild(buildMonthNav());
			self.innerContainer = createElement("div", "flatpickr-innerContainer");
			if (self.config.weekNumbers) {
				var _a = buildWeeks(), weekWrapper = _a.weekWrapper, weekNumbers = _a.weekNumbers;
				self.innerContainer.appendChild(weekWrapper);
				self.weekNumbers = weekNumbers;
				self.weekWrapper = weekWrapper;
			}
			self.rContainer = createElement("div", "flatpickr-rContainer");
			self.rContainer.appendChild(buildWeekdays());
			if (!self.daysContainer) {
				self.daysContainer = createElement("div", "flatpickr-days");
				self.daysContainer.tabIndex = -1;
			}
			buildDays();
			self.rContainer.appendChild(self.daysContainer);
			self.innerContainer.appendChild(self.rContainer);
			fragment.appendChild(self.innerContainer);
		}
		if (self.config.enableTime) fragment.appendChild(buildTime());
		toggleClass(self.calendarContainer, "rangeMode", self.config.mode === "range");
		toggleClass(self.calendarContainer, "animate", self.config.animate === true);
		toggleClass(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
		self.calendarContainer.appendChild(fragment);
		var customAppend = self.config.appendTo !== void 0 && self.config.appendTo.nodeType !== void 0;
		if (self.config.inline || self.config.static) {
			self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
			if (self.config.inline) {
				if (!customAppend && self.element.parentNode) self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);
				else if (self.config.appendTo !== void 0) self.config.appendTo.appendChild(self.calendarContainer);
			}
			if (self.config.static) {
				var wrapper = createElement("div", "flatpickr-wrapper");
				if (self.element.parentNode) self.element.parentNode.insertBefore(wrapper, self.element);
				wrapper.appendChild(self.element);
				if (self.altInput) wrapper.appendChild(self.altInput);
				wrapper.appendChild(self.calendarContainer);
			}
		}
		if (!self.config.static && !self.config.inline) (self.config.appendTo !== void 0 ? self.config.appendTo : window.document.body).appendChild(self.calendarContainer);
	}
	function createDay(className, date, _dayNumber, i) {
		var dateIsEnabled = isEnabled(date, true), dayElement = createElement("span", className, date.getDate().toString());
		dayElement.dateObj = date;
		dayElement.$i = i;
		dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));
		if (className.indexOf("hidden") === -1 && compareDates(date, self.now) === 0) {
			self.todayDateElem = dayElement;
			dayElement.classList.add("today");
			dayElement.setAttribute("aria-current", "date");
		}
		if (dateIsEnabled) {
			dayElement.tabIndex = -1;
			if (isDateSelected(date)) {
				dayElement.classList.add("selected");
				self.selectedDateElem = dayElement;
				if (self.config.mode === "range") {
					toggleClass(dayElement, "startRange", self.selectedDates[0] && compareDates(date, self.selectedDates[0], true) === 0);
					toggleClass(dayElement, "endRange", self.selectedDates[1] && compareDates(date, self.selectedDates[1], true) === 0);
					if (className === "nextMonthDay") dayElement.classList.add("inRange");
				}
			}
		} else dayElement.classList.add("flatpickr-disabled");
		if (self.config.mode === "range") {
			if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");
		}
		if (self.weekNumbers && self.config.showMonths === 1 && className !== "prevMonthDay" && i % 7 === 6) self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
		triggerEvent("onDayCreate", dayElement);
		return dayElement;
	}
	function focusOnDayElem(targetNode) {
		targetNode.focus();
		if (self.config.mode === "range") onMouseOver(targetNode);
	}
	function getFirstAvailableDay(delta) {
		var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
		var endMonth = delta > 0 ? self.config.showMonths : -1;
		for (var m = startMonth; m != endMonth; m += delta) {
			var month = self.daysContainer.children[m];
			var startIndex = delta > 0 ? 0 : month.children.length - 1;
			var endIndex = delta > 0 ? month.children.length : -1;
			for (var i = startIndex; i != endIndex; i += delta) {
				var c = month.children[i];
				if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj)) return c;
			}
		}
	}
	function getNextAvailableDay(current, delta) {
		var givenMonth = current.className.indexOf("Month") === -1 ? current.dateObj.getMonth() : self.currentMonth;
		var endMonth = delta > 0 ? self.config.showMonths : -1;
		var loopDelta = delta > 0 ? 1 : -1;
		for (var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta) {
			var month = self.daysContainer.children[m];
			var startIndex = givenMonth - self.currentMonth === m ? current.$i + delta : delta < 0 ? month.children.length - 1 : 0;
			var numMonthDays = month.children.length;
			for (var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta) {
				var c = month.children[i];
				if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj) && Math.abs(current.$i - i) >= Math.abs(delta)) return focusOnDayElem(c);
			}
		}
		self.changeMonth(loopDelta);
		focusOnDay(getFirstAvailableDay(loopDelta), 0);
	}
	function focusOnDay(current, offset) {
		var activeElement = getClosestActiveElement();
		var dayFocused = isInView(activeElement || document.body);
		var startElem = current !== void 0 ? current : dayFocused ? activeElement : self.selectedDateElem !== void 0 && isInView(self.selectedDateElem) ? self.selectedDateElem : self.todayDateElem !== void 0 && isInView(self.todayDateElem) ? self.todayDateElem : getFirstAvailableDay(offset > 0 ? 1 : -1);
		if (startElem === void 0) self._input.focus();
		else if (!dayFocused) focusOnDayElem(startElem);
		else getNextAvailableDay(startElem, offset);
	}
	function buildMonthDays(year, month) {
		var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
		var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12, year);
		var daysInMonth = self.utils.getDaysInMonth(month, year), days = window.document.createDocumentFragment(), isMultiMonth = self.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay", nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
		var dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
		for (; dayNumber <= prevMonthDays; dayNumber++, dayIndex++) days.appendChild(createDay("flatpickr-day " + prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
		for (dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++) days.appendChild(createDay("flatpickr-day", new Date(year, month, dayNumber), dayNumber, dayIndex));
		for (var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth && (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++) days.appendChild(createDay("flatpickr-day " + nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
		var dayContainer = createElement("div", "dayContainer");
		dayContainer.appendChild(days);
		return dayContainer;
	}
	function buildDays() {
		if (self.daysContainer === void 0) return;
		clearNode(self.daysContainer);
		if (self.weekNumbers) clearNode(self.weekNumbers);
		var frag = document.createDocumentFragment();
		for (var i = 0; i < self.config.showMonths; i++) {
			var d = new Date(self.currentYear, self.currentMonth, 1);
			d.setMonth(self.currentMonth + i);
			frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
		}
		self.daysContainer.appendChild(frag);
		self.days = self.daysContainer.firstChild;
		if (self.config.mode === "range" && self.selectedDates.length === 1) onMouseOver();
	}
	function buildMonthSwitch() {
		if (self.config.showMonths > 1 || self.config.monthSelectorType !== "dropdown") return;
		var shouldBuildMonth = function(month) {
			if (self.config.minDate !== void 0 && self.currentYear === self.config.minDate.getFullYear() && month < self.config.minDate.getMonth()) return false;
			return !(self.config.maxDate !== void 0 && self.currentYear === self.config.maxDate.getFullYear() && month > self.config.maxDate.getMonth());
		};
		self.monthsDropdownContainer.tabIndex = -1;
		self.monthsDropdownContainer.innerHTML = "";
		for (var i = 0; i < 12; i++) {
			if (!shouldBuildMonth(i)) continue;
			var month = createElement("option", "flatpickr-monthDropdown-month");
			month.value = new Date(self.currentYear, i).getMonth().toString();
			month.textContent = monthToStr(i, self.config.shorthandCurrentMonth, self.l10n);
			month.tabIndex = -1;
			if (self.currentMonth === i) month.selected = true;
			self.monthsDropdownContainer.appendChild(month);
		}
	}
	function buildMonth() {
		var container = createElement("div", "flatpickr-month");
		var monthNavFragment = window.document.createDocumentFragment();
		var monthElement;
		if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") monthElement = createElement("span", "cur-month");
		else {
			self.monthsDropdownContainer = createElement("select", "flatpickr-monthDropdown-months");
			self.monthsDropdownContainer.setAttribute("aria-label", self.l10n.monthAriaLabel);
			bind(self.monthsDropdownContainer, "change", function(e) {
				var target = getEventTarget(e);
				var selectedMonth = parseInt(target.value, 10);
				self.changeMonth(selectedMonth - self.currentMonth);
				triggerEvent("onMonthChange");
			});
			buildMonthSwitch();
			monthElement = self.monthsDropdownContainer;
		}
		var yearInput = createNumberInput("cur-year", { tabindex: "-1" });
		var yearElement = yearInput.getElementsByTagName("input")[0];
		yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);
		if (self.config.minDate) yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
		if (self.config.maxDate) {
			yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
			yearElement.disabled = !!self.config.minDate && self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
		}
		var currentMonth = createElement("div", "flatpickr-current-month");
		currentMonth.appendChild(monthElement);
		currentMonth.appendChild(yearInput);
		monthNavFragment.appendChild(currentMonth);
		container.appendChild(monthNavFragment);
		return {
			container,
			yearElement,
			monthElement
		};
	}
	function buildMonths() {
		clearNode(self.monthNav);
		self.monthNav.appendChild(self.prevMonthNav);
		if (self.config.showMonths) {
			self.yearElements = [];
			self.monthElements = [];
		}
		for (var m = self.config.showMonths; m--;) {
			var month = buildMonth();
			self.yearElements.push(month.yearElement);
			self.monthElements.push(month.monthElement);
			self.monthNav.appendChild(month.container);
		}
		self.monthNav.appendChild(self.nextMonthNav);
	}
	function buildMonthNav() {
		self.monthNav = createElement("div", "flatpickr-months");
		self.yearElements = [];
		self.monthElements = [];
		self.prevMonthNav = createElement("span", "flatpickr-prev-month");
		self.prevMonthNav.innerHTML = self.config.prevArrow;
		self.nextMonthNav = createElement("span", "flatpickr-next-month");
		self.nextMonthNav.innerHTML = self.config.nextArrow;
		buildMonths();
		Object.defineProperty(self, "_hidePrevMonthArrow", {
			get: function() {
				return self.__hidePrevMonthArrow;
			},
			set: function(bool) {
				if (self.__hidePrevMonthArrow !== bool) {
					toggleClass(self.prevMonthNav, "flatpickr-disabled", bool);
					self.__hidePrevMonthArrow = bool;
				}
			}
		});
		Object.defineProperty(self, "_hideNextMonthArrow", {
			get: function() {
				return self.__hideNextMonthArrow;
			},
			set: function(bool) {
				if (self.__hideNextMonthArrow !== bool) {
					toggleClass(self.nextMonthNav, "flatpickr-disabled", bool);
					self.__hideNextMonthArrow = bool;
				}
			}
		});
		self.currentYearElement = self.yearElements[0];
		updateNavigationCurrentMonth();
		return self.monthNav;
	}
	function buildTime() {
		self.calendarContainer.classList.add("hasTime");
		if (self.config.noCalendar) self.calendarContainer.classList.add("noCalendar");
		var defaults = getDefaultHours(self.config);
		self.timeContainer = createElement("div", "flatpickr-time");
		self.timeContainer.tabIndex = -1;
		var separator = createElement("span", "flatpickr-time-separator", ":");
		var hourInput = createNumberInput("flatpickr-hour", { "aria-label": self.l10n.hourAriaLabel });
		self.hourElement = hourInput.getElementsByTagName("input")[0];
		var minuteInput = createNumberInput("flatpickr-minute", { "aria-label": self.l10n.minuteAriaLabel });
		self.minuteElement = minuteInput.getElementsByTagName("input")[0];
		self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
		self.hourElement.value = pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getHours() : self.config.time_24hr ? defaults.hours : military2ampm(defaults.hours));
		self.minuteElement.value = pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getMinutes() : defaults.minutes);
		self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
		self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
		self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
		self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
		self.hourElement.setAttribute("maxlength", "2");
		self.minuteElement.setAttribute("min", "0");
		self.minuteElement.setAttribute("max", "59");
		self.minuteElement.setAttribute("maxlength", "2");
		self.timeContainer.appendChild(hourInput);
		self.timeContainer.appendChild(separator);
		self.timeContainer.appendChild(minuteInput);
		if (self.config.time_24hr) self.timeContainer.classList.add("time24hr");
		if (self.config.enableSeconds) {
			self.timeContainer.classList.add("hasSeconds");
			var secondInput = createNumberInput("flatpickr-second");
			self.secondElement = secondInput.getElementsByTagName("input")[0];
			self.secondElement.value = pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getSeconds() : defaults.seconds);
			self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
			self.secondElement.setAttribute("min", "0");
			self.secondElement.setAttribute("max", "59");
			self.secondElement.setAttribute("maxlength", "2");
			self.timeContainer.appendChild(createElement("span", "flatpickr-time-separator", ":"));
			self.timeContainer.appendChild(secondInput);
		}
		if (!self.config.time_24hr) {
			self.amPM = createElement("span", "flatpickr-am-pm", self.l10n.amPM[int((self.latestSelectedDateObj ? self.hourElement.value : self.config.defaultHour) > 11)]);
			self.amPM.title = self.l10n.toggleTitle;
			self.amPM.tabIndex = -1;
			self.timeContainer.appendChild(self.amPM);
		}
		return self.timeContainer;
	}
	function buildWeekdays() {
		if (!self.weekdayContainer) self.weekdayContainer = createElement("div", "flatpickr-weekdays");
		else clearNode(self.weekdayContainer);
		for (var i = self.config.showMonths; i--;) {
			var container = createElement("div", "flatpickr-weekdaycontainer");
			self.weekdayContainer.appendChild(container);
		}
		updateWeekdays();
		return self.weekdayContainer;
	}
	function updateWeekdays() {
		if (!self.weekdayContainer) return;
		var firstDayOfWeek = self.l10n.firstDayOfWeek;
		var weekdays = __spreadArrays(self.l10n.weekdays.shorthand);
		if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) weekdays = __spreadArrays(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
		for (var i = self.config.showMonths; i--;) self.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
	}
	function buildWeeks() {
		self.calendarContainer.classList.add("hasWeeks");
		var weekWrapper = createElement("div", "flatpickr-weekwrapper");
		weekWrapper.appendChild(createElement("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
		var weekNumbers = createElement("div", "flatpickr-weeks");
		weekWrapper.appendChild(weekNumbers);
		return {
			weekWrapper,
			weekNumbers
		};
	}
	function changeMonth(value, isOffset) {
		if (isOffset === void 0) isOffset = true;
		var delta = isOffset ? value : value - self.currentMonth;
		if (delta < 0 && self._hidePrevMonthArrow === true || delta > 0 && self._hideNextMonthArrow === true) return;
		self.currentMonth += delta;
		if (self.currentMonth < 0 || self.currentMonth > 11) {
			self.currentYear += self.currentMonth > 11 ? 1 : -1;
			self.currentMonth = (self.currentMonth + 12) % 12;
			triggerEvent("onYearChange");
			buildMonthSwitch();
		}
		buildDays();
		triggerEvent("onMonthChange");
		updateNavigationCurrentMonth();
	}
	function clear(triggerChangeEvent, toInitial) {
		if (triggerChangeEvent === void 0) triggerChangeEvent = true;
		if (toInitial === void 0) toInitial = true;
		self.input.value = "";
		if (self.altInput !== void 0) self.altInput.value = "";
		if (self.mobileInput !== void 0) self.mobileInput.value = "";
		self.selectedDates = [];
		self.latestSelectedDateObj = void 0;
		if (toInitial === true) {
			self.currentYear = self._initialDate.getFullYear();
			self.currentMonth = self._initialDate.getMonth();
		}
		if (self.config.enableTime === true) {
			var _a = getDefaultHours(self.config), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
			setHours(hours, minutes, seconds);
		}
		self.redraw();
		if (triggerChangeEvent) triggerEvent("onChange");
	}
	function close() {
		self.isOpen = false;
		if (!self.isMobile) {
			if (self.calendarContainer !== void 0) self.calendarContainer.classList.remove("open");
			if (self._input !== void 0) self._input.classList.remove("active");
		}
		triggerEvent("onClose");
	}
	function destroy() {
		if (self.config !== void 0) triggerEvent("onDestroy");
		for (var i = self._handlers.length; i--;) self._handlers[i].remove();
		self._handlers = [];
		if (self.mobileInput) {
			if (self.mobileInput.parentNode) self.mobileInput.parentNode.removeChild(self.mobileInput);
			self.mobileInput = void 0;
		} else if (self.calendarContainer && self.calendarContainer.parentNode) {
			if (self.config.static && self.calendarContainer.parentNode) {
				var wrapper = self.calendarContainer.parentNode;
				wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
				if (wrapper.parentNode) {
					while (wrapper.firstChild) wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
					wrapper.parentNode.removeChild(wrapper);
				}
			} else self.calendarContainer.parentNode.removeChild(self.calendarContainer);
		}
		if (self.altInput) {
			self.input.type = "text";
			if (self.altInput.parentNode) self.altInput.parentNode.removeChild(self.altInput);
			delete self.altInput;
		}
		if (self.input) {
			self.input.type = self.input._type;
			self.input.classList.remove("flatpickr-input");
			self.input.removeAttribute("readonly");
		}
		[
			"_showTimeInput",
			"latestSelectedDateObj",
			"_hideNextMonthArrow",
			"_hidePrevMonthArrow",
			"__hideNextMonthArrow",
			"__hidePrevMonthArrow",
			"isMobile",
			"isOpen",
			"selectedDateElem",
			"minDateHasTime",
			"maxDateHasTime",
			"days",
			"daysContainer",
			"_input",
			"_positionElement",
			"innerContainer",
			"rContainer",
			"monthNav",
			"todayDateElem",
			"calendarContainer",
			"weekdayContainer",
			"prevMonthNav",
			"nextMonthNav",
			"monthsDropdownContainer",
			"currentMonthElement",
			"currentYearElement",
			"navigationCurrentMonth",
			"selectedDateElem",
			"config"
		].forEach(function(k) {
			try {
				delete self[k];
			} catch (_) {}
		});
	}
	function isCalendarElem(elem) {
		return self.calendarContainer.contains(elem);
	}
	function documentClick(e) {
		if (self.isOpen && !self.config.inline) {
			var eventTarget_1 = getEventTarget(e);
			var isCalendarElement = isCalendarElem(eventTarget_1);
			var lostFocus = !(eventTarget_1 === self.input || eventTarget_1 === self.altInput || self.element.contains(eventTarget_1) || e.path && e.path.indexOf && (~e.path.indexOf(self.input) || ~e.path.indexOf(self.altInput))) && !isCalendarElement && !isCalendarElem(e.relatedTarget);
			var isIgnored = !self.config.ignoredFocusElements.some(function(elem) {
				return elem.contains(eventTarget_1);
			});
			if (lostFocus && isIgnored) {
				if (self.config.allowInput) self.setDate(self._input.value, false, self.config.altInput ? self.config.altFormat : self.config.dateFormat);
				if (self.timeContainer !== void 0 && self.minuteElement !== void 0 && self.hourElement !== void 0 && self.input.value !== "" && self.input.value !== void 0) updateTime();
				self.close();
				if (self.config && self.config.mode === "range" && self.selectedDates.length === 1) self.clear(false);
			}
		}
	}
	function changeYear(newYear) {
		if (!newYear || self.config.minDate && newYear < self.config.minDate.getFullYear() || self.config.maxDate && newYear > self.config.maxDate.getFullYear()) return;
		var newYearNum = newYear, isNewYear = self.currentYear !== newYearNum;
		self.currentYear = newYearNum || self.currentYear;
		if (self.config.maxDate && self.currentYear === self.config.maxDate.getFullYear()) self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
		else if (self.config.minDate && self.currentYear === self.config.minDate.getFullYear()) self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
		if (isNewYear) {
			self.redraw();
			triggerEvent("onYearChange");
			buildMonthSwitch();
		}
	}
	function isEnabled(date, timeless) {
		var _a;
		if (timeless === void 0) timeless = true;
		var dateToCheck = self.parseDate(date, void 0, timeless);
		if (self.config.minDate && dateToCheck && compareDates(dateToCheck, self.config.minDate, timeless !== void 0 ? timeless : !self.minDateHasTime) < 0 || self.config.maxDate && dateToCheck && compareDates(dateToCheck, self.config.maxDate, timeless !== void 0 ? timeless : !self.maxDateHasTime) > 0) return false;
		if (!self.config.enable && self.config.disable.length === 0) return true;
		if (dateToCheck === void 0) return false;
		var bool = !!self.config.enable, array = (_a = self.config.enable) !== null && _a !== void 0 ? _a : self.config.disable;
		for (var i = 0, d = void 0; i < array.length; i++) {
			d = array[i];
			if (typeof d === "function" && d(dateToCheck)) return bool;
			else if (d instanceof Date && dateToCheck !== void 0 && d.getTime() === dateToCheck.getTime()) return bool;
			else if (typeof d === "string") {
				var parsed = self.parseDate(d, void 0, true);
				return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
			} else if (typeof d === "object" && dateToCheck !== void 0 && d.from && d.to && dateToCheck.getTime() >= d.from.getTime() && dateToCheck.getTime() <= d.to.getTime()) return bool;
		}
		return !bool;
	}
	function isInView(elem) {
		if (self.daysContainer !== void 0) return elem.className.indexOf("hidden") === -1 && elem.className.indexOf("flatpickr-disabled") === -1 && self.daysContainer.contains(elem);
		return false;
	}
	function onBlur(e) {
		var isInput = e.target === self._input;
		var valueChanged = self._input.value.trimEnd() !== getDateStr();
		if (isInput && valueChanged && !(e.relatedTarget && isCalendarElem(e.relatedTarget))) self.setDate(self._input.value, true, e.target === self.altInput ? self.config.altFormat : self.config.dateFormat);
	}
	function onKeyDown(e) {
		var eventTarget = getEventTarget(e);
		var isInput = self.config.wrap ? element.contains(eventTarget) : eventTarget === self._input;
		var allowInput = self.config.allowInput;
		var allowKeydown = self.isOpen && (!allowInput || !isInput);
		var allowInlineKeydown = self.config.inline && isInput && !allowInput;
		if (e.keyCode === 13 && isInput) {
			if (allowInput) {
				self.setDate(self._input.value, true, eventTarget === self.altInput ? self.config.altFormat : self.config.dateFormat);
				self.close();
				return eventTarget.blur();
			} else self.open();
		} else if (isCalendarElem(eventTarget) || allowKeydown || allowInlineKeydown) {
			var isTimeObj = !!self.timeContainer && self.timeContainer.contains(eventTarget);
			switch (e.keyCode) {
				case 13:
					if (isTimeObj) {
						e.preventDefault();
						updateTime();
						focusAndClose();
					} else selectDate(e);
					break;
				case 27:
					e.preventDefault();
					focusAndClose();
					break;
				case 8:
				case 46:
					if (isInput && !self.config.allowInput) {
						e.preventDefault();
						self.clear();
					}
					break;
				case 37:
				case 39:
					if (!isTimeObj && !isInput) {
						e.preventDefault();
						var activeElement = getClosestActiveElement();
						if (self.daysContainer !== void 0 && (allowInput === false || activeElement && isInView(activeElement))) {
							var delta_1 = e.keyCode === 39 ? 1 : -1;
							if (!e.ctrlKey) focusOnDay(void 0, delta_1);
							else {
								e.stopPropagation();
								changeMonth(delta_1);
								focusOnDay(getFirstAvailableDay(1), 0);
							}
						}
					} else if (self.hourElement) self.hourElement.focus();
					break;
				case 38:
				case 40:
					e.preventDefault();
					var delta = e.keyCode === 40 ? 1 : -1;
					if (self.daysContainer && eventTarget.$i !== void 0 || eventTarget === self.input || eventTarget === self.altInput) {
						if (e.ctrlKey) {
							e.stopPropagation();
							changeYear(self.currentYear - delta);
							focusOnDay(getFirstAvailableDay(1), 0);
						} else if (!isTimeObj) focusOnDay(void 0, delta * 7);
					} else if (eventTarget === self.currentYearElement) changeYear(self.currentYear - delta);
					else if (self.config.enableTime) {
						if (!isTimeObj && self.hourElement) self.hourElement.focus();
						updateTime(e);
						self._debouncedChange();
					}
					break;
				case 9: if (isTimeObj) {
					var elems = [
						self.hourElement,
						self.minuteElement,
						self.secondElement,
						self.amPM
					].concat(self.pluginElements).filter(function(x) {
						return x;
					});
					var i = elems.indexOf(eventTarget);
					if (i !== -1) {
						var target = elems[i + (e.shiftKey ? -1 : 1)];
						e.preventDefault();
						(target || self._input).focus();
					}
				} else if (!self.config.noCalendar && self.daysContainer && self.daysContainer.contains(eventTarget) && e.shiftKey) {
					e.preventDefault();
					self._input.focus();
				}
			}
		}
		if (self.amPM !== void 0 && eventTarget === self.amPM) switch (e.key) {
			case self.l10n.amPM[0].charAt(0):
			case self.l10n.amPM[0].charAt(0).toLowerCase():
				self.amPM.textContent = self.l10n.amPM[0];
				setHoursFromInputs();
				updateValue();
				break;
			case self.l10n.amPM[1].charAt(0):
			case self.l10n.amPM[1].charAt(0).toLowerCase():
				self.amPM.textContent = self.l10n.amPM[1];
				setHoursFromInputs();
				updateValue();
		}
		if (isInput || isCalendarElem(eventTarget)) triggerEvent("onKeyDown", e);
	}
	function onMouseOver(elem, cellClass) {
		if (cellClass === void 0) cellClass = "flatpickr-day";
		if (self.selectedDates.length !== 1 || elem && (!elem.classList.contains(cellClass) || elem.classList.contains("flatpickr-disabled"))) return;
		var hoverDate = elem ? elem.dateObj.getTime() : self.days.firstElementChild.dateObj.getTime(), initialDate = self.parseDate(self.selectedDates[0], void 0, true).getTime(), rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime());
		var containsDisabled = false;
		var minRange = 0, maxRange = 0;
		for (var t = rangeStartDate; t < rangeEndDate; t += duration.DAY) if (!isEnabled(new Date(t), true)) {
			containsDisabled = containsDisabled || t > rangeStartDate && t < rangeEndDate;
			if (t < initialDate && (!minRange || t > minRange)) minRange = t;
			else if (t > initialDate && (!maxRange || t < maxRange)) maxRange = t;
		}
		Array.from(self.rContainer.querySelectorAll("*:nth-child(-n+" + self.config.showMonths + ") > ." + cellClass)).forEach(function(dayElem) {
			var timestamp = dayElem.dateObj.getTime();
			var outOfRange = minRange > 0 && timestamp < minRange || maxRange > 0 && timestamp > maxRange;
			if (outOfRange) {
				dayElem.classList.add("notAllowed");
				[
					"inRange",
					"startRange",
					"endRange"
				].forEach(function(c) {
					dayElem.classList.remove(c);
				});
				return;
			} else if (containsDisabled && !outOfRange) return;
			[
				"startRange",
				"inRange",
				"endRange",
				"notAllowed"
			].forEach(function(c) {
				dayElem.classList.remove(c);
			});
			if (elem !== void 0) {
				elem.classList.add(hoverDate <= self.selectedDates[0].getTime() ? "startRange" : "endRange");
				if (initialDate < hoverDate && timestamp === initialDate) dayElem.classList.add("startRange");
				else if (initialDate > hoverDate && timestamp === initialDate) dayElem.classList.add("endRange");
				if (timestamp >= minRange && (maxRange === 0 || timestamp <= maxRange) && isBetween(timestamp, initialDate, hoverDate)) dayElem.classList.add("inRange");
			}
		});
	}
	function onResize() {
		if (self.isOpen && !self.config.static && !self.config.inline) positionCalendar();
	}
	function open(e, positionElement) {
		if (positionElement === void 0) positionElement = self._positionElement;
		if (self.isMobile === true) {
			if (e) {
				e.preventDefault();
				var eventTarget = getEventTarget(e);
				if (eventTarget) eventTarget.blur();
			}
			if (self.mobileInput !== void 0) {
				self.mobileInput.focus();
				self.mobileInput.click();
			}
			triggerEvent("onOpen");
			return;
		} else if (self._input.disabled || self.config.inline) return;
		var wasOpen = self.isOpen;
		self.isOpen = true;
		if (!wasOpen) {
			self.calendarContainer.classList.add("open");
			self._input.classList.add("active");
			triggerEvent("onOpen");
			positionCalendar(positionElement);
		}
		if (self.config.enableTime === true && self.config.noCalendar === true) {
			if (self.config.allowInput === false && (e === void 0 || !self.timeContainer.contains(e.relatedTarget))) setTimeout(function() {
				return self.hourElement.select();
			}, 50);
		}
	}
	function minMaxDateSetter(type) {
		return function(date) {
			var dateObj = self.config["_" + type + "Date"] = self.parseDate(date, self.config.dateFormat);
			var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];
			if (dateObj !== void 0) self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
			if (self.selectedDates) {
				self.selectedDates = self.selectedDates.filter(function(d) {
					return isEnabled(d);
				});
				if (!self.selectedDates.length && type === "min") setHoursFromDate(dateObj);
				updateValue();
			}
			if (self.daysContainer) {
				redraw();
				if (dateObj !== void 0) self.currentYearElement[type] = dateObj.getFullYear().toString();
				else self.currentYearElement.removeAttribute(type);
				self.currentYearElement.disabled = !!inverseDateObj && dateObj !== void 0 && inverseDateObj.getFullYear() === dateObj.getFullYear();
			}
		};
	}
	function parseConfig() {
		var boolOpts = [
			"wrap",
			"weekNumbers",
			"allowInput",
			"allowInvalidPreload",
			"clickOpens",
			"time_24hr",
			"enableTime",
			"noCalendar",
			"altInput",
			"shorthandCurrentMonth",
			"inline",
			"static",
			"enableSeconds",
			"disableMobile"
		];
		var userConfig = __assign(__assign({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);
		var formats = {};
		self.config.parseDate = userConfig.parseDate;
		self.config.formatDate = userConfig.formatDate;
		Object.defineProperty(self.config, "enable", {
			get: function() {
				return self.config._enable;
			},
			set: function(dates) {
				self.config._enable = parseDateRules(dates);
			}
		});
		Object.defineProperty(self.config, "disable", {
			get: function() {
				return self.config._disable;
			},
			set: function(dates) {
				self.config._disable = parseDateRules(dates);
			}
		});
		var timeMode = userConfig.mode === "time";
		if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
			var defaultDateFormat = flatpickr.defaultConfig.dateFormat || defaults.dateFormat;
			formats.dateFormat = userConfig.noCalendar || timeMode ? "H:i" + (userConfig.enableSeconds ? ":S" : "") : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
		}
		if (userConfig.altInput && (userConfig.enableTime || timeMode) && !userConfig.altFormat) {
			var defaultAltFormat = flatpickr.defaultConfig.altFormat || defaults.altFormat;
			formats.altFormat = userConfig.noCalendar || timeMode ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K") : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
		}
		Object.defineProperty(self.config, "minDate", {
			get: function() {
				return self.config._minDate;
			},
			set: minMaxDateSetter("min")
		});
		Object.defineProperty(self.config, "maxDate", {
			get: function() {
				return self.config._maxDate;
			},
			set: minMaxDateSetter("max")
		});
		var minMaxTimeSetter = function(type) {
			return function(val) {
				self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i:S");
			};
		};
		Object.defineProperty(self.config, "minTime", {
			get: function() {
				return self.config._minTime;
			},
			set: minMaxTimeSetter("min")
		});
		Object.defineProperty(self.config, "maxTime", {
			get: function() {
				return self.config._maxTime;
			},
			set: minMaxTimeSetter("max")
		});
		if (userConfig.mode === "time") {
			self.config.noCalendar = true;
			self.config.enableTime = true;
		}
		Object.assign(self.config, formats, userConfig);
		for (var i = 0; i < boolOpts.length; i++) self.config[boolOpts[i]] = self.config[boolOpts[i]] === true || self.config[boolOpts[i]] === "true";
		HOOKS.filter(function(hook) {
			return self.config[hook] !== void 0;
		}).forEach(function(hook) {
			self.config[hook] = arrayify(self.config[hook] || []).map(bindToInstance);
		});
		self.isMobile = !self.config.disableMobile && !self.config.inline && self.config.mode === "single" && !self.config.disable.length && !self.config.enable && !self.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
		for (var i = 0; i < self.config.plugins.length; i++) {
			var pluginConf = self.config.plugins[i](self) || {};
			for (var key in pluginConf) if (HOOKS.indexOf(key) > -1) self.config[key] = arrayify(pluginConf[key]).map(bindToInstance).concat(self.config[key]);
			else if (typeof userConfig[key] === "undefined") self.config[key] = pluginConf[key];
		}
		if (!userConfig.altInputClass) self.config.altInputClass = getInputElem().className + " " + self.config.altInputClass;
		triggerEvent("onParseConfig");
	}
	function getInputElem() {
		return self.config.wrap ? element.querySelector("[data-input]") : element;
	}
	function setupLocale() {
		if (typeof self.config.locale !== "object" && typeof flatpickr.l10ns[self.config.locale] === "undefined") self.config.errorHandler(/* @__PURE__ */ new Error("flatpickr: invalid locale " + self.config.locale));
		self.l10n = __assign(__assign({}, flatpickr.l10ns.default), typeof self.config.locale === "object" ? self.config.locale : self.config.locale !== "default" ? flatpickr.l10ns[self.config.locale] : void 0);
		tokenRegex.D = "(" + self.l10n.weekdays.shorthand.join("|") + ")";
		tokenRegex.l = "(" + self.l10n.weekdays.longhand.join("|") + ")";
		tokenRegex.M = "(" + self.l10n.months.shorthand.join("|") + ")";
		tokenRegex.F = "(" + self.l10n.months.longhand.join("|") + ")";
		tokenRegex.K = "(" + self.l10n.amPM[0] + "|" + self.l10n.amPM[1] + "|" + self.l10n.amPM[0].toLowerCase() + "|" + self.l10n.amPM[1].toLowerCase() + ")";
		if (__assign(__assign({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {}))).time_24hr === void 0 && flatpickr.defaultConfig.time_24hr === void 0) self.config.time_24hr = self.l10n.time_24hr;
		self.formatDate = createDateFormatter(self);
		self.parseDate = createDateParser({
			config: self.config,
			l10n: self.l10n
		});
	}
	function positionCalendar(customPositionElement) {
		if (typeof self.config.position === "function") {
			self.config.position(self, customPositionElement);
			return;
		}
		if (self.calendarContainer === void 0) return;
		triggerEvent("onPreCalendarPosition");
		var positionElement = customPositionElement || self._positionElement;
		var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, (function(acc, child) {
			return acc + child.offsetHeight;
		}), 0), calendarWidth = self.calendarContainer.offsetWidth, configPos = self.config.position.split(" "), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === "above" || configPosVertical !== "below" && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight;
		var top = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
		toggleClass(self.calendarContainer, "arrowTop", !showOnTop);
		toggleClass(self.calendarContainer, "arrowBottom", showOnTop);
		if (self.config.inline) return;
		var left = window.pageXOffset + inputBounds.left;
		var isCenter = false;
		var isRight = false;
		if (configPosHorizontal === "center") {
			left -= (calendarWidth - inputBounds.width) / 2;
			isCenter = true;
		} else if (configPosHorizontal === "right") {
			left -= calendarWidth - inputBounds.width;
			isRight = true;
		}
		toggleClass(self.calendarContainer, "arrowLeft", !isCenter && !isRight);
		toggleClass(self.calendarContainer, "arrowCenter", isCenter);
		toggleClass(self.calendarContainer, "arrowRight", isRight);
		var right = window.document.body.offsetWidth - (window.pageXOffset + inputBounds.right);
		var rightMost = left + calendarWidth > window.document.body.offsetWidth;
		var centerMost = right + calendarWidth > window.document.body.offsetWidth;
		toggleClass(self.calendarContainer, "rightMost", rightMost);
		if (self.config.static) return;
		self.calendarContainer.style.top = top + "px";
		if (!rightMost) {
			self.calendarContainer.style.left = left + "px";
			self.calendarContainer.style.right = "auto";
		} else if (!centerMost) {
			self.calendarContainer.style.left = "auto";
			self.calendarContainer.style.right = right + "px";
		} else {
			var doc = getDocumentStyleSheet();
			if (doc === void 0) return;
			var bodyWidth = window.document.body.offsetWidth;
			var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
			var centerBefore = ".flatpickr-calendar.centerMost:before";
			var centerAfter = ".flatpickr-calendar.centerMost:after";
			var centerIndex = doc.cssRules.length;
			var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
			toggleClass(self.calendarContainer, "rightMost", false);
			toggleClass(self.calendarContainer, "centerMost", true);
			doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
			self.calendarContainer.style.left = centerLeft + "px";
			self.calendarContainer.style.right = "auto";
		}
	}
	function getDocumentStyleSheet() {
		var editableSheet = null;
		for (var i = 0; i < document.styleSheets.length; i++) {
			var sheet = document.styleSheets[i];
			if (!sheet.cssRules) continue;
			try {
				sheet.cssRules;
			} catch (err) {
				continue;
			}
			editableSheet = sheet;
			break;
		}
		return editableSheet != null ? editableSheet : createStyleSheet();
	}
	function createStyleSheet() {
		var style = document.createElement("style");
		document.head.appendChild(style);
		return style.sheet;
	}
	function redraw() {
		if (self.config.noCalendar || self.isMobile) return;
		buildMonthSwitch();
		updateNavigationCurrentMonth();
		buildDays();
	}
	function focusAndClose() {
		self._input.focus();
		if (window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== void 0) setTimeout(self.close, 0);
		else self.close();
	}
	function selectDate(e) {
		e.preventDefault();
		e.stopPropagation();
		var isSelectable = function(day) {
			return day.classList && day.classList.contains("flatpickr-day") && !day.classList.contains("flatpickr-disabled") && !day.classList.contains("notAllowed");
		};
		var t = findParent(getEventTarget(e), isSelectable);
		if (t === void 0) return;
		var target = t;
		var selectedDate = self.latestSelectedDateObj = new Date(target.dateObj.getTime());
		var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth || selectedDate.getMonth() > self.currentMonth + self.config.showMonths - 1) && self.config.mode !== "range";
		self.selectedDateElem = target;
		if (self.config.mode === "single") self.selectedDates = [selectedDate];
		else if (self.config.mode === "multiple") {
			var selectedIndex = isDateSelected(selectedDate);
			if (selectedIndex) self.selectedDates.splice(parseInt(selectedIndex), 1);
			else self.selectedDates.push(selectedDate);
		} else if (self.config.mode === "range") {
			if (self.selectedDates.length === 2) self.clear(false, false);
			self.latestSelectedDateObj = selectedDate;
			self.selectedDates.push(selectedDate);
			if (compareDates(selectedDate, self.selectedDates[0], true) !== 0) self.selectedDates.sort(function(a, b) {
				return a.getTime() - b.getTime();
			});
		}
		setHoursFromInputs();
		if (shouldChangeMonth) {
			var isNewYear = self.currentYear !== selectedDate.getFullYear();
			self.currentYear = selectedDate.getFullYear();
			self.currentMonth = selectedDate.getMonth();
			if (isNewYear) {
				triggerEvent("onYearChange");
				buildMonthSwitch();
			}
			triggerEvent("onMonthChange");
		}
		updateNavigationCurrentMonth();
		buildDays();
		updateValue();
		if (!shouldChangeMonth && self.config.mode !== "range" && self.config.showMonths === 1) focusOnDayElem(target);
		else if (self.selectedDateElem !== void 0 && self.hourElement === void 0) self.selectedDateElem && self.selectedDateElem.focus();
		if (self.hourElement !== void 0) self.hourElement !== void 0 && self.hourElement.focus();
		if (self.config.closeOnSelect) {
			var single = self.config.mode === "single" && !self.config.enableTime;
			var range = self.config.mode === "range" && self.selectedDates.length === 2 && !self.config.enableTime;
			if (single || range) focusAndClose();
		}
		triggerChange();
	}
	var CALLBACKS = {
		locale: [setupLocale, updateWeekdays],
		showMonths: [
			buildMonths,
			setCalendarWidth,
			buildWeekdays
		],
		minDate: [jumpToDate],
		maxDate: [jumpToDate],
		positionElement: [updatePositionElement],
		clickOpens: [function() {
			if (self.config.clickOpens === true) {
				bind(self._input, "focus", self.open);
				bind(self._input, "click", self.open);
			} else {
				self._input.removeEventListener("focus", self.open);
				self._input.removeEventListener("click", self.open);
			}
		}]
	};
	function set(option, value) {
		if (option !== null && typeof option === "object") {
			Object.assign(self.config, option);
			for (var key in option) if (CALLBACKS[key] !== void 0) CALLBACKS[key].forEach(function(x) {
				return x();
			});
		} else {
			self.config[option] = value;
			if (CALLBACKS[option] !== void 0) CALLBACKS[option].forEach(function(x) {
				return x();
			});
			else if (HOOKS.indexOf(option) > -1) self.config[option] = arrayify(value);
		}
		self.redraw();
		updateValue(true);
	}
	function setSelectedDate(inputDate, format) {
		var dates = [];
		if (inputDate instanceof Array) dates = inputDate.map(function(d) {
			return self.parseDate(d, format);
		});
		else if (inputDate instanceof Date || typeof inputDate === "number") dates = [self.parseDate(inputDate, format)];
		else if (typeof inputDate === "string") switch (self.config.mode) {
			case "single":
			case "time":
				dates = [self.parseDate(inputDate, format)];
				break;
			case "multiple":
				dates = inputDate.split(self.config.conjunction).map(function(date) {
					return self.parseDate(date, format);
				});
				break;
			case "range": dates = inputDate.split(self.l10n.rangeSeparator).map(function(date) {
				return self.parseDate(date, format);
			});
		}
		else self.config.errorHandler(/* @__PURE__ */ new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
		self.selectedDates = self.config.allowInvalidPreload ? dates : dates.filter(function(d) {
			return d instanceof Date && isEnabled(d, false);
		});
		if (self.config.mode === "range") self.selectedDates.sort(function(a, b) {
			return a.getTime() - b.getTime();
		});
	}
	function setDate(date, triggerChange, format) {
		if (triggerChange === void 0) triggerChange = false;
		if (format === void 0) format = self.config.dateFormat;
		if (date !== 0 && !date || date instanceof Array && date.length === 0) return self.clear(triggerChange);
		setSelectedDate(date, format);
		self.latestSelectedDateObj = self.selectedDates[self.selectedDates.length - 1];
		self.redraw();
		jumpToDate(void 0, triggerChange);
		setHoursFromDate();
		if (self.selectedDates.length === 0) self.clear(false);
		updateValue(triggerChange);
		if (triggerChange) triggerEvent("onChange");
	}
	function parseDateRules(arr) {
		return arr.slice().map(function(rule) {
			if (typeof rule === "string" || typeof rule === "number" || rule instanceof Date) return self.parseDate(rule, void 0, true);
			else if (rule && typeof rule === "object" && rule.from && rule.to) return {
				from: self.parseDate(rule.from, void 0),
				to: self.parseDate(rule.to, void 0)
			};
			return rule;
		}).filter(function(x) {
			return x;
		});
	}
	function setupDates() {
		self.selectedDates = [];
		self.now = self.parseDate(self.config.now) || /* @__PURE__ */ new Date();
		var preloadedDate = self.config.defaultDate || ((self.input.nodeName === "INPUT" || self.input.nodeName === "TEXTAREA") && self.input.placeholder && self.input.value === self.input.placeholder ? null : self.input.value);
		if (preloadedDate) setSelectedDate(preloadedDate, self.config.dateFormat);
		self._initialDate = self.selectedDates.length > 0 ? self.selectedDates[0] : self.config.minDate && self.config.minDate.getTime() > self.now.getTime() ? self.config.minDate : self.config.maxDate && self.config.maxDate.getTime() < self.now.getTime() ? self.config.maxDate : self.now;
		self.currentYear = self._initialDate.getFullYear();
		self.currentMonth = self._initialDate.getMonth();
		if (self.selectedDates.length > 0) self.latestSelectedDateObj = self.selectedDates[0];
		if (self.config.minTime !== void 0) self.config.minTime = self.parseDate(self.config.minTime, "H:i");
		if (self.config.maxTime !== void 0) self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
		self.minDateHasTime = !!self.config.minDate && (self.config.minDate.getHours() > 0 || self.config.minDate.getMinutes() > 0 || self.config.minDate.getSeconds() > 0);
		self.maxDateHasTime = !!self.config.maxDate && (self.config.maxDate.getHours() > 0 || self.config.maxDate.getMinutes() > 0 || self.config.maxDate.getSeconds() > 0);
	}
	function setupInputs() {
		self.input = getInputElem();
		if (!self.input) {
			self.config.errorHandler(/* @__PURE__ */ new Error("Invalid input element specified"));
			return;
		}
		self.input._type = self.input.type;
		self.input.type = "text";
		self.input.classList.add("flatpickr-input");
		self._input = self.input;
		if (self.config.altInput) {
			self.altInput = createElement(self.input.nodeName, self.config.altInputClass);
			self._input = self.altInput;
			self.altInput.placeholder = self.input.placeholder;
			self.altInput.disabled = self.input.disabled;
			self.altInput.required = self.input.required;
			self.altInput.tabIndex = self.input.tabIndex;
			self.altInput.type = "text";
			self.input.setAttribute("type", "hidden");
			if (!self.config.static && self.input.parentNode) self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
		}
		if (!self.config.allowInput) self._input.setAttribute("readonly", "readonly");
		updatePositionElement();
	}
	function updatePositionElement() {
		self._positionElement = self.config.positionElement || self._input;
	}
	function setupMobile() {
		var inputType = self.config.enableTime ? self.config.noCalendar ? "time" : "datetime-local" : "date";
		self.mobileInput = createElement("input", self.input.className + " flatpickr-mobile");
		self.mobileInput.tabIndex = 1;
		self.mobileInput.type = inputType;
		self.mobileInput.disabled = self.input.disabled;
		self.mobileInput.required = self.input.required;
		self.mobileInput.placeholder = self.input.placeholder;
		self.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";
		if (self.selectedDates.length > 0) self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
		if (self.config.minDate) self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
		if (self.config.maxDate) self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
		if (self.input.getAttribute("step")) self.mobileInput.step = String(self.input.getAttribute("step"));
		self.input.type = "hidden";
		if (self.altInput !== void 0) self.altInput.type = "hidden";
		try {
			if (self.input.parentNode) self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
		} catch (_a) {}
		bind(self.mobileInput, "change", function(e) {
			self.setDate(getEventTarget(e).value, false, self.mobileFormatStr);
			triggerEvent("onChange");
			triggerEvent("onClose");
		});
	}
	function toggle(e) {
		if (self.isOpen === true) return self.close();
		self.open(e);
	}
	function triggerEvent(event, data) {
		if (self.config === void 0) return;
		var hooks = self.config[event];
		if (hooks !== void 0 && hooks.length > 0) for (var i = 0; hooks[i] && i < hooks.length; i++) hooks[i](self.selectedDates, self.input.value, self, data);
		if (event === "onChange") {
			self.input.dispatchEvent(createEvent("change"));
			self.input.dispatchEvent(createEvent("input"));
		}
	}
	function createEvent(name) {
		var e = document.createEvent("Event");
		e.initEvent(name, true, true);
		return e;
	}
	function isDateSelected(date) {
		for (var i = 0; i < self.selectedDates.length; i++) {
			var selectedDate = self.selectedDates[i];
			if (selectedDate instanceof Date && compareDates(selectedDate, date) === 0) return "" + i;
		}
		return false;
	}
	function isDateInRange(date) {
		if (self.config.mode !== "range" || self.selectedDates.length < 2) return false;
		return compareDates(date, self.selectedDates[0]) >= 0 && compareDates(date, self.selectedDates[1]) <= 0;
	}
	function updateNavigationCurrentMonth() {
		if (self.config.noCalendar || self.isMobile || !self.monthNav) return;
		self.yearElements.forEach(function(yearElement, i) {
			var d = new Date(self.currentYear, self.currentMonth, 1);
			d.setMonth(self.currentMonth + i);
			if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") self.monthElements[i].textContent = monthToStr(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
			else self.monthsDropdownContainer.value = d.getMonth().toString();
			yearElement.value = d.getFullYear().toString();
		});
		self._hidePrevMonthArrow = self.config.minDate !== void 0 && (self.currentYear === self.config.minDate.getFullYear() ? self.currentMonth <= self.config.minDate.getMonth() : self.currentYear < self.config.minDate.getFullYear());
		self._hideNextMonthArrow = self.config.maxDate !== void 0 && (self.currentYear === self.config.maxDate.getFullYear() ? self.currentMonth + 1 > self.config.maxDate.getMonth() : self.currentYear > self.config.maxDate.getFullYear());
	}
	function getDateStr(specificFormat) {
		var format = specificFormat || (self.config.altInput ? self.config.altFormat : self.config.dateFormat);
		return self.selectedDates.map(function(dObj) {
			return self.formatDate(dObj, format);
		}).filter(function(d, i, arr) {
			return self.config.mode !== "range" || self.config.enableTime || arr.indexOf(d) === i;
		}).join(self.config.mode !== "range" ? self.config.conjunction : self.l10n.rangeSeparator);
	}
	function updateValue(triggerChange) {
		if (triggerChange === void 0) triggerChange = true;
		if (self.mobileInput !== void 0 && self.mobileFormatStr) self.mobileInput.value = self.latestSelectedDateObj !== void 0 ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr) : "";
		self.input.value = getDateStr(self.config.dateFormat);
		if (self.altInput !== void 0) self.altInput.value = getDateStr(self.config.altFormat);
		if (triggerChange !== false) triggerEvent("onValueUpdate");
	}
	function onMonthNavClick(e) {
		var eventTarget = getEventTarget(e);
		var isPrevMonth = self.prevMonthNav.contains(eventTarget);
		var isNextMonth = self.nextMonthNav.contains(eventTarget);
		if (isPrevMonth || isNextMonth) changeMonth(isPrevMonth ? -1 : 1);
		else if (self.yearElements.indexOf(eventTarget) >= 0) eventTarget.select();
		else if (eventTarget.classList.contains("arrowUp")) self.changeYear(self.currentYear + 1);
		else if (eventTarget.classList.contains("arrowDown")) self.changeYear(self.currentYear - 1);
	}
	function timeWrapper(e) {
		e.preventDefault();
		var isKeyDown = e.type === "keydown", eventTarget = getEventTarget(e), input = eventTarget;
		if (self.amPM !== void 0 && eventTarget === self.amPM) self.amPM.textContent = self.l10n.amPM[int(self.amPM.textContent === self.l10n.amPM[0])];
		var min = parseFloat(input.getAttribute("min")), max = parseFloat(input.getAttribute("max")), step = parseFloat(input.getAttribute("step")), curValue = parseInt(input.value, 10);
		var newValue = curValue + step * (e.delta || (isKeyDown ? e.which === 38 ? 1 : -1 : 0));
		if (typeof input.value !== "undefined" && input.value.length === 2) {
			var isHourElem = input === self.hourElement, isMinuteElem = input === self.minuteElement;
			if (newValue < min) {
				newValue = max + newValue + int(!isHourElem) + (int(isHourElem) && int(!self.amPM));
				if (isMinuteElem) incrementNumInput(void 0, -1, self.hourElement);
			} else if (newValue > max) {
				newValue = input === self.hourElement ? newValue - max - int(!self.amPM) : min;
				if (isMinuteElem) incrementNumInput(void 0, 1, self.hourElement);
			}
			if (self.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) self.amPM.textContent = self.l10n.amPM[int(self.amPM.textContent === self.l10n.amPM[0])];
			input.value = pad(newValue);
		}
	}
	init();
	return self;
}
function _flatpickr(nodeList, config) {
	var nodes = Array.prototype.slice.call(nodeList).filter(function(x) {
		return x instanceof HTMLElement;
	});
	var instances = [];
	for (var i = 0; i < nodes.length; i++) {
		var node = nodes[i];
		try {
			if (node.getAttribute("data-fp-omit") !== null) continue;
			if (node._flatpickr !== void 0) {
				node._flatpickr.destroy();
				node._flatpickr = void 0;
			}
			node._flatpickr = FlatpickrInstance(node, config || {});
			instances.push(node._flatpickr);
		} catch (e) {
			console.error(e);
		}
	}
	return instances.length === 1 ? instances[0] : instances;
}
if (typeof HTMLElement !== "undefined" && typeof HTMLCollection !== "undefined" && typeof NodeList !== "undefined") {
	HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(config) {
		return _flatpickr(this, config);
	};
	HTMLElement.prototype.flatpickr = function(config) {
		return _flatpickr([this], config);
	};
}
var flatpickr = function(selector, config) {
	if (typeof selector === "string") return _flatpickr(window.document.querySelectorAll(selector), config);
	else if (selector instanceof Node) return _flatpickr([selector], config);
	else return _flatpickr(selector, config);
};
flatpickr.defaultConfig = {};
flatpickr.l10ns = {
	en: __assign({}, english),
	default: __assign({}, english)
};
flatpickr.localize = function(l10n) {
	flatpickr.l10ns.default = __assign(__assign({}, flatpickr.l10ns.default), l10n);
};
flatpickr.setDefaults = function(config) {
	flatpickr.defaultConfig = __assign(__assign({}, flatpickr.defaultConfig), config);
};
flatpickr.parseDate = createDateParser({});
flatpickr.formatDate = createDateFormatter({});
flatpickr.compareDates = compareDates;
if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") jQuery.fn.flatpickr = function(config) {
	return _flatpickr(this, config);
};
Date.prototype.fp_incr = function(days) {
	return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
};
if (typeof window !== "undefined") window.flatpickr = flatpickr;
//#endregion
//#region DateTimePicker/DateTimePicker.ts
/**
* @public 
*/
var DateTimePicker = (() => {
	const Init = () => {
		document.querySelectorAll(".SiDateTimePicker").forEach((el) => {
			InitSingle(el);
		});
	};
	const InitSingle = (el) => {
		var val = el.querySelector("[type=\"hidden\"]");
		var text = el.querySelector("[type=\"text\"]");
		var button = el.querySelector("button");
		if (!text.readOnly) {
			const picker = flatpickr(text, {
				dateFormat: "j M Y",
				allowInput: true,
				clickOpens: true
			});
			if (val) {
				button.addEventListener("pointerdown", (e) => {
					e.preventDefault();
				});
				button.addEventListener("click", (e) => {
					picker.toggle();
				});
				val.addEventListener("change", (e) => {
					const value = val.value;
					if (value) {
						var parts = value.split(" ");
						if (text && parts.length >= 3) text.value = parts[0] + " " + parts[1] + " " + parts[2];
						var id = val.id;
						var elHour = document.querySelector("[data-id=\"" + id + "\"][data-part=\"h\"]");
						var elMinute = document.querySelector("[data-id=\"" + id + "\"][data-part=\"m\"]");
						if (elHour) {
							var time = "";
							if (parts.length == 1) time = parts[0];
							else if (parts.length === 4) time = parts[4];
							else return;
							var subParts = time.split(":");
							if (subParts.length === 2) {
								elHour.value = subParts[0];
								elMinute.value = subParts[1];
							}
						}
					}
				});
				el.querySelectorAll("[data-part=\"date\"], [data-part=\"h\"], [data-part=\"m\"]").forEach((el) => {
					el.addEventListener("change", (e) => {
						var that = e.currentTarget;
						DateTimeSet(that);
					});
				});
				document.querySelectorAll(".TimePickerDropDown select").forEach((el) => {
					DateTimeSet(el);
				});
			}
		}
	};
	const DateYMD = (date) => {
		var parts = date.split(" ");
		if (parts.length >= 3) {
			var day = parts[0];
			if (day.length < 2) day = "0" + day;
			return parts[2] + "-" + parts[1] + "-" + day;
		}
		return null;
	};
	const MinDate = (id, date) => {
		var el = document.querySelector("[data-id=\"" + id + "\"][data-part=\"date\"]");
		if (el) {
			var min = DateYMD(date);
			if (min) el.min = min;
		}
	};
	const MaxDate = (id, date) => {
		var el = document.querySelector("[data-id=\"" + id + "\"][data-part=\"date\"]");
		if (el) {
			var max = DateYMD(date);
			if (max) el.max = max;
		}
	};
	const DateTimeSet = function(el) {
		if (el) {
			var id = el.dataset.id;
			if (id) {
				var elDate = document.querySelector("[data-id=\"" + id + "\"][data-part=\"date\"]");
				var elHour = document.querySelector("[data-id=\"" + id + "\"][data-part=\"h\"]");
				var elMinute = document.querySelector("[data-id=\"" + id + "\"][data-part=\"m\"]");
				var valid = false;
				if (el.dataset.part === "date") {
					if (!elHour) valid = true;
					else valid = elDate.value !== "" && elHour.value !== "" && elMinute.value !== "";
				} else if (el.dataset.part === "h" || el.dataset.part === "m") valid = elHour.value !== "" && elMinute.value !== "";
				var datetime = "";
				var elVal = document.getElementById(id);
				if (valid) {
					if (elDate) datetime = elDate.value;
					if (elHour) {
						if (datetime.length > 0) datetime += " ";
						datetime += elHour.value + ":" + elMinute.value;
					}
					elVal.value = datetime;
				} else elVal.value = "";
				elVal.dispatchEvent(new CustomEvent("changed", { detail: { datetime } }));
			}
		}
	};
	const FormatDate = (d) => {
		return d.getDate() + " " + MonthName(d.getMonth() + 1) + " " + d.getFullYear();
	};
	const MonthName = (o) => {
		var month = "";
		switch (o) {
			case 1:
			case "1":
			case "01":
				month = "Jan";
				break;
			case 2:
			case "2":
			case "02":
				month = "Feb";
				break;
			case 3:
			case "3":
			case "03":
				month = "Mar";
				break;
			case 4:
			case "4":
			case "04":
				month = "Apr";
				break;
			case 5:
			case "5":
			case "05":
				month = "May";
				break;
			case 6:
			case "6":
			case "06":
				month = "Jun";
				break;
			case 7:
			case "7":
			case "07":
				month = "Jul";
				break;
			case 8:
			case "8":
			case "08":
				month = "Aug";
				break;
			case 9:
			case "9":
			case "09":
				month = "Sep";
				break;
			case 10:
			case "10":
				month = "Oct";
				break;
			case 11:
			case "11":
				month = "Nov";
				break;
			case 12:
			case "12": month = "Dec";
		}
		return month;
	};
	const MonthValue = (o) => {
		var month = "";
		switch (o) {
			case "Jan":
				month = "01";
				break;
			case "Feb":
				month = "02";
				break;
			case "Mar":
				month = "03";
				break;
			case "Apr":
				month = "04";
				break;
			case "May":
				month = "05";
				break;
			case "Jun":
				month = "06";
				break;
			case "Jul":
				month = "07";
				break;
			case "Aug":
				month = "08";
				break;
			case "Sep":
				month = "09";
				break;
			case "Oct":
				month = "10";
				break;
			case "Nov":
				month = "11";
				break;
			case "Dec": month = "12";
		}
		return month;
	};
	const SetDate = (id, date) => {
		var el = document.getElementById(id);
		if (el) {
			el.value = date;
			el.dispatchEvent(new Event("change"));
		}
	};
	return {
		Init,
		InitSingle,
		MinDate,
		MaxDate,
		FormatDate,
		MonthValue,
		MonthName,
		SetDate
	};
})();
document.addEventListener("DOMContentLoaded", () => {
	DateTimePicker.Init();
});
//#endregion
//#region Field/Field.ts
/**
* @public 
*/
var Field = (() => {
	const Init = () => {
		document.querySelectorAll("input[type=\"checkbox\"][readonly], input[type=\"radio\"][readonly]").forEach((el) => {
			el.addEventListener("click", () => {
				return false;
			});
		});
	};
	return { Init };
})();
document.addEventListener("DOMContentLoaded", () => {
	Field.Init();
});
//#endregion
//#region PartialDate/PartialDate.ts
/**
* @public 
*/
var PartialDate = (() => {
	const Init = () => {
		document.querySelectorAll(".PartialDate").forEach((el) => {
			InitSingle(el);
		});
	};
	const InitSingle = (el) => {
		el.querySelectorAll("select").forEach((elS) => {
			elS.addEventListener("change", (e) => {
				var that = e.currentTarget;
				if (that) {
					var id = that.dataset.id;
					if (id) {
						MinMaxSet(id, that.dataset.part ?? "");
						DateSet(id);
					}
				}
			});
		});
	};
	const SetDate = (id, date) => {
		var el = document.getElementById(id);
		el.value = date;
		var parts = date.split(" ");
		var day = document.getElementById(id + "_day");
		if (day) day.value = parts[0];
		var month = document.getElementById(id + "_month");
		if (month) month.value = parts[1];
		var year = document.getElementById(id + "_year");
		if (year) year.value = parts[2];
	};
	const MinMaxSet = (id, part) => {
		var date = document.getElementById(id);
		var elDay = document.getElementById(id + "_day");
		var elMonth = document.getElementById(id + "_month");
		var elYear = document.getElementById(id + "_year");
		var minDay = Number(date.dataset.minDay ?? "0");
		var minMonth = Number(date.dataset.minMonth ?? "0");
		var minYear = Number(date.dataset.minYear ?? "0");
		var maxDay = Number(date.dataset.maxDay ?? "31");
		var maxMonth = Number(date.dataset.maxMonth ?? "12");
		var maxYear = Number(date.dataset.maxYear ?? "9999");
		if (part == "Year") MinMaxYearSet(elDay, elMonth, elYear, minDay, minMonth, minYear, maxDay, maxMonth, maxYear);
		if (part == "Month") MinMaxMonthSet(elDay, elMonth, elYear, minDay, minMonth, minYear, maxDay, maxMonth, maxYear);
		if (part == "Day") MinMaxDaySet(elDay, elMonth, elYear, minDay, minMonth, minYear, maxDay, maxMonth, maxYear);
	};
	const MinMaxDaySet = (elDay, elMonth, elYear, minDay, minMonth, minYear, maxDay, maxMonth, maxYear) => {
		if (elDay) {
			var selectedMonth = Number(elMonth.value);
			var selectedYear = Number(elYear.value);
			var isMinMonth = selectedMonth === minMonth;
			var isMaxMonth = selectedYear === maxMonth;
			var isMinYear = Number(elYear.value) === minYear;
			var isMaxYear = Number(elYear.value) === maxYear;
			var daysThisMonth = DaysInMonth(selectedMonth, selectedYear);
			elDay.querySelectorAll("option").forEach((el) => {
				var currentDay = Number(el.value);
				if (!(minDay == 0 && maxDay == 0) && (currentDay < minDay && isMinYear && isMinMonth || currentDay > maxDay && isMaxYear && isMaxMonth || currentDay > daysThisMonth)) {
					el.classList.add("d-none");
					el.selected = false;
				} else el.classList.remove("d-none");
			});
		}
	};
	const MinMaxMonthSet = (elDay, elMonth, elYear, minDay, minMonth, minYear, maxDay, maxMonth, maxYear) => {
		if (elMonth) {
			var isMinYear = Number(elYear.value) === minYear;
			var isMaxYear = Number(elYear.value) === maxYear;
			elMonth.querySelectorAll("option").forEach((el) => {
				var monthVal = Number(DateTimePicker.MonthValue(el.value));
				if (!(minMonth == 0 && maxMonth == 0) && (monthVal < minMonth && isMinYear || monthVal > maxMonth && isMaxYear)) {
					el.classList.add("d-none");
					el.selected = false;
				} else el.classList.remove("d-none");
			});
			MinMaxDaySet(elDay, elMonth, elYear, minDay, minMonth, minYear, maxDay, maxMonth, maxYear);
		}
	};
	const MinMaxYearSet = (elDay, elMonth, elYear, minDay, minMonth, minYear, maxDay, maxMonth, maxYear) => {
		if (elYear) {
			elYear.querySelectorAll("option").forEach((el) => {
				if (!(minYear == 0 && maxYear == 0) && (Number(el.value) < minYear || Number(el.value) > maxYear)) {
					el.classList.add("d-none");
					el.selected = false;
				} else el.classList.remove("d-none");
			});
			MinMaxMonthSet(elDay, elMonth, elYear, minDay, minMonth, minYear, maxDay, maxMonth, maxYear);
		}
	};
	const DaysInMonth = (year, month) => {
		return new Date(year, month, 0).getDate();
	};
	const DateSet = (id) => {
		var day = "1";
		var elDay = document.getElementById(id + "_day");
		if (elDay) day = elDay.value;
		var elMonth = document.getElementById(id + "_month");
		var month = "Jan";
		if (elMonth) month = elMonth.value;
		var elYear = document.getElementById(id + "_year");
		var year = "2000";
		if (elYear) year = elYear.value;
		var valid = true;
		if (Number(day) > 29 && month == "Feb") valid = false;
		if (Number(day) > 30 && (month == "Apr" || month == "Jun" || month == "Sep" || month == "Nov")) valid = false;
		var date = day + " " + month + " " + year;
		if (day == "" || month == "" || year == "") date = "";
		var el = document.getElementById(id);
		if (el) {
			if (valid) el.value = date;
			else el.value = "";
			el.dispatchEvent(new CustomEvent("changed", { detail: { date } }));
		}
	};
	return {
		Init,
		InitSingle,
		SetDate
	};
})();
document.addEventListener("DOMContentLoaded", () => {
	PartialDate.Init();
});
//#endregion
//#region Filter/Filter.ts
/**
* @public 
*/
var Filter = (() => {
	const Init = async () => {
		document.querySelectorAll("[data-toggle-filter]").forEach((el) => {
			el.addEventListener("click", (e) => {
				e.preventDefault();
				var id = e.currentTarget.dataset.toggleFilter;
				if (id) ToggleFilter(id);
			});
		});
		document.querySelectorAll("[data-do-filter]").forEach((el) => {
			el.addEventListener("click", async (e) => {
				e.preventDefault();
				var that = e.currentTarget;
				var id = that.dataset.doFilter;
				var resetGridPage = that.dataset.resetGridPage?.toLowerCase() === "true";
				await FilterAsync(id, resetGridPage, that.name);
			});
		});
		document.querySelectorAll("[data-do-clear]").forEach((el) => {
			el.addEventListener("click", async (e) => {
				e.preventDefault();
				var that = e.currentTarget;
				var id = that.dataset.doClear;
				var resetGridPage = that.dataset.resetGridPage?.toLowerCase() === "true";
				await ClearAsync(id, resetGridPage, that.name);
			});
		});
		const fields = document.querySelectorAll(".FilterField");
		for (const el of fields) {
			var filter = el.closest(".Filter");
			var field = el.dataset.fieldId ?? "";
			var rec = await IndexedDb.FilterGetAsync(filter.id, field);
			var oField = document.getElementById(field);
			if (oField.closest(".FilterField")?.dataset.override === void 0) {
				var value = rec !== void 0 ? rec.value === void 0 ? oField.dataset.default : rec.value : oField.dataset.default;
				var text = rec !== void 0 ? rec.text : "";
				if (oField.type === "checkbox") oField.checked = value;
				else if (document.querySelector("[data-valueid=\"" + field + "\"]")) {
					oField.value = value;
					document.querySelector("[data-valueid=\"" + field + "\"]").value = text;
				} else if (document.getElementById(field + "_date")) DateTimePicker.SetDate(field, value);
				else if (oField.closest(".FilterField")?.querySelector(".PartialDate")) PartialDate.SetDate(field, value);
				else oField.value = value;
			}
		}
		window.siGridsReady.then(() => {
			document.querySelectorAll("[data-shareit-grid-ajax-url]").forEach((el) => {
				el.dispatchEvent(new Event("load"));
			});
		});
	};
	const ToggleFilter = (id) => {
		if (document.querySelector("#FilterToggle_" + id + " i")?.classList.contains("fa-chevron-up")) {
			Hide(void 0, "FilterContent_" + id);
			document.querySelector("#FilterToggle_" + id + " i")?.classList.replace("fa-chevron-up", "fa-chevron-down");
			Show(void 0, "FilterHiddenText_" + id);
		} else {
			Show(void 0, "FilterContent_" + id);
			document.querySelector("#FilterToggle_" + id + " i")?.classList.replace("fa-chevron-down", "fa-chevron-up");
			Hide(void 0, "FilterHiddenText_" + id);
		}
		document.getElementById(id)?.dispatchEvent(new Event("resize"));
	};
	const FilterAsync = async (id, resetGridPage, buttonName) => {
		if (id) {
			const fields = document.querySelectorAll("#" + id + " .FilterField");
			for (const el of fields) {
				var field = el.dataset.fieldId ?? "";
				var value = null;
				var text = null;
				var oField = document.getElementById(field);
				if (oField.type === "checkbox") value = oField.checked.toString();
				else if (document.querySelector("[data-valueid=\"" + field + "\"]")) {
					value = oField.value;
					text = document.querySelector("[data-valueid=\"" + field + "\"]")?.value ?? "";
				} else if (document.getElementById(field + "_date")) value = oField.value;
				else value = oField.value;
				await IndexedDb.FilterSetAsync(id, field, value, text);
			}
			document.getElementById(id + "_action").value = "Filter";
			if (resetGridPage) await ResetGridPageAsync(id);
			if (document.getElementById(id).dataset.fullSubmit === void 0) document.querySelector("[data-shareit-grid-ajax-url]")?.dispatchEvent(new Event("load"));
			else {
				var form = document.getElementById(id)?.closest("form");
				document.querySelectorAll("[name=\"" + buttonName + "\"]").forEach((el) => el.remove());
				const button = document.createElement("input");
				button.type = "hidden";
				button.name = buttonName;
				form.appendChild(button);
				form.submit();
			}
		}
	};
	const ClearAsync = async (id, resetGridPage, buttonName) => {
		if (id) {
			await IndexedDb.FilterClearAsync(id);
			const fields = document.querySelectorAll("#" + id + " .FilterField");
			for (const el of fields) {
				var field = el.dataset.fieldId ?? "";
				var oField = document.getElementById(field);
				var value = oField.dataset.default ?? "";
				if (oField.type === "checkbox") oField.checked = value.toLowerCase() === "true";
				else if (document.querySelector("[data-valueid=\"" + field + "\"]")) {
					oField.value = value;
					await AutoCompleter.AutoCompleteValueTextAsync(field);
				} else if (document.getElementById(field + "_date")) DateTimePicker.SetDate(field, value);
				else if (oField.closest(".FilterField")?.querySelector(".PartialDate")) PartialDate.SetDate(field, value);
				else oField.value = value;
			}
			document.getElementById(id + "_action").value = "Clear";
			if (resetGridPage) await ResetGridPageAsync(id);
			if (document.getElementById(id).dataset.fullSubmit === void 0) document.querySelector("[data-shareit-grid-ajax-url]")?.dispatchEvent(new Event("load"));
			else {
				var form = document.getElementById(id)?.closest("form");
				document.querySelectorAll("[name=\"" + buttonName + "\"]").forEach((el) => el.remove());
				const button = document.createElement("input");
				button.type = "hidden";
				button.name = buttonName;
				form.appendChild(button);
				form.submit();
			}
		}
	};
	const ResetGridPageAsync = async (id) => {
		const gridExplicits = document.querySelectorAll(".si-ajax-grid [data-filter-ids]");
		for (const el of gridExplicits) {
			const filterIds = el.dataset.filterIds?.split(",");
			if (filterIds && filterIds.includes(id)) await IndexedDb.GridClearAsync(el.id);
		}
		const grids = document.querySelectorAll(".si-ajax-grid:not([data-filter-ids])");
		for (const el of grids) await IndexedDb.GridClearAsync(el.id);
	};
	return { Init };
})();
document.addEventListener("DOMContentLoaded", () => {
	Filter.Init();
});
//#endregion
//#region Form/Form.ts
/**
* @public 
*/
var Form = (() => {
	var _submitting = false;
	const Init = () => {
		document.querySelectorAll("input[type=\"submit\"]:not([data-no-submit-disable])").forEach((el) => {
			el.addEventListener("click", (e) => {
				if (!_submitting) {
					_submitting = true;
					window.setTimeout(() => {
						_submitting = false;
					}, 2e3);
				} else e.preventDefault();
			});
		});
	};
	return { Init };
})();
document.addEventListener("DOMContentLoaded", () => {
	Form.Init();
});
//#endregion
//#region PageReturn/PageReturn.ts
/**
* @public 
*/
var PageReturn = (() => {
	const Init = async () => {
		var trailField = document.querySelector("[name=\"__SiPageReturn\"]");
		if (trailField) {
			var returnFound = false;
			const cookies = document.cookie.split(";");
			for (let cookie of cookies) {
				const [key, value] = cookie.trim().split("=");
				if (key === "PageReturn") {
					returnFound = true;
					break;
				}
			}
			var jsonPage = [];
			var merged = [];
			if (!returnFound) {
				var trail = document.querySelector("[name=\"__SiPageReturn\"]")?.value ?? "";
				var t = new DOMParser().parseFromString(trail, "text/html").documentElement.textContent;
				jsonPage = JSON.parse(t);
			}
			var existingTrail = await IndexedDb.PageReturnGetAsync();
			var et = new DOMParser().parseFromString(existingTrail, "text/html").documentElement.textContent;
			var jsonIdb = JSON.parse(et);
			if (returnFound) {
				if (jsonIdb != null) jsonIdb.pop();
				merged = jsonIdb;
				document.cookie = "PageReturn=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; Secure; SameSite=Strict";
			} else {
				merged = jsonIdb;
				if (jsonPage !== null && merged !== null) {
					if (merged.length > 0 && jsonPage.length > 0) {
						if (JSON.stringify(merged[merged.length - 1]) !== JSON.stringify(jsonPage[jsonPage.length - 1])) if (merged.length == jsonPage.length) merged = [...jsonIdb, ...jsonPage];
						else merged = [...jsonIdb, jsonPage[jsonPage.length - 1]];
					}
				}
			}
			if (merged !== null && merged.length) {
				var final = JSON.stringify(merged).replace(/"/g, "&quot;");
				await IndexedDb.PageReturnSetAsync(final);
				trailField.value = final;
			} else await IndexedDb.PageReturnClearAsync();
		} else await IndexedDb.PageReturnClearAsync();
		document.querySelectorAll("[data-page-return-edit-saved-url]").forEach((el) => {
			el.addEventListener("click", async (e) => {
				var that = e.currentTarget;
				var form = that.closest("form");
				document.querySelectorAll("[name=\"__SiSavedUrl\"]").forEach((el) => el.remove());
				const savedUrl = document.createElement("input");
				savedUrl.type = "hidden";
				savedUrl.id = "__SiSavedUrl";
				savedUrl.name = "__SiSavedUrl";
				savedUrl.value = that.dataset.pageReturnEditSavedUrl ?? "";
				form.appendChild(savedUrl);
				if (that.dataset.pageReturnEditField !== void 0) {
					document.querySelectorAll("[name=\"__SiPkf\"]").forEach((el) => el.remove());
					const pkf = document.createElement("input");
					pkf.type = "hidden";
					pkf.id = "__SiPkf";
					pkf.name = "__SiPkf";
					pkf.value = that.dataset.pageReturnEditField;
					form.appendChild(pkf);
					var value = "";
					if (that.dataset.PageReturnEditValue !== void 0) value = that.dataset.pageReturnEditValue ?? "";
					if (value === "") value = document.getElementById(that.dataset.pageReturnEditField).value;
					document.querySelectorAll("[name=\"__SiPk\"]").forEach((el) => el.remove());
					const pk = document.createElement("input");
					pk.type = "hidden";
					pk.id = "__SiPk";
					pk.name = "__SiPk";
					pk.value = value;
					form.appendChild(pk);
				}
				if (that.dataset.pageReturnEditFields !== void 0) {
					var value = that.dataset.pageReturnEditFields;
					if (value !== "") {
						var fieldsString = new DOMParser().parseFromString(value, "text/html").documentElement.textContent;
						var fields = JSON.parse(fieldsString);
						var fv = "";
						fields.forEach((e) => {
							if (e.V === "") e.V = document.getElementById(value).value;
							if (fv !== "") fv += "&";
							fv += (e.F + "=" + (e.V ?? "")).replace(/"/g, "&quot;");
						});
						document.querySelectorAll("[name=\"__SiPFs\"]").forEach((el) => el.remove());
						const pfs = document.createElement("input");
						pfs.type = "hidden";
						pfs.id = "__SiPFs";
						pfs.name = "__SiPFs";
						pfs.value = fv;
						form.appendChild(pfs);
					}
				}
				if (that.dataset.pageReturnEditSaveButtonName !== void 0) {
					document.querySelectorAll("[name=\"" + that.dataset.pageReturnEditSaveButtonName + "\"]").forEach((el) => el.remove());
					const saveButton = document.createElement("input");
					saveButton.type = "hidden";
					saveButton.id = "__SiSaveButton";
					saveButton.name = that.dataset.pageReturnEditSaveButtonName;
					saveButton.value = "1";
					form.appendChild(saveButton);
				}
				await IndexedDb.PageReturnSetAsync(document.querySelector("[name=\"__SiPageReturn\"]")?.value ?? "");
				form.trigger("submit");
			});
		});
	};
	return { Init };
})();
document.addEventListener("DOMContentLoaded", () => {
	PageReturn.Init();
});
//#endregion
//#region PasswordStrength/PasswordStrength.ts
/**
* @public 
*/
var PasswordStrength = (() => {
	const Init = () => {
		document.querySelectorAll("[data-password-id]").forEach((el) => {
			var id = el.dataset.passwordId;
			document.getElementById(id)?.addEventListener("keyup", () => {
				var pwd = document.getElementById(id).value;
				var len = pwd.length;
				var upper = pwd.toLowerCase() != pwd;
				var lower = pwd.toUpperCase() != pwd;
				var numeric = /\d/g.test(pwd);
				var symbol = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(pwd);
				var score = 0;
				if (upper) score++;
				if (lower) score++;
				if (numeric) score++;
				if (symbol) score++;
				var ps = document.querySelector("[data-password-id=\"" + id + "\"] [data-password-strength-main]");
				if (ps) {
					ps.classList.remove("pwd-not-current", "pwd-weak", "pwd-medium", "pwd-strong");
					ps.querySelectorAll("[data-password-strength-weak], [data-password-strength-medium], [data-password-strength-strong]").forEach((el) => {
						el.classList.remove("pwd-not-current", "pwd-weak", "pwd-medium", "pwd-strong");
					});
					if (score == 0) {
						ps.classList.add("pwd-not-current");
						ps.querySelectorAll("[data-password-strength-weak], [data-password-strength-medium], [data-password-strength-strong]").forEach((el) => {
							el.classList.add("pwd-not-current");
						});
						ps.querySelector("[data-password-strength-text]").innerHTML = "Weak";
					}
					if (score < 2 || len < 5) {
						ps.classList.add("pwd-weak");
						ps.querySelector("[data-password-strength-weak]")?.classList.add("pwd-weak");
						ps.querySelectorAll("[data-password-strength-medium], [data-password-strength-strong]").forEach((el) => {
							el.classList.add("pwd-not-current");
						});
						ps.querySelector("[data-password-strength-text]").innerHTML = "Weak";
					} else if (score == 2 || len < 8 || !upper || !lower || !numeric) {
						ps.classList.add("pwd-medium");
						ps.querySelectorAll("[data-password-strength-weak], [data-password-strength-medium]").forEach((el) => {
							el.classList.add("pwd-medium");
						});
						ps.querySelector("[data-password-strength-strong]")?.classList.add("pwd-not-current");
						ps.querySelector("[data-password-strength-text]").innerHTML = "Medium";
					} else if (score >= 3) {
						ps.classList.add("pwd-strong");
						ps.querySelectorAll("[data-password-strength-weak], [data-password-strength-medium], [data-password-strength-strong]").forEach((el) => {
							el.classList.add("pwd-strong");
						});
						ps.querySelector("[data-password-strength-text]").innerHTML = "Strong";
					}
				}
			});
		});
	};
	return { Init };
})();
document.addEventListener("DOMContentLoaded", () => {
	PasswordStrength.Init();
});
//#endregion
//#region Queue/Queue.ts
/**
* @public 
*/
var Queue = (() => {
	var _functions = [];
	var _functionFinal;
	var _timer = null;
	var _startTime = null;
	var _stepTimer = null;
	var _stepStartTime = null;
	var _stepRemaining = -1;
	var _stepAnimation = 0;
	const Start = async (id, baseUrl, jsFns, jsFnFinal, pageSize, start, to, total) => {
		var el = document.getElementById(id);
		if (!el) alert("Queue with id " + id + " not found.");
		else {
			if (!pageSize) pageSize = 100;
			if (!start) start = 1;
			if (!to) to = pageSize;
			if (!total) total = -1;
			document.querySelector("#" + id + " .modal-footer")?.classList.add("d-none");
			document.querySelectorAll("#" + id + ", #" + id + "_alert").forEach((e) => e.classList.remove("d-none"));
			document.querySelectorAll("#" + id + "_progress").forEach((e) => e.parentElement?.classList.remove("d-none"));
			var error = document.getElementById(id + "_error");
			if (error) error.innerHTML = "";
			document.querySelectorAll("#" + id + "_progress").forEach((e) => {
				e.style.width = "0%";
				e.innerHTML = "";
			});
			el.querySelectorAll("i").forEach((e) => {
				e.classList.add("fa-hourglass");
				e.classList.remove("fa-check", "fa-ban");
			});
			document.querySelectorAll("[data-si-queue-step]").forEach((e) => {
				e.classList.remove("QueueInProgress", "QueueSuccess", "QueueFail");
				e.classList.add("QueueWait");
			});
			new bootstrap.Modal(el).show();
			_functions = jsFns;
			if (jsFnFinal) _functionFinal = jsFnFinal;
			await DoQueueAsync(id, baseUrl, -1, 1, start, to, total, true);
		}
	};
	const TimeString = ((time) => {
		var s = "";
		if (time >= 3600) {
			var h = Math.trunc(time / 60 / 60);
			s += h + ":";
			time -= h * 60 * 60;
		}
		if (time >= 60) {
			var m = Math.trunc(time / 60);
			var sm = m.toString();
			if (sm.length < 2 && s !== "") sm = "0" + sm;
			s += sm + ":";
			time -= m * 60;
		}
		var ss = time.toString();
		if (s !== "") {
			if (ss.length < 2) ss = "0" + ss;
		} else ss += " sec";
		s += ss;
		return s;
	});
	const DoQueueAsync = async (id, baseUrl, index, page, current, to, total, complete) => {
		if (_timer == null) {
			_startTime = /* @__PURE__ */ new Date();
			_timer = setInterval(() => {
				var elapsedTime = Math.trunc((Date.now() - _startTime.getTime()) / 1e3);
				var html = "Total Time: " + TimeString(elapsedTime);
				var el = document.getElementById(id)?.querySelector("[data-total-time]");
				if (el) el.innerHTML = html;
			}, 1e3);
		}
		if (index < _functions.length) {
			if (_stepTimer == null && index !== -1) {
				_stepStartTime = /* @__PURE__ */ new Date();
				_stepRemaining = -1;
				_stepTimer = setInterval(() => {
					_stepAnimation++;
					if (_stepAnimation == 2) {
						var elapsedTime = Math.trunc((Date.now() - _stepStartTime.getTime()) / 1e3);
						var html = "<span class=\"badge rounded-pill bg-light border border-1 border-primary text-primary\">" + TimeString(elapsedTime) + "</span>";
						if (_stepRemaining !== -1) html = "<span class=\"badge rounded-pill bg-light border border-1 border-success text-success me-2\" data-estimate>Est: " + TimeString(_stepRemaining) + "</span>" + html;
						var el = document.getElementById(id);
						if (el) {
							var step = el.querySelectorAll("[data-si-queue-step]")[index];
							if (step) {
								var timeEl = step.querySelector("[data-time]");
								if (timeEl) timeEl.innerHTML = html;
								var fa = step.querySelector(".fa");
								if (fa) {
									if (fa.classList.contains("fa-hourglass") || fa.classList.contains("fa-hourglass-end")) {
										fa.classList.remove("fa-hourglass", "fa-hourglass-end");
										fa.classList.add("fa-hourglass-start");
									} else if (fa.classList.contains("fa-hourglass-start")) {
										fa.classList.remove("fa-hourglass-start");
										fa.classList.add("fa-hourglass-half");
									} else if (fa.classList.contains("fa-hourglass-half")) {
										fa.classList.remove("fa-hourglass-half");
										fa.classList.add("fa-hourglass-end");
									}
								}
							}
						}
						_stepAnimation = 0;
					}
					var el = document.getElementById(id);
					if (el) {
						var step = el.querySelectorAll("[data-si-queue-step]")[index];
						if (step) {
							var fa = step.querySelector(".fa");
							if (fa) {
								if (fa.classList.contains("fa-hourglass") || fa.classList.contains("fa-hourglass-end")) {
									fa.classList.remove("fa-hourglass", "fa-hourglass-end");
									fa.classList.add("fa-hourglass-start");
								} else if (fa.classList.contains("fa-hourglass-start")) {
									fa.classList.remove("fa-hourglass-start");
									fa.classList.add("fa-hourglass-half");
								} else if (fa.classList.contains("fa-hourglass-half")) {
									fa.classList.remove("fa-hourglass-half");
									fa.classList.add("fa-hourglass-end");
								}
							}
						}
					}
				}, 500);
			}
			if (!complete) {
				if (current === void 0) current = 0;
				if (to === void 0) to = 0;
				if (total === void 0) total = 0;
				if (_functions[index].hasTotal === void 0) _functions[index].hasTotal = true;
				var status = total === -1 ? "Processing..." : total === 0 ? "All done" : "Processing " + current + " - " + to + (_functions[index].hasTotal ? " of " + total : "");
				await CallFunctionAsync(id, baseUrl, index, status, page);
			} else {
				var elId = document.getElementById(id);
				if (index !== -1) elId?.dispatchEvent(new CustomEvent("stepend", { detail: index }));
				await DelayAsync(800);
				var el = document.getElementById(id + "_progress");
				if (el) {
					el.style.width = "0%";
					el.innerHTML = "";
				}
				if (_stepTimer != null) clearInterval(_stepTimer);
				_stepTimer = null;
				if (elId) {
					var step = elId.querySelectorAll("[data-si-queue-step]")[index];
					if (step) {
						var span = step.querySelector("[data-time] span");
						if (span) {
							span.classList.remove("badge", "rounded-pill", "bg-light", "border", "border-1", "border-primary", "text-primary");
							span.classList.add("form-text");
							span.querySelectorAll("[data-estimate]").forEach((el) => el.remove());
						}
					}
				}
				index++;
				_stepAnimation = 0;
				elId?.dispatchEvent(new CustomEvent("stepstart", { detail: index }));
				await DoQueueAsync(id, baseUrl, index, 1, 1, 100, -1, false);
			}
		} else await EndAsync(id, "Complete");
	};
	const CallFunctionAsync = async (id, baseUrl, index, status, page) => {
		var fns = _functions[index];
		var itemDiv = document.getElementById(id + "_" + fns.stepId);
		itemDiv?.classList.remove("QueueWait");
		itemDiv?.classList.add("QueueInProgress");
		var headers = Ajax.Headers();
		var jTemp = { page };
		var json = jTemp;
		if (fns.process !== void 0) {
			if (fns.process !== null) {
				var jData = null;
				if (fns.process.constructor.name === "AsyncFunction") jData = await fns.process();
				else jData = fns.process();
				json = {
					...jTemp,
					...jData
				};
				if (status === "") {
					var current = jData.current === void 0 ? 0 : jData.current;
					var to = jData.to === void 0 ? 0 : jData.to;
					var total = jData.total === void 0 ? 0 : jData.total;
					status = jData.total === -1 ? "Processing" : jData.total === 0 ? "All done" : "Processing " + current + " - " + to + (fns.hasTotal ? " of " + total : "");
				}
			}
		}
		var el = document.getElementById(id + "_status");
		if (el) el.innerHTML = status;
		const params = new URLSearchParams();
		Object.entries(json).forEach(([key, value]) => {
			if (Array.isArray(value)) value.forEach((v) => params.append(key, String(v)));
			else params.append(key, String(value));
		});
		const response = await fetch(baseUrl + fns.serverFn, {
			method: "POST",
			headers,
			body: params
		});
		if (!response.ok) {
			document.getElementById(id + "_alert")?.classList.add("d-none");
			var errorArray = new Array();
			errorArray.push({
				category: "Application Error",
				error: await response.text()
			});
			AddErrors(id, errorArray);
			itemDiv?.querySelectorAll("i").forEach((e) => {
				e.classList.remove("fa-hourglass", "fa-hourglass-start", "fa-hourglass-half", "fa-hourglass-end");
				e.classList.add("fa-ban");
			});
			itemDiv?.classList.remove("QueueInProgress");
			itemDiv?.classList.add("QueueFail");
			await EndAsync(id, " Failed!");
		}
		var d = await response.json();
		if (d.success) {
			if (fns.end !== void 0 && fns.end !== null) {
				var result = {
					jData,
					data: d.data,
					d
				};
				if (fns.end.constructor.name === "AsyncFunction") await fns.end(result);
				else fns.end(result);
			}
			if (d.itemComplete) {
				itemDiv?.classList.remove("QueueInProgress");
				itemDiv?.classList.add("QueueSuccess");
				itemDiv?.querySelectorAll("i").forEach((e) => {
					e.classList.remove("fa-hourglass", "fa-hourglass-start", "fa-hourglass-half", "fa-hourglass-end");
					e.classList.add("fa-check");
				});
			}
			AddErrors(id, d.errors);
			var elProgress = document.getElementById(id + "_progress");
			if (elProgress) {
				elProgress.style.width = d.totalPercent + "%";
				elProgress.innerHTML = d.totalPercent + "%";
			}
			var elId = document.getElementById(id);
			if (elId) {
				var step = elId.querySelectorAll("[data-si-queue-step]")[index];
				if (step) {
					var eCount = step.querySelector("[data-count]");
					if (eCount) {
						var count = String(d.itemComplete ? d.to : d.current - 1);
						if (d.date !== void 0 && d.date !== null) {
							var sDate = d.date.toString();
							var year = sDate.substring(0, 4);
							var month = sDate.substring(5, 6);
							var day = sDate.substring(8, 9);
							count += " <span class=\"form-text\"> - " + day + "/" + month + "/" + year + "</span>";
						}
						eCount.innerHTML = count;
					}
				}
			}
			if (fns.hasTotal) {
				var elapsedTime = Math.trunc((Date.now() - _stepStartTime.getTime()) / 1e3);
				_stepRemaining = Number((elapsedTime / (d.current - 1) * (d.total - (d.current - 1))).toFixed(0));
			}
			await DoQueueAsync(id, baseUrl, index, page + 1, d.current, d.to, d.total, d.itemComplete);
		} else if (d.redirectUrl !== null) window.location.href = d.redirectUrl;
		else {
			document.getElementById(id + "_alert")?.classList.add("d-none");
			AddErrors(id, d.errors);
			itemDiv?.querySelectorAll("i").forEach((e) => {
				e.classList.remove("fa-hourglass", "fa-hourglass-start", "fa-hourglass-half", "fa-hourglass-end");
				e.classList.add("fa-ban");
			});
			itemDiv?.classList.remove("QueueInProgress");
			itemDiv?.classList.add("QueueFail");
			await EndAsync(id, "Failed!");
		}
	};
	const EndAsync = async (id, status) => {
		await DelayAsync(800);
		document.querySelectorAll("#" + id + "_alert").forEach((e) => e.classList.add("d-none"));
		document.querySelectorAll("#" + id + "_progress").forEach((e) => e.parentElement?.classList.add("d-none"));
		document.querySelector("#" + id + " .modal-footer")?.classList.remove("d-none");
		var el = document.getElementById(id + "_status");
		if (el) el.innerHTML = status;
		if (_functionFinal !== void 0) {
			if (_functionFinal !== null) await Promise.resolve(_functionFinal());
		}
		if (_timer != null) clearInterval(_timer);
		if (_stepTimer != null) clearInterval(_stepTimer);
		_timer = null;
	};
	const AddErrors = (id, errors) => {
		if (errors != null) errors.forEach((e) => {
			var first = false;
			var html = document.getElementById(id + "_error");
			if (html) {
				first = html.innerHTML === "";
				if (first) {
					html.classList.add("mb-4");
					const div = document.createElement("div");
					div.className = "alert alert-danger";
					div.append("Error Count: ");
					const span = document.createElement("span");
					span.id = id + "_error_count";
					div.appendChild(span);
					html.appendChild(div);
				}
				var safeCategory = e.category === null ? "General" : e.category.replace(/ /g, "").replace(/\$/g, "");
				var categoryId = "SiQueueErrorCat" + safeCategory;
				var category = html?.querySelector("#" + categoryId);
				if (!category) {
					var listId = "SiQueueErrorList" + safeCategory;
					const item = document.createElement("div");
					item.className = "accordion-item";
					category = document.createElement("h2");
					category.className = "accordion-header";
					category.id = categoryId;
					const button = document.createElement("button");
					button.className = "accordion-button fw-600" + (first ? "" : " collapsed");
					button.type = "button";
					button.dataset.bsToggle = "collapse";
					button.dataset.bsTarget = "#" + listId;
					button.setAttribute("aria-expanded", first ? "true" : "false");
					button.setAttribute("aria-controls", listId);
					button.textContent = e.category;
					category.appendChild(button);
					const collapse = document.createElement("div");
					collapse.id = listId;
					collapse.className = "accordion-collapse collapse" + (first ? " show" : "");
					collapse.setAttribute("aria-labelledby", categoryId);
					collapse.dataset.bsParent = "#" + id + "_error";
					const body = document.createElement("div");
					body.className = "accordion-body";
					collapse.appendChild(body);
					item.append(category, collapse);
					html.appendChild(item);
				}
				var htmlError = document.createElement("div");
				htmlError.className = "mb-2";
				htmlError.innerHTML = e.error;
				category?.closest(".accordion-item")?.querySelector(".accordion-body")?.append(htmlError);
				var errorCount = html.querySelector("#" + id + "_error_count");
				var errorCountNum = parseInt(errorCount?.innerHTML ?? "0");
				if (isNaN(errorCountNum)) errorCountNum = 0;
				errorCountNum++;
				errorCount.innerHTML = String(errorCountNum);
			}
		});
	};
	return { Start };
})();
//#endregion
//#region ReadMore/ReadMore.ts
/**
* @public 
*/
var ReadMore = (() => {
	const Init = () => {
		document.querySelectorAll(".morebutton").forEach((el) => {
			el.addEventListener("click", (e) => {
				e.stopPropagation();
				var that = e.currentTarget.firstElementChild;
				var o = that.parentElement?.parentElement?.querySelector("[data-more-height]");
				var lessHeight = Number(o.dataset.moreHeight);
				if (that.innerHTML === "<i class=\"fas fa-angle-double-down\"></i>") {
					var height = o.firstElementChild.scrollHeight;
					that.innerHTML = "<i class=\"fas fa-angle-double-up\"></i>";
					if (height > lessHeight) o.style.setProperty("--si-more-height", height + "px");
				} else {
					that.innerHTML = "<i class=\"fas fa-angle-double-down\"></i>";
					o.style.setProperty("--si-more-height", lessHeight + "px");
				}
				return false;
			});
			if (document.querySelector("[data-more-height]")) {
				window.addEventListener("resize", Adjust);
				Adjust();
			}
		});
	};
	const Adjust = () => {
		document.querySelectorAll("[data-more-height]").forEach((el) => {
			var e = el;
			if (e.scrollHeight > Number(e.dataset.moreHeight)) {
				e.style.setProperty("--si-more-height", e.dataset.moreHeight + "px");
				e.parentElement?.querySelector(".morebutton")?.classList.remove("d-none");
			} else e.parentElement?.querySelector(".morebutton")?.classList.add("d-none");
		});
	};
	return { Init };
})();
document.addEventListener("DOMContentLoaded", () => {
	ReadMore.Init();
});
//#endregion
//#region Required/Required.ts
/**
* @public 
*/
var Required = (() => {
	const Init = () => {
		document.querySelectorAll("[data-si-required], [data-val-required]").forEach((el) => {
			el.addEventListener("change", Refresh);
			el.addEventListener("focus", Refresh);
			el.addEventListener("blur", Refresh);
			RefreshRequired(el);
		});
	};
	const Refresh = (e) => {
		var that = e.currentTarget;
		RefreshRequired(that);
	};
	const RefreshRequired = (el) => {
		if (el.type === "radio") {
			if ("siRequired" in el.dataset) {
				if (document.querySelector("[name=\"" + el.name + "\"]:checked")) el.parentElement?.parentElement?.classList.remove("si-required");
				else el.parentElement?.parentElement?.classList.add("si-required");
			} else el.parentElement?.parentElement?.classList.remove("si-required");
		} else if ("siRequired" in el.dataset) {
			if (el.value === "") el.classList.add("si-required");
			else el.classList.remove("si-required");
		} else el.classList.remove("si-required");
	};
	const MakeRequired = (el) => {
		el.dataset.siRequired = "";
		RefreshRequired(el);
	};
	const RemoveRequired = (el) => {
		delete el.dataset.siRequired;
		RefreshRequired(el);
	};
	return {
		Init,
		MakeRequired,
		RemoveRequired
	};
})();
document.addEventListener("DOMContentLoaded", () => {
	Required.Init();
});
//#endregion
//#region Table/ShareItGrid.ts
/**
* @public 
*/
var ShareItGrid = (() => {
	const Submit = (gridId, action, eps) => {
		var grid = document.getElementById(gridId);
		if (grid === void 0 || grid === null) {
			alert("Grid " + gridId + " not found!");
			return;
		}
		var form = null;
		var tAction = "";
		var ajaxSubmit = grid.dataset.ajaxSubmit !== void 0;
		var data = {};
		if (!ajaxSubmit) {
			form = grid.closest("form");
			if (form === null) {
				alert("Grid " + gridId + " is not inside a form!");
				return;
			}
			if (action !== void 0) {
				if (form !== null) {
					var tAction = form?.action;
					if (action.indexOf("/") === -1) action = window.location.pathname + "/" + action;
					form.action = action;
				}
			}
		}
		if (grid.parentElement?.dataset.shareitGridAjaxUrl !== void 0) {
			var gridContainerId = grid.parentElement.id;
			var epa;
			var epaa;
			if (eps !== void 0) {
				if (eps !== "") {
					epa = eps.split("|");
					for (var j = 0; j < epa.length; j++) {
						epaa = epa[j].split("=");
						if (!ajaxSubmit) {
							const input = document.createElement("input");
							input.type = "hidden";
							input.name = epaa[0].trim();
							input.value = epaa[1].trim();
							form?.appendChild(input);
						} else data[epaa[0].trim()] = epaa[1].trim();
					}
				}
			}
			var eps2 = document.getElementById(gridContainerId)?.dataset.ep;
			if (eps2 !== void 0 && eps2 !== "") {
				epa = eps2.split("|");
				for (var j = 0; j < epa.length; j++) {
					epaa = epa[j].split("=");
					if (!ajaxSubmit) {
						const input = document.createElement("input");
						input.type = "hidden";
						input.name = epaa[0].trim();
						input.value = epaa[1].trim();
						form?.appendChild(input);
					} else data[epaa[0].trim()] = epaa[1].trim();
				}
			}
		}
		if (!ajaxSubmit && form) {
			if (grid.dataset.triggerSave !== void 0) {
				const input = document.createElement("input");
				input.type = "hidden";
				input.name = "Save";
				input.value = "1";
				form?.appendChild(input);
			}
			document.getElementById(gridId + "_gridaction").value = "true";
			form.submit();
			if (action !== void 0) form.action = tAction;
		} else {
			data["rowId"] = document.getElementById(gridId + "_rowid").value;
			grid.dispatchEvent(new CustomEvent("submit", { detail: data }));
		}
	};
	const AjaxSubmitAsync = async (gridContainerId, action, childId, eventToTrigger) => {
		var gridContainer = document.getElementById(gridContainerId);
		if (gridContainer == null) {
			alert("Grid Container " + gridContainerId + " not found.");
			return;
		}
		var timerId = setTimeout(() => {
			gridContainer?.querySelectorAll(".ShareItGrid").forEach((el) => {
				ShowWaiting(el);
			});
		}, 400);
		if (action === void 0) action = gridContainer.dataset.shareitGridAjaxUrl;
		var data = {
			ShareItGridAjaxUrl: action,
			ShareItGridAjaxDestination: gridContainerId
		};
		var readOnly = gridContainer.dataset.readOnly;
		if (readOnly !== void 0) data["ReadOnly"] = readOnly;
		var externalAddButton = gridContainer.dataset.externalAddButton;
		if (externalAddButton !== void 0) data["ExternalAddButton"] = externalAddButton;
		var externalAddButtonClass = gridContainer.dataset.externalAddButtonClass;
		if (externalAddButtonClass !== void 0) data["ExternalAddButtonClass"] = externalAddButtonClass;
		var externalAddButtonText = gridContainer.dataset.externalAddButtonText;
		if (externalAddButtonText !== void 0) data["ExternalAddButtonText"] = externalAddButtonText;
		var gridMeta = await IndexedDb.GridGetAsync(gridContainerId);
		data["sort"] = gridMeta === void 0 ? null : gridMeta.sortField;
		data["direction"] = gridMeta === void 0 ? null : gridMeta.direction;
		data["page"] = gridMeta === void 0 ? null : gridMeta.page;
		var gridId = childId === void 0 ? document.getElementById(gridContainerId)?.querySelector("table")?.id : childId;
		if (gridId !== void 0) {
			var gid = CSS.escape(gridId);
			var rowId = document.getElementById(gid + "_rowid");
			if (rowId) data[rowId.getAttribute("name")] = rowId.value;
			var rowActive = document.getElementById(gid + "_active");
			if (rowActive) data[rowActive.getAttribute("name")] = rowActive.value;
			data["GridId"] = gridId;
		}
		var apf = gridContainer.dataset.autoPostFilters;
		if (apf !== void 0) {
			if (apf === "True") {
				var filterIds = gridContainer.dataset.filterIds;
				var filterFields = [];
				if (filterIds !== void 0 && filterIds !== "") {
					var fid = filterIds.split(",");
					for (var i = 0; i < fid.length; i++) {
						var foid = document.getElementById(CSS.escape(fid[i].trim()))?.querySelector(".FilterField [id]");
						if (foid != null) filterFields.push(foid);
					}
				} else if (gridContainer.dataset.filterId !== void 0) {
					const elements = document.querySelectorAll("#" + CSS.escape(gridContainer.dataset.filterId) + " .FilterField [id]");
					if (elements) filterFields.push(...Array.from(elements));
				} else {
					const elements = document.querySelectorAll(".Filter .FilterField [id]");
					if (elements) filterFields.push(...Array.from(elements));
				}
				filterFields.forEach((e) => {
					if (e.id !== void 0) {
						var o = document.getElementById(CSS.escape(e.id));
						if (o.type === "radio" || o.type === "checkbox") data[e.id] = o.checked;
						else data[e.id] = o.value;
					}
				});
			}
		}
		var ids = gridContainer.dataset.controlIds;
		if (ids !== void 0) {
			if (ids !== "") {
				var ida = ids.split(",");
				for (var i = 0; i < ida.length; i++) {
					var o = document.getElementById(CSS.escape(ida[i].trim()));
					if (o) {
						if (o.type === "radio" || o.type === "checkbox") data[ida[i].trim()] = o.checked;
						else data[ida[i].trim()] = o.value;
					}
				}
			}
		}
		var eps = gridContainer.dataset.ep;
		if (eps !== void 0) {
			if (eps !== "") {
				var epa = eps.split("|");
				for (var j = 0; j < epa.length; j++) {
					var epaa = epa[j].split("=");
					data[epaa[0].trim()] = epaa[1].trim();
				}
			}
		}
		var headers = {
			...Ajax.Headers(),
			"SilPartial": "1"
		};
		const dataForm = new URLSearchParams(data).toString();
		const response = await fetch(action, {
			method: "POST",
			headers,
			body: dataForm
		});
		if (!response.ok) {
			if (timerId !== void 0) clearTimeout(timerId);
			var gid = gridContainer.id;
			var d = (await response.text()).replaceAll("<script", "<div").replaceAll("<\/script", "</div");
			gridContainer.innerHTML = "<div class=\"ShareItGrid text-center\"><div data-show-error><h5><span class=\"me-2\">Oh No!</span> That's not right...</h5><p>Something didn't quite work as expected. <i class=\"far fa-sad-tear\"></i> Please contact technical support.</p></div><div class=\"text-left d-none\">" + d + "</div><div><a data-reset role=\"Button\" class=\"btn btn-secondary form-text btn-sm\"><i class=\"fa-solid fa-clock-rotate-left me-2\"></i> Reset Grid</a></div></div>";
			gridContainer.querySelector("[data-show-error]")?.addEventListener("click", (e) => {
				(e.currentTarget.parentElement?.children[1])?.classList.toggle("d-none");
			});
			gridContainer.querySelector("[data-reset]")?.addEventListener("click", async (e) => {
				e.preventDefault();
				await IndexedDb.GridClearAsync(gid);
				await SubmitterAsync(gid);
			});
		} else {
			var d = await response.text();
			if (timerId !== void 0) clearTimeout(timerId);
			if (childId !== void 0) AjaxButtonInit(childId);
			if (eventToTrigger != "delete") {
				gridContainer.innerHTML = d;
				var g = gridContainer.querySelector(".ShareItGrid");
				if (g) {
					var childGridId = g.id;
					gridContainer.dataset.childId = childGridId;
					await InitGridAsync(g);
					gridContainer.dispatchEvent(new Event("loaded"));
				}
			} else await AjaxSubmitAsync(gridContainerId);
			if (eventToTrigger) gridContainer.dispatchEvent(new Event(eventToTrigger));
		}
	};
	const SubmitterAsync = async (gridId, action, eventToTrigger) => {
		var ajaxGrid = document.getElementById(gridId)?.closest(".si-ajax-grid");
		if (ajaxGrid) {
			var gridContainerId = ajaxGrid.id;
			await AjaxSubmitAsync(gridContainerId, action, gridId, eventToTrigger);
		} else {
			if (eventToTrigger !== void 0) document.getElementById(gridId)?.dispatchEvent(new Event(eventToTrigger));
			Submit(gridId, action);
		}
	};
	const ShowWaiting = (g) => {
		var gridContainer = g.closest(".si-ajax-grid");
		if (gridContainer) {
			var html = "<div class=\"WaitingOuterChild\" style=\"height: " + gridContainer.clientHeight + "px; width: " + gridContainer.clientWidth + "px\"><div class=\"WaitingChild\"><div class=\"text-center\"><div class=\"spinner-border text-primary\" role=\"status\"></div><p>Loading Data...</p></div></div></div>";
			gridContainer.insertAdjacentHTML("afterbegin", html);
		}
	};
	const InitGridAsync = async (g) => {
		var id = g.id;
		var grid = document.getElementById(id);
		if (grid == null) {
			alert("Missing Grid for " + id);
			return;
		}
		var gridContainerId = g.closest(".si-ajax-grid").id;
		if (gridContainerId == null) {
			alert("Missing Grid Container Id for " + id);
			return;
		}
		var rowId = document.getElementById(id + "_rowid");
		g.querySelectorAll("th a[data-sort]").forEach((el) => {
			el.addEventListener("click", async (e) => {
				e.preventDefault();
				var that = e.currentTarget;
				var direction = that.dataset.direction === "Asc" ? "Desc" : "Asc";
				await IndexedDb.GridSetAsync(gridContainerId, that.dataset.field, direction, null);
				await SubmitterAsync(id);
			});
		});
		g.querySelectorAll("tfoot .paging a").forEach((el) => {
			el.addEventListener("click", async (e) => {
				e.preventDefault();
				var that = e.currentTarget;
				await IndexedDb.GridSetAsync(gridContainerId, null, null, that.dataset.sipage);
				await SubmitterAsync(id);
			});
		});
		g.querySelectorAll("th a[data-reset]").forEach((el) => {
			el.addEventListener("click", async (e) => {
				e.preventDefault();
				await IndexedDb.GridClearAsync(gridContainerId);
				await SubmitterAsync(id, void 0, void 0);
			});
		});
		g.querySelectorAll("th a[data-refresh]").forEach((el) => {
			el.addEventListener("click", async (e) => {
				e.preventDefault();
				await SubmitterAsync(id, void 0, void 0);
			});
		});
		if (g.dataset.triggerSave === void 0) g.querySelectorAll("th a[data-type=\"add\"], a[data-type=\"add\"]").forEach((el) => {
			el.addEventListener("click", (e) => {
				e.preventDefault();
				var that = e.currentTarget;
				var addId = that.dataset.addid;
				if (addId !== void 0) rowId.value = addId;
				var action = that.dataset.action;
				if (action === void 0) action = that.closest("table")?.dataset.action;
				var eps = that.closest("table")?.dataset.ep;
				if (eps === void 0) {
					if (that.closest(".ShareItGrid")?.parentElement?.dataset.shareitGridAjaxUrl !== "undefined") eps = that.closest(".ShareItGrid")?.parentElement?.dataset.ep;
				}
				Submit(id, action, eps);
			});
		});
		if (g.dataset.triggerSave === void 0) document.querySelector("a[data-type=\"add\"][data-share-it-grid=\"" + id + "\"]")?.addEventListener("click", (e) => {
			e.preventDefault();
			var that = e.currentTarget;
			var addId = that.dataset.addid;
			if (addId !== void 0) rowId.value = addId;
			var action = that.dataset.action;
			if (action === void 0) action = grid.dataset.action;
			var eps = that.dataset.ep;
			Submit(id, action, eps);
		});
		if (g.dataset.triggerSave === void 0) g.querySelectorAll("td a[data-type=\"edit\"]").forEach((el) => {
			el.addEventListener("click", (e) => {
				e.preventDefault();
				var that = e.currentTarget;
				var editId = that.dataset.editid;
				if (editId === void 0) editId = that.closest("tr")?.dataset.rowid;
				var action = that.dataset.action;
				if (action === void 0) action = that.closest("table")?.dataset.action;
				var prop = that.dataset.editidproperty;
				if (prop !== void 0) rowId.setAttribute("name", prop);
				rowId.value = editId ?? "";
				Submit(id, action);
			});
		});
		if (g.dataset.triggerSave === void 0) g.querySelectorAll("tbody tr").forEach((el) => {
			el.addEventListener("dblclick", (e) => {
				e.preventDefault();
				e.currentTarget.querySelectorAll("td a[data-type=\"edit\"]").forEach((el) => {
					var editId = el.dataset.editid;
					if (editId === void 0) editId = el.closest("tr")?.dataset.rowid;
					var action = el.dataset.action;
					if (action === void 0) action = el.closest("table")?.dataset.action;
					var prop = el.dataset.editidproperty;
					if (prop !== void 0) rowId.setAttribute("name", prop);
					rowId.value = editId ?? "";
					Submit(id, action);
				});
			});
		});
		document.querySelectorAll("#" + id + " tr").forEach((el, index) => {
			if (index > 0) {
				const anch = el.querySelector("td:last-child")?.querySelector("a");
				if (anch) {
					if (anch.getAttribute("title") === "Undelete this item") el.classList.add("Deleted");
				}
			}
		});
		g.querySelectorAll("td a[data-type=\"delete\"]").forEach((el) => {
			el.addEventListener("click", async (e) => {
				e.preventDefault();
				var that = e.currentTarget;
				var ok = true;
				var active = that.dataset.active;
				if (grid.dataset.deleteconfirm !== void 0) {
					if (active === "True") ok = confirm(grid.dataset.deleteconfirm);
					else ok = confirm(grid.dataset.undeleteconfirm);
				}
				if (ok) {
					var deleteId = that.dataset.deleteid;
					if (deleteId === void 0) deleteId = that.closest("tr")?.dataset.rowid;
					rowId.value = deleteId ?? "";
					var activeField = document.getElementById(id + "_active");
					if (activeField) activeField.value = active ?? "";
					await SubmitterAsync(id, that.dataset.action, "delete");
				}
			});
		});
		var cache = g.querySelectorAll("[data-si-cache]");
		if (cache.length) {
			var cacheIds = [];
			var cacheFieldIds = [];
			cache.forEach((el) => {
				var fieldId = el.dataset.siCacheField;
				if (fieldId) {
					if (!cacheFieldIds.includes(fieldId)) cacheFieldIds.push(fieldId);
					if (el.dataset.siCacheField != void 0) if (el.dataset.siCacheValueId === void 0) cacheIds.push([el.dataset.siCacheField, el.closest("tr")?.dataset.rowid ?? ""]);
					else cacheIds.push([el.dataset.siCacheField, el.dataset.siCacheValueId]);
				}
			});
			var parentId = g.dataset.siCacheParentId;
			if (parentId !== void 0) for (var fi = 0; fi < cacheFieldIds.length; fi++) {
				var thisFieldCacheIds = [];
				for (var i = 0; i < cacheIds.length; i++) if (cacheIds[i][0] === cacheFieldIds[fi]) thisFieldCacheIds.push(cacheIds[i][1]);
				(await IndexedDb.GridFieldValuesGetAsync(id, cacheFieldIds[fi], thisFieldCacheIds, parentId)).forEach((el) => {
					var target = null;
					var row = document.querySelector("[data-rowid=\"" + el.rowId + "\"]");
					if (row !== void 0 && row != null) target = row.querySelector("[data-si-cache-field=\"" + el.fieldId + "\"]");
					else target = document.querySelector("[data-si-cache-field=\"" + el.fieldId + "\"][data-si-cache-value-id=\"" + el.rowId + "\"]");
					if (target != null) if (target.type === "checkbox") target.checked = el.value;
					else target.value = el.value;
				});
			}
			cache.forEach((el) => {
				el.addEventListener("change", async (e) => {
					var that = e.currentTarget;
					var valueId = that.dataset.siCacheValueId;
					if (valueId === void 0) valueId = that.closest("[data-rowid]")?.dataset.rowid;
					var value = null;
					if (that.type === "checkbox") value = that.checked;
					else value = that.value;
					var parentId = that.closest(".ShareItGrid")?.dataset.siCacheParentId;
					await IndexedDb.GridFieldSetAsync(id, that.dataset.siCacheField, valueId, value, parentId);
				});
			});
		}
	};
	const SelectAll = (selector) => {
		document.querySelectorAll(selector).forEach((el) => {
			el.checked = true;
			el.dispatchEvent(new Event("change"));
		});
	};
	const CacheValuesAsync = async (gridId, fieldId) => {
		var that = document.getElementById(gridId);
		if (that?.classList.contains("si-ajax-grid")) {
			var id = that.querySelector(".ShareItGrid")?.id;
			if (id != void 0) {
				var parentId = that.querySelector(".ShareItGrid")?.dataset.siCacheParentId;
				if (parentId != void 0) {
					var rows = [];
					rows = await IndexedDb.GridFieldValuesGetAsync(id, fieldId, void 0, parentId);
					return rows.filter((el) => el.value);
				}
			}
		}
		return [];
	};
	const FieldCacheRemoveAsync = async (gridId, fieldId, rowIds) => {
		var that = document.getElementById(gridId);
		if (that?.classList.contains("si-ajax-grid")) {
			var id = that.querySelector(".ShareItGrid")?.id;
			if (id != void 0) {
				var parentId = that.querySelector(".ShareItGrid")?.dataset.siCacheParentId;
				if (parentId != void 0) await IndexedDb.GridFieldRemoveAsync(id, fieldId, rowIds, parentId);
			}
		}
	};
	const ClearFieldCacheValuesAsync = async (gridId, fieldId) => {
		var that = document.getElementById(gridId);
		if (that?.classList.contains("si-ajax-grid")) {
			var id = that.querySelector(".ShareItGrid")?.id;
			if (id != void 0) {
				var parentId = that.querySelector(".ShareItGrid")?.dataset.siCacheParentId;
				if (parentId != void 0) await IndexedDb.GridFieldClearAsync(id, fieldId, parentId);
			}
		}
	};
	const AjaxLoadAsync = async (gridId) => {
		var g = document.getElementById(gridId);
		if (g) {
			var id = g.id;
			var action = g.dataset.shareitGridAjaxUrl;
			var childId = g.dataset.childId;
			await AjaxSubmitAsync(id, action, childId);
		}
	};
	const AjaxButtonInit = (gridId) => {
		document.querySelectorAll("a[data-share-it-grid=\"" + gridId + "\"]").forEach((el) => {
			el.addEventListener("click", (e) => {
				e.preventDefault();
				var that = e.currentTarget;
				var g = document.getElementById(gridId);
				var action = g.querySelector("th a[data-action]")?.dataset.action;
				if (action === void 0) action = g.querySelector("a[data-type=\"add\"]")?.dataset.action;
				if (action === void 0) action = g.dataset.action;
				var eps = that.dataset.ep;
				Submit(gridId, action, eps);
			});
		});
	};
	const Start = () => {
		document.querySelectorAll("[data-shareit-grid-ajax-url]").forEach((e) => {
			var g = e;
			if (document.querySelectorAll(".Filter")) g.addEventListener("load", async (e) => {
				if (g.dataset.filterId !== void 0) {
					if (e.currentTarget.id == g.dataset.filterId) await AjaxLoadAsync(g.id);
				} else await AjaxLoadAsync(g.id);
			});
			else if (g.dataset.manualLoad !== "True") (async () => {
				await AjaxLoadAsync(g.id);
			})();
		});
		document.querySelectorAll(".ShareItGrid").forEach((el) => {
			(async () => {
				await InitGridAsync(el);
			})();
		});
		document.querySelectorAll("a[data-share-it-grid]").forEach((el) => {
			el.addEventListener("click", (e) => {
				e.preventDefault();
				var that = e.currentTarget;
				var id = that.dataset.shareItGrid;
				if (id) {
					var grid = document.getElementById(id);
					var action = grid.querySelector("th a[data-action]")?.dataset.action;
					if (action === void 0) action = grid.querySelector("a[data-type=\"add\"]")?.dataset.action;
					if (action === void 0) action = grid.dataset.action;
					var eps = that.dataset.ep;
					Submit(id, action, eps);
				}
			});
		});
		window.siSignalGridsReady();
	};
	const ExtraParameterSet = async (gridId, parameter, value) => {
		var g = document.getElementById(gridId);
		if (g) {
			var eps = (g.dataset.ep ?? "").split("|");
			const index = eps.findIndex((e) => e.startsWith(parameter + "="));
			if (index >= 0) eps[index] = parameter + "=" + (value ?? "");
			else eps.push(parameter + "=" + (value ?? ""));
			g.dataset.ep = eps.join("|");
		}
	};
	return {
		Start,
		AjaxLoadAsync,
		SelectAll,
		CacheValuesAsync,
		FieldCacheRemoveAsync,
		ClearFieldCacheValuesAsync,
		AjaxButtonInit,
		ExtraParameterSet
	};
})();
document.addEventListener("DOMContentLoaded", () => {
	ShareItGrid.Start();
});
//#endregion
//#region SwitchGridFilter/SwitchGridFilter.ts
/**
* @public 
*/
var SwitchGridFilter = (() => {
	const Init = () => {
		document.querySelectorAll("[data-si-switch-grid]").forEach((el) => {
			el.addEventListener("click", async (e) => {
				var switchG = e.currentTarget.dataset.siSwitchGrid;
				if (switchG) await ShareItGrid.AjaxLoadAsync(switchG);
			});
		});
	};
	return { Init };
})();
document.addEventListener("DOMContentLoaded", () => {
	SwitchGridFilter.Init();
});
//#endregion
//#region Timezone/Timezone.ts
/**
* @public 
*/
var Timezone = (() => {
	const Init = () => {
		document.querySelectorAll("[data-timezone]").forEach((e) => {
			if (e.value === "") AutoDetect(e);
		});
		document.querySelectorAll("[data-auto-detect]").forEach((el) => {
			el.addEventListener("click", (e) => {
				var id = e.currentTarget.dataset.autoDetect;
				if (id !== void 0) {
					var o = document.getElementById(id);
					AutoDetect(o);
				}
			});
		});
	};
	const AutoDetect = (o) => {
		var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
		var optionIana = o.querySelector("[data-iana~=\"" + tz + "\"]");
		if (optionIana) o.value = optionIana.value;
	};
	return { Init };
})();
document.addEventListener("DOMContentLoaded", () => {
	Timezone.Init();
});
//#endregion
//#region Waiting/Waiting.ts
/**
* @public 
*/
var Waiting = (() => {
	const Init = () => {
		Hide("Waiting");
	};
	const Show = (id) => {
		var el = document.getElementById(id);
		if (el && el.dataset.targetId !== void 0) {
			var target = document.getElementById(el.dataset?.targetId);
			if (target) {
				var height = target.clientHeight;
				var width = target.clientWidth;
				var top = target.getBoundingClientRect().top + window.scrollY;
				var left = target.getBoundingClientRect().left;
				if (height < 50) height = 50;
				el.style.height = height + "px";
				el.style.width = width + "px";
				el.style.top = top + "px";
				el.style.left = left + "px";
			}
		}
		el?.classList.remove("d-none");
	};
	const Hide = (id) => {
		document.getElementById(id)?.classList.add("d-none");
	};
	const Ajax = (id, delayBeforeShow = 200) => {
		setTimeout(() => {
			Show(id);
		}, delayBeforeShow);
	};
	return {
		Init,
		Show,
		Hide,
		Ajax
	};
})();
document.addEventListener("DOMContentLoaded", () => {
	Waiting.Init();
});
/*!**********************!*\
!*** ./src/index.ts ***!
\**********************/
(/* @__PURE__ */ __commonJSMin(((exports, module) => {
	(function webpackUniversalModuleDefinition(root, factory) {
		if (typeof exports === "object" && typeof module === "object") module.exports = factory();
		else if (typeof define === "function" && define.amd) define([], factory);
		else if (typeof exports === "object") exports["aspnetValidation"] = factory();
		else root["aspnetValidation"] = factory();
	})(self, () => {
		return (() => {
			"use strict";
			var __webpack_require__ = {};
			(() => {
				__webpack_require__.d = (exports$1, definition) => {
					for (var key in definition) if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports$1, key)) Object.defineProperty(exports$1, key, {
						enumerable: true,
						get: definition[key]
					});
				};
			})();
			(() => {
				__webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
			})();
			(() => {
				__webpack_require__.r = (exports$2) => {
					if (typeof Symbol !== "undefined" && Symbol.toStringTag) Object.defineProperty(exports$2, Symbol.toStringTag, { value: "Module" });
					Object.defineProperty(exports$2, "__esModule", { value: true });
				};
			})();
			var __webpack_exports__ = {};
			__webpack_require__.r(__webpack_exports__);
			__webpack_require__.d(__webpack_exports__, {
				MvcValidationProviders: () => MvcValidationProviders,
				ValidationService: () => ValidationService,
				isValidatable: () => isValidatable
			});
			var __awaiter = function(thisArg, _arguments, P, generator) {
				function adopt(value) {
					return value instanceof P ? value : new P(function(resolve) {
						resolve(value);
					});
				}
				return new (P || (P = Promise))(function(resolve, reject) {
					function fulfilled(value) {
						try {
							step(generator.next(value));
						} catch (e) {
							reject(e);
						}
					}
					function rejected(value) {
						try {
							step(generator["throw"](value));
						} catch (e) {
							reject(e);
						}
					}
					function step(result) {
						result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
					}
					step((generator = generator.apply(thisArg, _arguments || [])).next());
				});
			};
			var __generator = function(thisArg, body) {
				var _ = {
					label: 0,
					sent: function() {
						if (t[0] & 1) throw t[1];
						return t[1];
					},
					trys: [],
					ops: []
				}, f, y, t, g = {
					next: verb(0),
					"throw": verb(1),
					"return": verb(2)
				};
				return typeof Symbol === "function" && (g[Symbol.iterator] = function() {
					return this;
				}), g;
				function verb(n) {
					return function(v) {
						return step([n, v]);
					};
				}
				function step(op) {
					if (f) throw new TypeError("Generator is already executing.");
					while (g && (g = 0, op[0] && (_ = 0)), _) try {
						if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
						if (y = 0, t) op = [op[0] & 2, t.value];
						switch (op[0]) {
							case 0:
							case 1:
								t = op;
								break;
							case 4:
								_.label++;
								return {
									value: op[1],
									done: false
								};
							case 5:
								_.label++;
								y = op[1];
								op = [0];
								continue;
							case 7:
								op = _.ops.pop();
								_.trys.pop();
								continue;
							default:
								if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
									_ = 0;
									continue;
								}
								if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
									_.label = op[1];
									break;
								}
								if (op[0] === 6 && _.label < t[1]) {
									_.label = t[1];
									t = op;
									break;
								}
								if (t && _.label < t[2]) {
									_.label = t[2];
									_.ops.push(op);
									break;
								}
								if (t[2]) _.ops.pop();
								_.trys.pop();
								continue;
						}
						op = body.call(thisArg, _);
					} catch (e) {
						op = [6, e];
						y = 0;
					} finally {
						f = t = 0;
					}
					if (op[0] & 5) throw op[1];
					return {
						value: op[0] ? op[1] : void 0,
						done: true
					};
				}
			};
			var nullLogger = new (function() {
				function class_1() {
					this.warn = globalThis.console.warn;
				}
				class_1.prototype.log = function(_) {
					var _args = [];
					for (var _i = 1; _i < arguments.length; _i++) _args[_i - 1] = arguments[_i];
				};
				return class_1;
			}())();
			/**
			* Checks if `element` is validatable (`input`, `select`, `textarea`).
			* @param element The element to check.
			* @returns `true` if validatable, otherwise `false`.
			*/
			var isValidatable = function(element) {
				return element instanceof HTMLInputElement || element instanceof HTMLSelectElement || element instanceof HTMLTextAreaElement;
			};
			var validatableElementTypes = [
				"input",
				"select",
				"textarea"
			];
			/**
			* Generates a selector to match validatable elements (`input`, `select`, `textarea`).
			* @param selector An optional selector to apply to the valid input types, e.g. `[data-val="true"]`.
			* @returns The validatable elements.
			*/
			var validatableSelector = function(selector) {
				return validatableElementTypes.map(function(t) {
					return "".concat(t).concat(selector || "");
				}).join(",");
			};
			/**
			* Resolves and returns the element referred by original element using ASP.NET selector logic.
			* @param element - The input to validate
			* @param selector - Used to find the field. Ex. *.Password where * replaces whatever prefixes asp.net might add.
			*/
			function getRelativeFormElement(element, selector) {
				var elementName = element.name;
				var selectedName = selector.substring(2);
				var objectName = "";
				var dotLocation = elementName.lastIndexOf(".");
				if (dotLocation > -1) {
					objectName = elementName.substring(0, dotLocation);
					var relativeElementName = objectName + "." + selectedName;
					var relativeElement = document.getElementsByName(relativeElementName)[0];
					if (isValidatable(relativeElement)) return relativeElement;
				}
				return element.form.querySelector(validatableSelector("[name=".concat(selectedName, "]")));
			}
			/**
			* Contains default implementations for ASP.NET Core MVC validation attributes.
			*/
			var MvcValidationProviders = function() {
				function MvcValidationProviders() {
					/**
					* Validates whether the input has a value.
					*/
					this.required = function(value, element, params) {
						var elementType = element.type.toLowerCase();
						if (elementType === "checkbox" || elementType === "radio") {
							var allElementsOfThisName = Array.from(element.form.querySelectorAll(validatableSelector("[name='".concat(element.name, "'][type='").concat(elementType, "']"))));
							for (var _i = 0, allElementsOfThisName_1 = allElementsOfThisName; _i < allElementsOfThisName_1.length; _i++) {
								var element_1 = allElementsOfThisName_1[_i];
								if (element_1 instanceof HTMLInputElement && element_1.checked === true) return true;
							}
							if (elementType === "checkbox") {
								var checkboxHiddenInput = element.form.querySelector("input[name='".concat(element.name, "'][type='hidden']"));
								if (checkboxHiddenInput instanceof HTMLInputElement && checkboxHiddenInput.value === "false") return true;
							}
							return false;
						}
						return Boolean(value === null || value === void 0 ? void 0 : value.trim());
					};
					/**
					* Validates whether the input value satisfies the length contstraint.
					*/
					this.stringLength = function(value, element, params) {
						if (!value) return true;
						if (params.min) {
							var min = parseInt(params.min);
							if (value.length < min) return false;
						}
						if (params.max) {
							var max = parseInt(params.max);
							if (value.length > max) return false;
						}
						return true;
					};
					/**
					* Validates whether the input value is equal to another input value.
					*/
					this.compare = function(value, element, params) {
						if (!params.other) return true;
						var otherElement = getRelativeFormElement(element, params.other);
						if (!otherElement) return true;
						return otherElement.value === value;
					};
					/**
					* Validates whether the input value is a number within a given range.
					*/
					this.range = function(value, element, params) {
						if (!value) return true;
						var val = parseFloat(value);
						if (isNaN(val)) return false;
						if (params.min) {
							if (val < parseFloat(params.min)) return false;
						}
						if (params.max) {
							if (val > parseFloat(params.max)) return false;
						}
						return true;
					};
					/**
					* Validates whether the input value satisfies a regular expression pattern.
					*/
					this.regex = function(value, element, params) {
						if (!value || !params.pattern) return true;
						return new RegExp(params.pattern).test(value);
					};
					/**
					* Validates whether the input value is an email in accordance to RFC822 specification, with a top level domain.
					*/
					this.email = function(value, element, params) {
						if (!value) return true;
						return /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*(\.\w{2,})+$/.test(value);
					};
					/**
					* Validates whether the input value is a credit card number, with Luhn's Algorithm.
					*/
					this.creditcard = function(value, element, params) {
						if (!value) return true;
						if (/[^0-9 \-]+/.test(value)) return false;
						var nCheck = 0, nDigit = 0, bEven = false, n, cDigit;
						value = value.replace(/\D/g, "");
						if (value.length < 13 || value.length > 19) return false;
						for (n = value.length - 1; n >= 0; n--) {
							cDigit = value.charAt(n);
							nDigit = parseInt(cDigit, 10);
							if (bEven) {
								if ((nDigit *= 2) > 9) nDigit -= 9;
							}
							nCheck += nDigit;
							bEven = !bEven;
						}
						return nCheck % 10 === 0;
					};
					/**
					* Validates whether the input value is a URL.
					*/
					this.url = function(value, element, params) {
						if (!value) return true;
						var lowerCaseValue = value.toLowerCase();
						return lowerCaseValue.indexOf("http://") > -1 || lowerCaseValue.indexOf("https://") > -1 || lowerCaseValue.indexOf("ftp://") > -1;
					};
					/**
					* Validates whether the input value is a phone number.
					*/
					this.phone = function(value, element, params) {
						if (!value) return true;
						if (/[\+\-\s][\-\s]/g.test(value)) return false;
						return /^\+?[0-9\-\s]+$/.test(value);
					};
					/**
					* Asynchronously validates the input value to a JSON GET API endpoint.
					*/
					this.remote = function(value, element, params) {
						if (!value) return true;
						var fieldSelectors = params.additionalfields.split(",");
						var fields = {};
						for (var _i = 0, fieldSelectors_1 = fieldSelectors; _i < fieldSelectors_1.length; _i++) {
							var fieldSelector = fieldSelectors_1[_i];
							var fieldName = fieldSelector.substr(2);
							var fieldElement = getRelativeFormElement(element, fieldSelector);
							if (!Boolean(fieldElement && fieldElement.value)) continue;
							if (fieldElement instanceof HTMLInputElement && (fieldElement.type === "checkbox" || fieldElement.type === "radio")) fields[fieldName] = fieldElement.checked ? fieldElement.value : "";
							else fields[fieldName] = fieldElement.value;
						}
						var url = params["url"];
						var encodedParams = [];
						for (var fieldName in fields) {
							var encodedParam = encodeURIComponent(fieldName) + "=" + encodeURIComponent(fields[fieldName]);
							encodedParams.push(encodedParam);
						}
						var payload = encodedParams.join("&");
						return new Promise(function(ok, reject) {
							var request = new XMLHttpRequest();
							if (params.type && params.type.toLowerCase() === "post") {
								var postData = new FormData();
								for (var fieldName in fields) postData.append(fieldName, fields[fieldName]);
								request.open("post", url);
								request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
								request.send(payload);
							} else {
								request.open("get", url + "?" + payload);
								request.send();
							}
							request.onload = function(e) {
								if (request.status >= 200 && request.status < 300) ok(JSON.parse(request.responseText));
								else reject({
									status: request.status,
									statusText: request.statusText,
									data: request.responseText
								});
							};
							request.onerror = function(e) {
								reject({
									status: request.status,
									statusText: request.statusText,
									data: request.responseText
								});
							};
						});
					};
				}
				return MvcValidationProviders;
			}();
			/**
			* Responsible for managing the DOM elements and running the validation providers.
			*/
			var ValidationService = function() {
				function ValidationService(logger) {
					var _this = this;
					/**
					* A key-value collection of loaded validation plugins.
					*/
					this.providers = {};
					/**
					* A key-value collection of form UIDs and their <span> elements for displaying validation messages for an input (by DOM name).
					*/
					this.messageFor = {};
					/**
					* A list of managed elements, each having a randomly assigned unique identifier (UID).
					*/
					this.elementUIDs = [];
					/**
					* A key-value collection of UID to Element for quick lookup.
					*/
					this.elementByUID = {};
					/**
					* A key-value collection of input UIDs for a <form> UID.
					*/
					this.formInputs = {};
					/**
					* A key-value map for input UID to its validator factory.
					*/
					this.validators = {};
					/**
					* A key-value map for form UID to its trigger element (submit event for <form>).
					*/
					this.formEvents = {};
					/**
					* A key-value map for element UID to its trigger element (input event for <textarea> and <input>, change event for <select>).
					*/
					this.inputEvents = {};
					/**
					* A key-value map of input UID to its validation error message.
					*/
					this.summary = {};
					/**
					* In milliseconds, the rate of fire of the input validation.
					*/
					this.debounce = 300;
					/**
					* Allow hidden fields validation
					*/
					this.allowHiddenFields = false;
					/**
					* Fires off validation for elements within the provided form and then calls the callback
					* @param form The form to validate.
					* @param callback Receives true or false indicating validity after all validation is complete.
					* @returns Promise that resolves to true or false indicating validity after all validation is complete.
					*/
					this.validateForm = function(form, callback) {
						return __awaiter(_this, void 0, void 0, function() {
							var formUID, formValidationEvent, _a;
							return __generator(this, function(_b) {
								switch (_b.label) {
									case 0:
										if (!(form instanceof HTMLFormElement)) throw new Error("validateForm() can only be called on <form> elements");
										formUID = this.getElementUID(form);
										formValidationEvent = this.formEvents[formUID];
										_a = !formValidationEvent;
										if (_a) return [3, 2];
										return [4, formValidationEvent(void 0, callback)];
									case 1:
										_a = _b.sent();
										_b.label = 2;
									case 2: return [2, _a];
								}
							});
						});
					};
					/**
					* Fires off validation for the provided element and then calls the callback
					* @param field The element to validate.
					* @param callback Receives true or false indicating validity after all validation is complete.
					* @returns Promise that resolves to true or false indicating validity after all validation is complete
					*/
					this.validateField = function(field, callback) {
						return __awaiter(_this, void 0, void 0, function() {
							var fieldUID, fieldValidationEvent, _a;
							return __generator(this, function(_b) {
								switch (_b.label) {
									case 0:
										fieldUID = this.getElementUID(field);
										fieldValidationEvent = this.inputEvents[fieldUID];
										_a = !fieldValidationEvent;
										if (_a) return [3, 2];
										return [4, fieldValidationEvent(void 0, callback)];
									case 1:
										_a = _b.sent();
										_b.label = 2;
									case 2: return [2, _a];
								}
							});
						});
					};
					/**
					* Called before validating form submit events.
					* Default calls `preventDefault()` and `stopImmediatePropagation()`.
					* @param submitEvent The `SubmitEvent`.
					*/
					this.preValidate = function(submitEvent) {
						submitEvent.preventDefault();
						submitEvent.stopImmediatePropagation();
					};
					/**
					* Handler for validated form submit events.
					* Default calls `submitValidForm(form, submitEvent)` on success
					* and `focusFirstInvalid(form)` on failure.
					* @param form The form that has been validated.
					* @param success The validation result.
					* @param submitEvent The `SubmitEvent`.
					*/
					this.handleValidated = function(form, success, submitEvent) {
						if (!(form instanceof HTMLFormElement)) throw new Error("handleValidated() can only be called on <form> elements");
						if (success) {
							if (submitEvent) _this.submitValidForm(form, submitEvent);
						} else _this.focusFirstInvalid(form);
					};
					/**
					* Dispatches a new `SubmitEvent` on the provided form,
					* then calls `form.submit()` unless `submitEvent` is cancelable
					* and `preventDefault()` was called by a handler that received the new event.
					*
					* This is equivalent to `form.requestSubmit()`, but more flexible.
					* @param form The validated form to submit
					* @param submitEvent The `SubmitEvent`.
					*/
					this.submitValidForm = function(form, submitEvent) {
						if (!(form instanceof HTMLFormElement)) throw new Error("submitValidForm() can only be called on <form> elements");
						var newEvent = new SubmitEvent("submit", submitEvent);
						if (form.dispatchEvent(newEvent)) {
							var submitter = submitEvent.submitter;
							var submitterInput = null;
							var initialFormAction = form.action;
							if (submitter) {
								var name_1 = submitter.getAttribute("name");
								if (name_1) {
									submitterInput = document.createElement("input");
									submitterInput.type = "hidden";
									submitterInput.name = name_1;
									submitterInput.value = submitter.getAttribute("value");
									form.appendChild(submitterInput);
								}
								var formAction = submitter.getAttribute("formaction");
								if (formAction) form.action = formAction;
							}
							try {
								form.submit();
							} finally {
								if (submitterInput) form.removeChild(submitterInput);
								form.action = initialFormAction;
							}
						}
					};
					/**
					* Focuses the first invalid element within the provided form
					* @param form
					*/
					this.focusFirstInvalid = function(form) {
						if (!(form instanceof HTMLFormElement)) throw new Error("focusFirstInvalid() can only be called on <form> elements");
						var formUID = _this.getElementUID(form);
						var formInputUIDs = _this.formInputs[formUID];
						var invalidFormInputUID = formInputUIDs === null || formInputUIDs === void 0 ? void 0 : formInputUIDs.find(function(uid) {
							return _this.summary[uid];
						});
						if (invalidFormInputUID) {
							var firstInvalid = _this.elementByUID[invalidFormInputUID];
							if (firstInvalid instanceof HTMLElement) firstInvalid.focus();
						}
					};
					/**
					* Returns true if the provided form is currently valid.
					* The form will be validated unless prevalidate is set to false.
					* @param form The form to validate.
					* @param prevalidate Whether the form should be validated before returning.
					* @param callback A callback that receives true or false indicating validity after all validation is complete. Ignored if prevalidate is false.
					* @returns The current state of the form. May be inaccurate if any validation is asynchronous (e.g. remote); consider using `callback` instead.
					*/
					this.isValid = function(form, prevalidate, callback) {
						if (prevalidate === void 0) prevalidate = true;
						if (!(form instanceof HTMLFormElement)) throw new Error("isValid() can only be called on <form> elements");
						if (prevalidate) _this.validateForm(form, callback);
						var formUID = _this.getElementUID(form);
						var formInputUIDs = _this.formInputs[formUID];
						return !((formInputUIDs === null || formInputUIDs === void 0 ? void 0 : formInputUIDs.some(function(uid) {
							return _this.summary[uid];
						})) === true);
					};
					/**
					* Returns true if the provided field is currently valid.
					* The field will be validated unless prevalidate is set to false.
					* @param field The field to validate.
					* @param prevalidate Whether the field should be validated before returning.
					* @param callback A callback that receives true or false indicating validity after all validation is complete. Ignored if prevalidate is false.
					* @returns The current state of the field. May be inaccurate if any validation is asynchronous (e.g. remote); consider using `callback` instead.
					*/
					this.isFieldValid = function(field, prevalidate, callback) {
						if (prevalidate === void 0) prevalidate = true;
						if (prevalidate) _this.validateField(field, callback);
						var fieldUID = _this.getElementUID(field);
						return _this.summary[fieldUID] === void 0;
					};
					/**
					* Options for this instance of @type {ValidationService}.
					*/
					this.options = {
						root: document.body,
						watch: false,
						addNoValidate: true
					};
					/**
					* Override CSS class name for input validation error. Default: 'input-validation-error'
					*/
					this.ValidationInputCssClassName = "input-validation-error";
					/**
					* Override CSS class name for valid input validation. Default: 'input-validation-valid'
					*/
					this.ValidationInputValidCssClassName = "input-validation-valid";
					/**
					* Override CSS class name for field validation error. Default: 'field-validation-error'
					*/
					this.ValidationMessageCssClassName = "field-validation-error";
					/**
					* Override CSS class name for valid field validation. Default: 'field-validation-valid'
					*/
					this.ValidationMessageValidCssClassName = "field-validation-valid";
					/**
					* Override CSS class name for validation summary error. Default: 'validation-summary-errors'
					*/
					this.ValidationSummaryCssClassName = "validation-summary-errors";
					/**
					* Override CSS class name for valid validation summary. Default: 'validation-summary-valid'
					*/
					this.ValidationSummaryValidCssClassName = "validation-summary-valid";
					this.logger = logger || nullLogger;
				}
				/**
				* Registers a new validation plugin of the given name, if not registered yet.
				* Registered plugin validates inputs with data-val-[name] attribute, used as error message.
				* @param name
				* @param callback
				*/
				ValidationService.prototype.addProvider = function(name, callback) {
					if (this.providers[name]) return;
					this.logger.log("Registered provider: %s", name);
					this.providers[name] = callback;
				};
				/**
				* Registers the default providers for enabling ASP.NET Core MVC client-side validation.
				*/
				ValidationService.prototype.addMvcProviders = function() {
					var mvc = new MvcValidationProviders();
					this.addProvider("required", mvc.required);
					this.addProvider("length", mvc.stringLength);
					this.addProvider("maxlength", mvc.stringLength);
					this.addProvider("minlength", mvc.stringLength);
					this.addProvider("equalto", mvc.compare);
					this.addProvider("range", mvc.range);
					this.addProvider("regex", mvc.regex);
					this.addProvider("creditcard", mvc.creditcard);
					this.addProvider("email", mvc.email);
					this.addProvider("url", mvc.url);
					this.addProvider("phone", mvc.phone);
					this.addProvider("remote", mvc.remote);
				};
				/**
				* Scans `root` for all validation message <span> generated by ASP.NET Core MVC, then calls `cb` for each.
				* @param root The root node to scan
				* @param cb The callback to invoke with each form and span
				*/
				ValidationService.prototype.scanMessages = function(root, cb) {
					var validationMessageElements = Array.from(root.querySelectorAll("span[form]"));
					for (var _i = 0, validationMessageElements_1 = validationMessageElements; _i < validationMessageElements_1.length; _i++) {
						var span = validationMessageElements_1[_i];
						var form = document.getElementById(span.getAttribute("form"));
						if (form instanceof HTMLFormElement) cb.call(this, form, span);
					}
					var forms = Array.from(root.querySelectorAll("form"));
					if (root instanceof HTMLFormElement) forms.push(root);
					var containingForm = root instanceof Element ? root.closest("form") : null;
					if (containingForm) forms.push(containingForm);
					for (var _a = 0, forms_1 = forms; _a < forms_1.length; _a++) {
						var form = forms_1[_a];
						var validationMessageElements_3 = Array.from(form.querySelectorAll("[data-valmsg-for]"));
						for (var _b = 0, validationMessageElements_2 = validationMessageElements_3; _b < validationMessageElements_2.length; _b++) {
							var span = validationMessageElements_2[_b];
							cb.call(this, form, span);
						}
					}
				};
				ValidationService.prototype.pushValidationMessageSpan = function(form, span) {
					var _a, _b;
					var _c;
					var formId = this.getElementUID(form);
					var formSpans = (_a = (_c = this.messageFor)[formId]) !== null && _a !== void 0 ? _a : _c[formId] = {};
					var messageForId = span.getAttribute("data-valmsg-for");
					if (!messageForId) return;
					var spans = (_b = formSpans[messageForId]) !== null && _b !== void 0 ? _b : formSpans[messageForId] = [];
					if (spans.indexOf(span) < 0) spans.push(span);
					else this.logger.log("Validation element for '%s' is already tracked", name, span);
				};
				ValidationService.prototype.removeValidationMessageSpan = function(form, span) {
					var formId = this.getElementUID(form);
					var formSpans = this.messageFor[formId];
					if (!formSpans) return;
					var messageForId = span.getAttribute("data-valmsg-for");
					if (!messageForId) return;
					var spans = formSpans[messageForId];
					if (!spans) return;
					var index = spans.indexOf(span);
					if (index >= 0) spans.splice(index, 1);
					else this.logger.log("Validation element for '%s' was already removed", name, span);
				};
				/**
				* Given attribute map for an HTML input, returns the validation directives to be executed.
				* @param attributes
				*/
				ValidationService.prototype.parseDirectives = function(attributes) {
					var directives = {};
					var validationAtributes = {};
					var cut = 9;
					for (var i = 0; i < attributes.length; i++) {
						var a = attributes[i];
						if (a.name.indexOf("data-val-") === 0) {
							var key = a.name.substr(cut);
							validationAtributes[key] = a.value;
						}
					}
					var _loop_1 = function(key) {
						if (key.indexOf("-") === -1) {
							var parameters = Object.keys(validationAtributes).filter(function(Q) {
								return Q !== key && Q.indexOf(key) === 0;
							});
							var directive = {
								error: validationAtributes[key],
								params: {}
							};
							var pcut = (key + "-").length;
							for (var i = 0; i < parameters.length; i++) {
								var pvalue = validationAtributes[parameters[i]];
								var pkey = parameters[i].substr(pcut);
								directive.params[pkey] = pvalue;
							}
							directives[key] = directive;
						}
					};
					for (var key in validationAtributes) _loop_1(key);
					return directives;
				};
				/**
				*  Returns an RFC4122 version 4 compliant GUID.
				*/
				ValidationService.prototype.guid4 = function() {
					return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
						var r = Math.random() * 16 | 0;
						return (c == "x" ? r : r & 3 | 8).toString(16);
					});
				};
				/**
				* Gets a UID for an DOM element.
				* @param node
				*/
				ValidationService.prototype.getElementUID = function(node) {
					var x = this.elementUIDs.filter(function(e) {
						return e.node === node;
					})[0];
					if (x) return x.uid;
					var uid = this.guid4();
					this.elementUIDs.push({
						node,
						uid
					});
					this.elementByUID[uid] = node;
					return uid;
				};
				/**
				* Returns a Promise that returns validation result for each and every inputs within the form.
				* @param formUID
				*/
				ValidationService.prototype.getFormValidationTask = function(formUID) {
					var formInputUIDs = this.formInputs[formUID];
					if (!formInputUIDs || formInputUIDs.length === 0) return Promise.resolve(true);
					var formValidators = [];
					for (var _i = 0, formInputUIDs_1 = formInputUIDs; _i < formInputUIDs_1.length; _i++) {
						var inputUID = formInputUIDs_1[_i];
						var validator = this.validators[inputUID];
						if (validator) formValidators.push(validator);
					}
					var tasks = formValidators.map(function(factory) {
						return factory();
					});
					return Promise.all(tasks).then(function(result) {
						return result.every(function(e) {
							return e;
						});
					});
				};
				ValidationService.prototype.getMessageFor = function(input) {
					var _a;
					if (!input.form) return;
					var formId = this.getElementUID(input.form);
					return (_a = this.messageFor[formId]) === null || _a === void 0 ? void 0 : _a[input.name];
				};
				/**
				* Returns true if the event triggering the form submission indicates we should validate the form.
				* @param e
				*/
				ValidationService.prototype.shouldValidate = function(e) {
					return !(e && e["submitter"] && e["submitter"]["formNoValidate"]);
				};
				/**
				* Tracks a <form> element as parent of an input UID. When the form is submitted, attempts to validate the said input asynchronously.
				* @param form
				* @param inputUID
				*/
				ValidationService.prototype.trackFormInput = function(form, inputUID) {
					var _this = this;
					var _a;
					var _b;
					var formUID = this.getElementUID(form);
					var formInputUIDs = (_a = (_b = this.formInputs)[formUID]) !== null && _a !== void 0 ? _a : _b[formUID] = [];
					if (formInputUIDs.indexOf(inputUID) === -1) {
						formInputUIDs.push(inputUID);
						if (this.options.addNoValidate) {
							this.logger.log("Setting novalidate on form", form);
							form.setAttribute("novalidate", "novalidate");
						} else this.logger.log("Not setting novalidate on form", form);
					} else this.logger.log("Form input for UID '%s' is already tracked", inputUID);
					if (this.formEvents[formUID]) return;
					var validationTask = null;
					var cb = function(e, callback) {
						if (validationTask) return validationTask;
						if (!_this.shouldValidate(e)) return Promise.resolve(true);
						validationTask = _this.getFormValidationTask(formUID);
						if (e) _this.preValidate(e);
						_this.logger.log("Validating", form);
						return validationTask.then(function(success) {
							return __awaiter(_this, void 0, void 0, function() {
								var validationEvent;
								return __generator(this, function(_a) {
									switch (_a.label) {
										case 0:
											this.logger.log("Validated (success = %s)", success, form);
											if (callback) {
												callback(success);
												return [2, success];
											}
											validationEvent = new CustomEvent("validation", { detail: { valid: success } });
											form.dispatchEvent(validationEvent);
											return [4, new Promise(function(resolve) {
												return setTimeout(resolve, 0);
											})];
										case 1:
											_a.sent();
											this.handleValidated(form, success, e);
											return [2, success];
									}
								});
							});
						}).catch(function(error) {
							_this.logger.log("Validation error", error);
							return false;
						}).finally(function() {
							validationTask = null;
						});
					};
					form.addEventListener("submit", cb);
					var cbReset = function(e) {
						var formInputUIDs = _this.formInputs[formUID];
						for (var _i = 0, formInputUIDs_2 = formInputUIDs; _i < formInputUIDs_2.length; _i++) {
							var inputUID_1 = formInputUIDs_2[_i];
							_this.resetField(inputUID_1);
						}
						_this.renderSummary();
					};
					form.addEventListener("reset", cbReset);
					cb.remove = function() {
						form.removeEventListener("submit", cb);
						form.removeEventListener("reset", cbReset);
					};
					this.formEvents[formUID] = cb;
				};
				ValidationService.prototype.reset = function(input) {
					if (this.isDisabled(input)) this.resetField(this.getElementUID(input));
					else this.scan(input);
				};
				ValidationService.prototype.resetField = function(inputUID) {
					var input = this.elementByUID[inputUID];
					this.swapClasses(input, "", this.ValidationInputCssClassName);
					this.swapClasses(input, "", this.ValidationInputValidCssClassName);
					var spans = isValidatable(input) && this.getMessageFor(input);
					if (spans) for (var i = 0; i < spans.length; i++) {
						spans[i].innerHTML = "";
						this.swapClasses(spans[i], "", this.ValidationMessageCssClassName);
						this.swapClasses(spans[i], "", this.ValidationMessageValidCssClassName);
					}
					delete this.summary[inputUID];
				};
				ValidationService.prototype.untrackFormInput = function(form, inputUID) {
					var _a;
					var formUID = this.getElementUID(form);
					var formInputUIDs = this.formInputs[formUID];
					if (!formInputUIDs) return;
					var indexToRemove = formInputUIDs.indexOf(inputUID);
					if (indexToRemove >= 0) {
						formInputUIDs.splice(indexToRemove, 1);
						if (!formInputUIDs.length) {
							(_a = this.formEvents[formUID]) === null || _a === void 0 || _a.remove();
							delete this.formEvents[formUID];
							delete this.formInputs[formUID];
							delete this.messageFor[formUID];
						}
					} else this.logger.log("Form input for UID '%s' was already removed", inputUID);
				};
				/**
				* Adds an input element to be managed and validated by the service.
				* Triggers a debounced live validation when input value changes.
				* @param input
				*/
				ValidationService.prototype.addInput = function(input) {
					var _this = this;
					var _a;
					var uid = this.getElementUID(input);
					var directives = this.parseDirectives(input.attributes);
					this.validators[uid] = this.createValidator(input, directives);
					if (input.form) this.trackFormInput(input.form, uid);
					if (this.inputEvents[uid]) return;
					var cb = function(event, callback) {
						return __awaiter(_this, void 0, void 0, function() {
							var validate, success, error_1;
							return __generator(this, function(_a) {
								switch (_a.label) {
									case 0:
										validate = this.validators[uid];
										if (!validate) return [2, true];
										if (!input.dataset.valEvent && event && event.type === "input" && !input.classList.contains(this.ValidationInputCssClassName)) return [2, true];
										this.logger.log("Validating", { event });
										_a.label = 1;
									case 1:
										_a.trys.push([
											1,
											3,
											,
											4
										]);
										return [4, validate()];
									case 2:
										success = _a.sent();
										callback(success);
										return [2, success];
									case 3:
										error_1 = _a.sent();
										this.logger.log("Validation error", error_1);
										return [2, false];
									case 4: return [2];
								}
							});
						});
					};
					var debounceTimeoutID = null;
					cb.debounced = function(event, callback) {
						if (debounceTimeoutID !== null) clearTimeout(debounceTimeoutID);
						debounceTimeoutID = setTimeout(function() {
							cb(event, callback);
						}, _this.debounce);
					};
					var defaultEvent = input instanceof HTMLSelectElement ? "change" : "input change";
					var events = ((_a = input.dataset.valEvent) !== null && _a !== void 0 ? _a : defaultEvent).split(" ");
					events.forEach(function(eventName) {
						input.addEventListener(eventName, cb.debounced);
					});
					cb.remove = function() {
						events.forEach(function(eventName) {
							input.removeEventListener(eventName, cb.debounced);
						});
					};
					this.inputEvents[uid] = cb;
				};
				ValidationService.prototype.removeInput = function(input) {
					var uid = this.getElementUID(input);
					var cb = this.inputEvents[uid];
					if (cb === null || cb === void 0 ? void 0 : cb.remove) {
						cb.remove();
						delete cb.remove;
					}
					delete this.summary[uid];
					delete this.inputEvents[uid];
					delete this.validators[uid];
					if (input.form) this.untrackFormInput(input.form, uid);
				};
				/**
				* Scans `root` for input elements to be validated, then calls `cb` for each.
				* @param root The root node to scan
				* @param cb The callback to invoke with each input
				*/
				ValidationService.prototype.scanInputs = function(root, cb) {
					var inputs = Array.from(root.querySelectorAll(validatableSelector("[data-val=\"true\"]")));
					if (isValidatable(root) && root.getAttribute("data-val") === "true") inputs.push(root);
					for (var i = 0; i < inputs.length; i++) {
						var input = inputs[i];
						cb.call(this, input);
					}
				};
				/**
				* Returns a <ul> element as a validation errors summary.
				*/
				ValidationService.prototype.createSummaryDOM = function() {
					if (!Object.keys(this.summary).length) return null;
					var renderedMessages = [];
					var ul = document.createElement("ul");
					for (var key in this.summary) {
						var matchingElement = this.elementByUID[key];
						if (matchingElement instanceof HTMLInputElement) {
							if (matchingElement.type === "checkbox" || matchingElement.type === "radio") {
								if (matchingElement.className === this.ValidationInputValidCssClassName) continue;
							}
						}
						if (renderedMessages.indexOf(this.summary[key]) > -1) continue;
						var li = document.createElement("li");
						li.innerHTML = this.summary[key];
						ul.appendChild(li);
						renderedMessages.push(this.summary[key]);
					}
					return ul;
				};
				/**
				* Displays validation summary to ASP.NET Core MVC designated elements, when it actually gets updated.
				*/
				ValidationService.prototype.renderSummary = function() {
					var summaryElements = document.querySelectorAll("[data-valmsg-summary=\"true\"]");
					if (!summaryElements.length) return;
					var shadow = JSON.stringify(this.summary, Object.keys(this.summary).sort());
					if (shadow === this.renderedSummaryJSON) return;
					this.renderedSummaryJSON = shadow;
					var ul = this.createSummaryDOM();
					for (var i = 0; i < summaryElements.length; i++) {
						var e = summaryElements[i];
						var listElements = e.querySelectorAll("ul");
						for (var j = 0; j < listElements.length; j++) listElements[j].remove();
						if (ul && ul.hasChildNodes()) {
							this.swapClasses(e, this.ValidationSummaryCssClassName, this.ValidationSummaryValidCssClassName);
							e.appendChild(ul.cloneNode(true));
						} else this.swapClasses(e, this.ValidationSummaryValidCssClassName, this.ValidationSummaryCssClassName);
					}
				};
				/**
				* Adds an error message to an input element, which also updates the validation message elements and validation summary elements.
				* @param input
				* @param message
				*/
				ValidationService.prototype.addError = function(input, message) {
					var spans = this.getMessageFor(input);
					if (spans) for (var i = 0; i < spans.length; i++) {
						spans[i];
						spans[i].innerHTML = message;
						this.swapClasses(spans[i], this.ValidationMessageCssClassName, this.ValidationMessageValidCssClassName);
					}
					this.highlight(input, this.ValidationInputCssClassName, this.ValidationInputValidCssClassName);
					if (input.form) {
						var inputs = input.form.querySelectorAll(validatableSelector("[name=\"".concat(input.name, "\"]")));
						for (var i = 0; i < inputs.length; i++) {
							this.swapClasses(inputs[i], this.ValidationInputCssClassName, this.ValidationInputValidCssClassName);
							var uid = this.getElementUID(inputs[i]);
							this.summary[uid] = message;
						}
					}
					this.renderSummary();
				};
				/**
				* Removes an error message from an input element, which also updates the validation message elements and validation summary elements.
				* @param input
				*/
				ValidationService.prototype.removeError = function(input) {
					var spans = this.getMessageFor(input);
					if (spans) for (var i = 0; i < spans.length; i++) {
						spans[i].innerHTML = "";
						this.swapClasses(spans[i], this.ValidationMessageValidCssClassName, this.ValidationMessageCssClassName);
					}
					this.unhighlight(input, this.ValidationInputCssClassName, this.ValidationInputValidCssClassName);
					if (input.form) {
						var inputs = input.form.querySelectorAll(validatableSelector("[name=\"".concat(input.name, "\"]")));
						for (var i = 0; i < inputs.length; i++) {
							this.swapClasses(inputs[i], this.ValidationInputValidCssClassName, this.ValidationInputCssClassName);
							var uid = this.getElementUID(inputs[i]);
							delete this.summary[uid];
						}
					}
					this.renderSummary();
				};
				/**
				* Returns a validation Promise factory for an input element, using given validation directives.
				* @param input
				* @param directives
				*/
				ValidationService.prototype.createValidator = function(input, directives) {
					var _this = this;
					return function() {
						return __awaiter(_this, void 0, void 0, function() {
							var _a, _b, _c, _i, key, directive, provider, result, valid, error, resolution;
							return __generator(this, function(_d) {
								switch (_d.label) {
									case 0:
										if (!(!this.isHidden(input) && !this.isDisabled(input))) return [3, 7];
										_a = directives;
										_b = [];
										for (_c in _a) _b.push(_c);
										_i = 0;
										_d.label = 1;
									case 1:
										if (!(_i < _b.length)) return [3, 7];
										_c = _b[_i];
										if (!(_c in _a)) return [3, 6];
										key = _c;
										directive = directives[key];
										provider = this.providers[key];
										if (!provider) {
											this.logger.log("aspnet-validation provider not implemented: %s", key);
											return [3, 6];
										}
										this.logger.log("Running %s validator on element", key, input);
										result = provider(input.value, input, directive.params);
										valid = false;
										error = directive.error;
										if (!(typeof result === "boolean")) return [3, 2];
										valid = result;
										return [3, 5];
									case 2:
										if (!(typeof result === "string")) return [3, 3];
										valid = false;
										error = result;
										return [3, 5];
									case 3: return [4, result];
									case 4:
										resolution = _d.sent();
										if (typeof resolution === "boolean") valid = resolution;
										else {
											valid = false;
											error = resolution;
										}
										_d.label = 5;
									case 5:
										if (!valid) {
											this.addError(input, error);
											return [2, false];
										}
										_d.label = 6;
									case 6:
										_i++;
										return [3, 1];
									case 7:
										this.removeError(input);
										return [2, true];
								}
							});
						});
					};
				};
				/**
				* Checks if the provided input is hidden from the browser
				* @param input
				* @returns
				*/
				ValidationService.prototype.isHidden = function(input) {
					return !(this.allowHiddenFields || input.offsetWidth || input.offsetHeight || input.getClientRects().length);
				};
				/**
				* Checks if the provided input is disabled
				* @param input
				* @returns
				*/
				ValidationService.prototype.isDisabled = function(input) {
					return input.disabled;
				};
				/**
				* Adds addClass and removes removeClass
				* @param element Element to modify
				* @param addClass Class to add
				* @param removeClass Class to remove
				*/
				ValidationService.prototype.swapClasses = function(element, addClass, removeClass) {
					if (addClass && !this.isDisabled(element) && !element.classList.contains(addClass)) element.classList.add(addClass);
					if (element.classList.contains(removeClass)) element.classList.remove(removeClass);
				};
				/**
				* Load default validation providers and scans the entire document when ready.
				* @param options.watch If set to true, a MutationObserver will be used to continuously watch for new elements that provide validation directives.
				* @param options.addNoValidate If set to true (the default), a novalidate attribute will be added to the containing form in validate elements.
				*/
				ValidationService.prototype.bootstrap = function(options) {
					var _this = this;
					Object.assign(this.options, options);
					this.addMvcProviders();
					var document = window.document;
					var root = this.options.root;
					var init = function() {
						_this.scan(root);
						if (_this.options.watch) _this.watch(root);
					};
					if (document.readyState === "complete" || document.readyState === "interactive") init();
					else document.addEventListener("DOMContentLoaded", init);
				};
				/**
				* Scans the root element for any validation directives and attaches behavior to them.
				* @param root The root node to scan; if not provided, `options.root` (default: `document.body`) will be scanned
				*/
				ValidationService.prototype.scan = function(root) {
					root !== null && root !== void 0 || (root = this.options.root);
					this.logger.log("Scanning", root);
					this.scanMessages(root, this.pushValidationMessageSpan);
					this.scanInputs(root, this.addInput);
				};
				/**
				* Scans the root element for any validation directives and removes behavior from them.
				* @param root The root node to scan; if not provided, `options.root` (default: `document.body`) will be scanned
				*/
				ValidationService.prototype.remove = function(root) {
					root !== null && root !== void 0 || (root = this.options.root);
					this.logger.log("Removing", root);
					this.scanMessages(root, this.removeValidationMessageSpan);
					this.scanInputs(root, this.removeInput);
				};
				/**
				* Watches the provided root element for mutations, and scans for new validation directives to attach behavior.
				* @param root The root node to watch; if not provided, `options.root` (default: `document.body`) will be watched
				*/
				ValidationService.prototype.watch = function(root) {
					var _this = this;
					root !== null && root !== void 0 || (root = this.options.root);
					this.observer = new MutationObserver(function(mutations) {
						mutations.forEach(function(mutation) {
							_this.observed(mutation);
						});
					});
					this.observer.observe(root, {
						attributes: true,
						childList: true,
						subtree: true
					});
					this.logger.log("Watching for mutations");
				};
				ValidationService.prototype.observed = function(mutation) {
					var _a, _b, _c;
					if (mutation.type === "childList") {
						for (var i = 0; i < mutation.addedNodes.length; i++) {
							var node = mutation.addedNodes[i];
							this.logger.log("Added node", node);
							if (node instanceof HTMLElement) this.scan(node);
						}
						for (var i = 0; i < mutation.removedNodes.length; i++) {
							var node = mutation.removedNodes[i];
							this.logger.log("Removed node", node);
							if (node instanceof HTMLElement) this.remove(node);
						}
					} else if (mutation.type === "attributes") {
						if (mutation.target instanceof HTMLElement) {
							if (mutation.attributeName === "disabled") {
								var target = mutation.target;
								this.reset(target);
							} else {
								var oldValue = (_a = mutation.oldValue) !== null && _a !== void 0 ? _a : "";
								var newValue = (_c = (_b = mutation.target.attributes[mutation.attributeName]) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : "";
								this.logger.log("Attribute '%s' changed from '%s' to '%s'", mutation.attributeName, oldValue, newValue, mutation.target);
								if (oldValue !== newValue) this.scan(mutation.target);
							}
						}
					}
				};
				/**
				* Highlights invalid element by adding errorClass CSS class and removing validClass CSS class
				* @param input Element to modify
				* @param errorClass Class to add
				* @param validClass Class to remove
				*/
				ValidationService.prototype.highlight = function(input, errorClass, validClass) {
					this.swapClasses(input, errorClass, validClass);
				};
				/**
				* Unhighlight valid element by removing errorClass CSS class and adding validClass CSS class
				* @param input Element to modify
				* @param errorClass Class to remove
				* @param validClass Class to add
				*/
				ValidationService.prototype.unhighlight = function(input, errorClass, validClass) {
					this.swapClasses(input, validClass, errorClass);
				};
				return ValidationService;
			}();
			return __webpack_exports__;
		})();
	});
})))();
//#endregion
export { Ajax, Alert, Attachment, AutoCompleter, Canvas, DateTimePicker, DelayAsync, Field, Filter, Form, Hide, IndexedDb, IsHidden, PageReturn, PartialDate, PasswordStrength, Queue, ReadMore, Required, ShareItGrid, Show, SiIndexedDb, SiIndexedDbMain, SwitchGridFilter, Timezone, Toggle, Val, ValId, Waiting, siIndexedDb };

//# sourceMappingURL=index.es.js.map